// This client was generated by Platformatic from an OpenAPI specification.

import type { Api } from './api-types'
import type * as Types from './api-types'

// The base URL for the API. This can be overridden by calling `setBaseUrl`.
let baseUrl = ''
// The default headers to send within each request. This can be overridden by calling `setDefaultHeaders`.
let defaultHeaders = {}

function sanitizeUrl(url: string) : string {
  if (url.endsWith('/')) { return url.slice(0, -1) } else { return url }
}
export const setBaseUrl = (newUrl: string) : void => { baseUrl = sanitizeUrl(newUrl) }

export const setDefaultHeaders = (headers: Object): void => { defaultHeaders = headers }

type JSON = Record<string, unknown>
/* @ts-ignore */
function headersToJSON(headers: Headers): JSON {
  const output: JSON = {}
  headers.forEach((value, key) => {
    output[key] = value
  })
  return output
}

const _postV1ChartOfAccount = async (url: string, request: Types.PostV1ChartOfAccountRequest): Promise<Types.PostV1ChartOfAccountResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/chart-of-account/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ChartOfAccount: Api['postV1ChartOfAccount'] = async (request: Types.PostV1ChartOfAccountRequest): Promise<Types.PostV1ChartOfAccountResponses> => {
  return await _postV1ChartOfAccount(baseUrl, request)
}
const _getV1ChartOfAccount = async (url: string, request: Types.GetV1ChartOfAccountRequest): Promise<Types.GetV1ChartOfAccountResponses> => {
  const queryParameters: (keyof Types.GetV1ChartOfAccountRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/chart-of-account/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ChartOfAccount: Api['getV1ChartOfAccount'] = async (request: Types.GetV1ChartOfAccountRequest): Promise<Types.GetV1ChartOfAccountResponses> => {
  return await _getV1ChartOfAccount(baseUrl, request)
}
const _postV1ChartOfAccountImport = async (url: string, request: Types.PostV1ChartOfAccountImportRequest): Promise<Types.PostV1ChartOfAccountImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }

  const response = await fetch(`${url}/v1/chart-of-account/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ChartOfAccountImport: Api['postV1ChartOfAccountImport'] = async (request: Types.PostV1ChartOfAccountImportRequest): Promise<Types.PostV1ChartOfAccountImportResponses> => {
  return await _postV1ChartOfAccountImport(baseUrl, request)
}
const _getV1ChartOfAccountAccountTypeDetail = async (url: string, request: Types.GetV1ChartOfAccountAccountTypeDetailRequest): Promise<Types.GetV1ChartOfAccountAccountTypeDetailResponses> => {
  const queryParameters: (keyof Types.GetV1ChartOfAccountAccountTypeDetailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/chart-of-account/account-type/detail?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ChartOfAccountAccountTypeDetail: Api['getV1ChartOfAccountAccountTypeDetail'] = async (request: Types.GetV1ChartOfAccountAccountTypeDetailRequest): Promise<Types.GetV1ChartOfAccountAccountTypeDetailResponses> => {
  return await _getV1ChartOfAccountAccountTypeDetail(baseUrl, request)
}
const _getV1ChartOfAccountId = async (url: string, request: Types.GetV1ChartOfAccountIdRequest): Promise<Types.GetV1ChartOfAccountIdResponses> => {
  const queryParameters: (keyof Types.GetV1ChartOfAccountIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/chart-of-account/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ChartOfAccountId: Api['getV1ChartOfAccountId'] = async (request: Types.GetV1ChartOfAccountIdRequest): Promise<Types.GetV1ChartOfAccountIdResponses> => {
  return await _getV1ChartOfAccountId(baseUrl, request)
}
const _putV1ChartOfAccountId = async (url: string, request: Types.PutV1ChartOfAccountIdRequest): Promise<Types.PutV1ChartOfAccountIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/chart-of-account/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ChartOfAccountId: Api['putV1ChartOfAccountId'] = async (request: Types.PutV1ChartOfAccountIdRequest): Promise<Types.PutV1ChartOfAccountIdResponses> => {
  return await _putV1ChartOfAccountId(baseUrl, request)
}
const _deleteV1ChartOfAccountId = async (url: string, request: Types.DeleteV1ChartOfAccountIdRequest): Promise<Types.DeleteV1ChartOfAccountIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/chart-of-account/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ChartOfAccountId: Api['deleteV1ChartOfAccountId'] = async (request: Types.DeleteV1ChartOfAccountIdRequest): Promise<Types.DeleteV1ChartOfAccountIdResponses> => {
  return await _deleteV1ChartOfAccountId(baseUrl, request)
}
const _getV1ChartOfAccountAccountType = async (url: string, request: Types.GetV1ChartOfAccountAccountTypeRequest): Promise<Types.GetV1ChartOfAccountAccountTypeResponses> => {
  const queryParameters: (keyof Types.GetV1ChartOfAccountAccountTypeRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/chart-of-account/account-type?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ChartOfAccountAccountType: Api['getV1ChartOfAccountAccountType'] = async (request: Types.GetV1ChartOfAccountAccountTypeRequest): Promise<Types.GetV1ChartOfAccountAccountTypeResponses> => {
  return await _getV1ChartOfAccountAccountType(baseUrl, request)
}
const _getV1ChartOfAccountGenerateExcel = async (url: string, request: Types.GetV1ChartOfAccountGenerateExcelRequest): Promise<Types.GetV1ChartOfAccountGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1ChartOfAccountGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/chart-of-account/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ChartOfAccountGenerateExcel: Api['getV1ChartOfAccountGenerateExcel'] = async (request: Types.GetV1ChartOfAccountGenerateExcelRequest): Promise<Types.GetV1ChartOfAccountGenerateExcelResponses> => {
  return await _getV1ChartOfAccountGenerateExcel(baseUrl, request)
}
const _getV1ChartOfAccountGeneratePdf = async (url: string, request: Types.GetV1ChartOfAccountGeneratePdfRequest): Promise<Types.GetV1ChartOfAccountGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1ChartOfAccountGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/chart-of-account/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ChartOfAccountGeneratePdf: Api['getV1ChartOfAccountGeneratePdf'] = async (request: Types.GetV1ChartOfAccountGeneratePdfRequest): Promise<Types.GetV1ChartOfAccountGeneratePdfResponses> => {
  return await _getV1ChartOfAccountGeneratePdf(baseUrl, request)
}
const _postV1TaxCategory = async (url: string, request: Types.PostV1TaxCategoryRequest): Promise<Types.PostV1TaxCategoryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-category/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1TaxCategory: Api['postV1TaxCategory'] = async (request: Types.PostV1TaxCategoryRequest): Promise<Types.PostV1TaxCategoryResponses> => {
  return await _postV1TaxCategory(baseUrl, request)
}
const _getV1TaxCategory = async (url: string, request: Types.GetV1TaxCategoryRequest): Promise<Types.GetV1TaxCategoryResponses> => {
  const queryParameters: (keyof Types.GetV1TaxCategoryRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-category/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TaxCategory: Api['getV1TaxCategory'] = async (request: Types.GetV1TaxCategoryRequest): Promise<Types.GetV1TaxCategoryResponses> => {
  return await _getV1TaxCategory(baseUrl, request)
}
const _postV1TaxCategoryImport = async (url: string, request: Types.PostV1TaxCategoryImportRequest): Promise<Types.PostV1TaxCategoryImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-category/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1TaxCategoryImport: Api['postV1TaxCategoryImport'] = async (request: Types.PostV1TaxCategoryImportRequest): Promise<Types.PostV1TaxCategoryImportResponses> => {
  return await _postV1TaxCategoryImport(baseUrl, request)
}
const _getV1TaxCategorySalesAccount = async (url: string, request: Types.GetV1TaxCategorySalesAccountRequest): Promise<Types.GetV1TaxCategorySalesAccountResponses> => {
  const queryParameters: (keyof Types.GetV1TaxCategorySalesAccountRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-category/sales-account?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TaxCategorySalesAccount: Api['getV1TaxCategorySalesAccount'] = async (request: Types.GetV1TaxCategorySalesAccountRequest): Promise<Types.GetV1TaxCategorySalesAccountResponses> => {
  return await _getV1TaxCategorySalesAccount(baseUrl, request)
}
const _getV1TaxCategoryPurchaseAccount = async (url: string, request: Types.GetV1TaxCategoryPurchaseAccountRequest): Promise<Types.GetV1TaxCategoryPurchaseAccountResponses> => {
  const queryParameters: (keyof Types.GetV1TaxCategoryPurchaseAccountRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-category/purchase-account?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TaxCategoryPurchaseAccount: Api['getV1TaxCategoryPurchaseAccount'] = async (request: Types.GetV1TaxCategoryPurchaseAccountRequest): Promise<Types.GetV1TaxCategoryPurchaseAccountResponses> => {
  return await _getV1TaxCategoryPurchaseAccount(baseUrl, request)
}
const _getV1TaxCategoryId = async (url: string, request: Types.GetV1TaxCategoryIdRequest): Promise<Types.GetV1TaxCategoryIdResponses> => {
  const queryParameters: (keyof Types.GetV1TaxCategoryIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-category/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TaxCategoryId: Api['getV1TaxCategoryId'] = async (request: Types.GetV1TaxCategoryIdRequest): Promise<Types.GetV1TaxCategoryIdResponses> => {
  return await _getV1TaxCategoryId(baseUrl, request)
}
const _putV1TaxCategoryId = async (url: string, request: Types.PutV1TaxCategoryIdRequest): Promise<Types.PutV1TaxCategoryIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-category/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1TaxCategoryId: Api['putV1TaxCategoryId'] = async (request: Types.PutV1TaxCategoryIdRequest): Promise<Types.PutV1TaxCategoryIdResponses> => {
  return await _putV1TaxCategoryId(baseUrl, request)
}
const _deleteV1TaxCategoryId = async (url: string, request: Types.DeleteV1TaxCategoryIdRequest): Promise<Types.DeleteV1TaxCategoryIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-category/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1TaxCategoryId: Api['deleteV1TaxCategoryId'] = async (request: Types.DeleteV1TaxCategoryIdRequest): Promise<Types.DeleteV1TaxCategoryIdResponses> => {
  return await _deleteV1TaxCategoryId(baseUrl, request)
}
const _getV1TaxCategoryGenerateExcel = async (url: string, request: Types.GetV1TaxCategoryGenerateExcelRequest): Promise<Types.GetV1TaxCategoryGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1TaxCategoryGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-category/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TaxCategoryGenerateExcel: Api['getV1TaxCategoryGenerateExcel'] = async (request: Types.GetV1TaxCategoryGenerateExcelRequest): Promise<Types.GetV1TaxCategoryGenerateExcelResponses> => {
  return await _getV1TaxCategoryGenerateExcel(baseUrl, request)
}
const _getV1TaxCategoryGeneratePdf = async (url: string, request: Types.GetV1TaxCategoryGeneratePdfRequest): Promise<Types.GetV1TaxCategoryGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1TaxCategoryGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-category/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TaxCategoryGeneratePdf: Api['getV1TaxCategoryGeneratePdf'] = async (request: Types.GetV1TaxCategoryGeneratePdfRequest): Promise<Types.GetV1TaxCategoryGeneratePdfResponses> => {
  return await _getV1TaxCategoryGeneratePdf(baseUrl, request)
}
const _postV1TaxCode = async (url: string, request: Types.PostV1TaxCodeRequest): Promise<Types.PostV1TaxCodeResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-code/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1TaxCode: Api['postV1TaxCode'] = async (request: Types.PostV1TaxCodeRequest): Promise<Types.PostV1TaxCodeResponses> => {
  return await _postV1TaxCode(baseUrl, request)
}
const _getV1TaxCode = async (url: string, request: Types.GetV1TaxCodeRequest): Promise<Types.GetV1TaxCodeResponses> => {
  const queryParameters: (keyof Types.GetV1TaxCodeRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-code/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TaxCode: Api['getV1TaxCode'] = async (request: Types.GetV1TaxCodeRequest): Promise<Types.GetV1TaxCodeResponses> => {
  return await _getV1TaxCode(baseUrl, request)
}
const _postV1TaxCodeImport = async (url: string, request: Types.PostV1TaxCodeImportRequest): Promise<Types.PostV1TaxCodeImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-code/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1TaxCodeImport: Api['postV1TaxCodeImport'] = async (request: Types.PostV1TaxCodeImportRequest): Promise<Types.PostV1TaxCodeImportResponses> => {
  return await _postV1TaxCodeImport(baseUrl, request)
}
const _getV1TaxCodeId = async (url: string, request: Types.GetV1TaxCodeIdRequest): Promise<Types.GetV1TaxCodeIdResponses> => {
  const queryParameters: (keyof Types.GetV1TaxCodeIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-code/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TaxCodeId: Api['getV1TaxCodeId'] = async (request: Types.GetV1TaxCodeIdRequest): Promise<Types.GetV1TaxCodeIdResponses> => {
  return await _getV1TaxCodeId(baseUrl, request)
}
const _putV1TaxCodeId = async (url: string, request: Types.PutV1TaxCodeIdRequest): Promise<Types.PutV1TaxCodeIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-code/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1TaxCodeId: Api['putV1TaxCodeId'] = async (request: Types.PutV1TaxCodeIdRequest): Promise<Types.PutV1TaxCodeIdResponses> => {
  return await _putV1TaxCodeId(baseUrl, request)
}
const _deleteV1TaxCodeId = async (url: string, request: Types.DeleteV1TaxCodeIdRequest): Promise<Types.DeleteV1TaxCodeIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-code/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1TaxCodeId: Api['deleteV1TaxCodeId'] = async (request: Types.DeleteV1TaxCodeIdRequest): Promise<Types.DeleteV1TaxCodeIdResponses> => {
  return await _deleteV1TaxCodeId(baseUrl, request)
}
const _getV1TaxCodeTaxCategoryDropdown = async (url: string, request: Types.GetV1TaxCodeTaxCategoryDropdownRequest): Promise<Types.GetV1TaxCodeTaxCategoryDropdownResponses> => {
  const queryParameters: (keyof Types.GetV1TaxCodeTaxCategoryDropdownRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-code/tax-category-dropdown?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TaxCodeTaxCategoryDropdown: Api['getV1TaxCodeTaxCategoryDropdown'] = async (request: Types.GetV1TaxCodeTaxCategoryDropdownRequest): Promise<Types.GetV1TaxCodeTaxCategoryDropdownResponses> => {
  return await _getV1TaxCodeTaxCategoryDropdown(baseUrl, request)
}
const _getV1TaxCodeGenerateExcel = async (url: string, request: Types.GetV1TaxCodeGenerateExcelRequest): Promise<Types.GetV1TaxCodeGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1TaxCodeGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-code/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TaxCodeGenerateExcel: Api['getV1TaxCodeGenerateExcel'] = async (request: Types.GetV1TaxCodeGenerateExcelRequest): Promise<Types.GetV1TaxCodeGenerateExcelResponses> => {
  return await _getV1TaxCodeGenerateExcel(baseUrl, request)
}
const _getV1TaxCodeGeneratePdf = async (url: string, request: Types.GetV1TaxCodeGeneratePdfRequest): Promise<Types.GetV1TaxCodeGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1TaxCodeGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-code/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TaxCodeGeneratePdf: Api['getV1TaxCodeGeneratePdf'] = async (request: Types.GetV1TaxCodeGeneratePdfRequest): Promise<Types.GetV1TaxCodeGeneratePdfResponses> => {
  return await _getV1TaxCodeGeneratePdf(baseUrl, request)
}
const _postV1TaxTemplates = async (url: string, request: Types.PostV1TaxTemplatesRequest): Promise<Types.PostV1TaxTemplatesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-templates/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1TaxTemplates: Api['postV1TaxTemplates'] = async (request: Types.PostV1TaxTemplatesRequest): Promise<Types.PostV1TaxTemplatesResponses> => {
  return await _postV1TaxTemplates(baseUrl, request)
}
const _getV1TaxTemplates = async (url: string, request: Types.GetV1TaxTemplatesRequest): Promise<Types.GetV1TaxTemplatesResponses> => {
  const queryParameters: (keyof Types.GetV1TaxTemplatesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-templates/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TaxTemplates: Api['getV1TaxTemplates'] = async (request: Types.GetV1TaxTemplatesRequest): Promise<Types.GetV1TaxTemplatesResponses> => {
  return await _getV1TaxTemplates(baseUrl, request)
}
const _postV1TaxTemplatesImport = async (url: string, request: Types.PostV1TaxTemplatesImportRequest): Promise<Types.PostV1TaxTemplatesImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-templates/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1TaxTemplatesImport: Api['postV1TaxTemplatesImport'] = async (request: Types.PostV1TaxTemplatesImportRequest): Promise<Types.PostV1TaxTemplatesImportResponses> => {
  return await _postV1TaxTemplatesImport(baseUrl, request)
}
const _getV1TaxTemplatesId = async (url: string, request: Types.GetV1TaxTemplatesIdRequest): Promise<Types.GetV1TaxTemplatesIdResponses> => {
  const queryParameters: (keyof Types.GetV1TaxTemplatesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-templates/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TaxTemplatesId: Api['getV1TaxTemplatesId'] = async (request: Types.GetV1TaxTemplatesIdRequest): Promise<Types.GetV1TaxTemplatesIdResponses> => {
  return await _getV1TaxTemplatesId(baseUrl, request)
}
const _putV1TaxTemplatesId = async (url: string, request: Types.PutV1TaxTemplatesIdRequest): Promise<Types.PutV1TaxTemplatesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-templates/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1TaxTemplatesId: Api['putV1TaxTemplatesId'] = async (request: Types.PutV1TaxTemplatesIdRequest): Promise<Types.PutV1TaxTemplatesIdResponses> => {
  return await _putV1TaxTemplatesId(baseUrl, request)
}
const _deleteV1TaxTemplatesId = async (url: string, request: Types.DeleteV1TaxTemplatesIdRequest): Promise<Types.DeleteV1TaxTemplatesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-templates/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1TaxTemplatesId: Api['deleteV1TaxTemplatesId'] = async (request: Types.DeleteV1TaxTemplatesIdRequest): Promise<Types.DeleteV1TaxTemplatesIdResponses> => {
  return await _deleteV1TaxTemplatesId(baseUrl, request)
}
const _getV1TaxTemplatesGenerateExcel = async (url: string, request: Types.GetV1TaxTemplatesGenerateExcelRequest): Promise<Types.GetV1TaxTemplatesGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1TaxTemplatesGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-templates/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TaxTemplatesGenerateExcel: Api['getV1TaxTemplatesGenerateExcel'] = async (request: Types.GetV1TaxTemplatesGenerateExcelRequest): Promise<Types.GetV1TaxTemplatesGenerateExcelResponses> => {
  return await _getV1TaxTemplatesGenerateExcel(baseUrl, request)
}
const _getV1TaxTemplatesGeneratePdf = async (url: string, request: Types.GetV1TaxTemplatesGeneratePdfRequest): Promise<Types.GetV1TaxTemplatesGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1TaxTemplatesGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/tax-templates/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TaxTemplatesGeneratePdf: Api['getV1TaxTemplatesGeneratePdf'] = async (request: Types.GetV1TaxTemplatesGeneratePdfRequest): Promise<Types.GetV1TaxTemplatesGeneratePdfResponses> => {
  return await _getV1TaxTemplatesGeneratePdf(baseUrl, request)
}
const _postV1Banks = async (url: string, request: Types.PostV1BanksRequest): Promise<Types.PostV1BanksResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/banks/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Banks: Api['postV1Banks'] = async (request: Types.PostV1BanksRequest): Promise<Types.PostV1BanksResponses> => {
  return await _postV1Banks(baseUrl, request)
}
const _getV1Banks = async (url: string, request: Types.GetV1BanksRequest): Promise<Types.GetV1BanksResponses> => {
  const queryParameters: (keyof Types.GetV1BanksRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/banks/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Banks: Api['getV1Banks'] = async (request: Types.GetV1BanksRequest): Promise<Types.GetV1BanksResponses> => {
  return await _getV1Banks(baseUrl, request)
}
const _postV1BanksImport = async (url: string, request: Types.PostV1BanksImportRequest): Promise<Types.PostV1BanksImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/banks/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1BanksImport: Api['postV1BanksImport'] = async (request: Types.PostV1BanksImportRequest): Promise<Types.PostV1BanksImportResponses> => {
  return await _postV1BanksImport(baseUrl, request)
}
const _getV1BanksId = async (url: string, request: Types.GetV1BanksIdRequest): Promise<Types.GetV1BanksIdResponses> => {
  const queryParameters: (keyof Types.GetV1BanksIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/banks/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BanksId: Api['getV1BanksId'] = async (request: Types.GetV1BanksIdRequest): Promise<Types.GetV1BanksIdResponses> => {
  return await _getV1BanksId(baseUrl, request)
}
const _putV1BanksId = async (url: string, request: Types.PutV1BanksIdRequest): Promise<Types.PutV1BanksIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/banks/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1BanksId: Api['putV1BanksId'] = async (request: Types.PutV1BanksIdRequest): Promise<Types.PutV1BanksIdResponses> => {
  return await _putV1BanksId(baseUrl, request)
}
const _deleteV1BanksId = async (url: string, request: Types.DeleteV1BanksIdRequest): Promise<Types.DeleteV1BanksIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/banks/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1BanksId: Api['deleteV1BanksId'] = async (request: Types.DeleteV1BanksIdRequest): Promise<Types.DeleteV1BanksIdResponses> => {
  return await _deleteV1BanksId(baseUrl, request)
}
const _getV1BanksGenerateExcel = async (url: string, request: Types.GetV1BanksGenerateExcelRequest): Promise<Types.GetV1BanksGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1BanksGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/banks/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BanksGenerateExcel: Api['getV1BanksGenerateExcel'] = async (request: Types.GetV1BanksGenerateExcelRequest): Promise<Types.GetV1BanksGenerateExcelResponses> => {
  return await _getV1BanksGenerateExcel(baseUrl, request)
}
const _getV1BanksGeneratePdf = async (url: string, request: Types.GetV1BanksGeneratePdfRequest): Promise<Types.GetV1BanksGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1BanksGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/banks/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BanksGeneratePdf: Api['getV1BanksGeneratePdf'] = async (request: Types.GetV1BanksGeneratePdfRequest): Promise<Types.GetV1BanksGeneratePdfResponses> => {
  return await _getV1BanksGeneratePdf(baseUrl, request)
}
const _postV1BankAccounts = async (url: string, request: Types.PostV1BankAccountsRequest): Promise<Types.PostV1BankAccountsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bank-accounts/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1BankAccounts: Api['postV1BankAccounts'] = async (request: Types.PostV1BankAccountsRequest): Promise<Types.PostV1BankAccountsResponses> => {
  return await _postV1BankAccounts(baseUrl, request)
}
const _getV1BankAccounts = async (url: string, request: Types.GetV1BankAccountsRequest): Promise<Types.GetV1BankAccountsResponses> => {
  const queryParameters: (keyof Types.GetV1BankAccountsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bank-accounts/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BankAccounts: Api['getV1BankAccounts'] = async (request: Types.GetV1BankAccountsRequest): Promise<Types.GetV1BankAccountsResponses> => {
  return await _getV1BankAccounts(baseUrl, request)
}
const _postV1BankAccountsImport = async (url: string, request: Types.PostV1BankAccountsImportRequest): Promise<Types.PostV1BankAccountsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bank-accounts/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1BankAccountsImport: Api['postV1BankAccountsImport'] = async (request: Types.PostV1BankAccountsImportRequest): Promise<Types.PostV1BankAccountsImportResponses> => {
  return await _postV1BankAccountsImport(baseUrl, request)
}
const _getV1BankAccountsId = async (url: string, request: Types.GetV1BankAccountsIdRequest): Promise<Types.GetV1BankAccountsIdResponses> => {
  const queryParameters: (keyof Types.GetV1BankAccountsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bank-accounts/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BankAccountsId: Api['getV1BankAccountsId'] = async (request: Types.GetV1BankAccountsIdRequest): Promise<Types.GetV1BankAccountsIdResponses> => {
  return await _getV1BankAccountsId(baseUrl, request)
}
const _putV1BankAccountsId = async (url: string, request: Types.PutV1BankAccountsIdRequest): Promise<Types.PutV1BankAccountsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bank-accounts/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1BankAccountsId: Api['putV1BankAccountsId'] = async (request: Types.PutV1BankAccountsIdRequest): Promise<Types.PutV1BankAccountsIdResponses> => {
  return await _putV1BankAccountsId(baseUrl, request)
}
const _deleteV1BankAccountsId = async (url: string, request: Types.DeleteV1BankAccountsIdRequest): Promise<Types.DeleteV1BankAccountsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bank-accounts/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1BankAccountsId: Api['deleteV1BankAccountsId'] = async (request: Types.DeleteV1BankAccountsIdRequest): Promise<Types.DeleteV1BankAccountsIdResponses> => {
  return await _deleteV1BankAccountsId(baseUrl, request)
}
const _getV1BankAccountsTypes = async (url: string, request: Types.GetV1BankAccountsTypesRequest): Promise<Types.GetV1BankAccountsTypesResponses> => {
  const queryParameters: (keyof Types.GetV1BankAccountsTypesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bank-accounts/types?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BankAccountsTypes: Api['getV1BankAccountsTypes'] = async (request: Types.GetV1BankAccountsTypesRequest): Promise<Types.GetV1BankAccountsTypesResponses> => {
  return await _getV1BankAccountsTypes(baseUrl, request)
}
const _getV1BankAccountsGenerateExcel = async (url: string, request: Types.GetV1BankAccountsGenerateExcelRequest): Promise<Types.GetV1BankAccountsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1BankAccountsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bank-accounts/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BankAccountsGenerateExcel: Api['getV1BankAccountsGenerateExcel'] = async (request: Types.GetV1BankAccountsGenerateExcelRequest): Promise<Types.GetV1BankAccountsGenerateExcelResponses> => {
  return await _getV1BankAccountsGenerateExcel(baseUrl, request)
}
const _getV1BankAccountsGeneratePdf = async (url: string, request: Types.GetV1BankAccountsGeneratePdfRequest): Promise<Types.GetV1BankAccountsGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1BankAccountsGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bank-accounts/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BankAccountsGeneratePdf: Api['getV1BankAccountsGeneratePdf'] = async (request: Types.GetV1BankAccountsGeneratePdfRequest): Promise<Types.GetV1BankAccountsGeneratePdfResponses> => {
  return await _getV1BankAccountsGeneratePdf(baseUrl, request)
}
const _getV1Currency = async (url: string, request: Types.GetV1CurrencyRequest): Promise<Types.GetV1CurrencyResponses> => {
  const queryParameters: (keyof Types.GetV1CurrencyRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/currency/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Currency: Api['getV1Currency'] = async (request: Types.GetV1CurrencyRequest): Promise<Types.GetV1CurrencyResponses> => {
  return await _getV1Currency(baseUrl, request)
}
const _postV1Currency = async (url: string, request: Types.PostV1CurrencyRequest): Promise<Types.PostV1CurrencyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/currency/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Currency: Api['postV1Currency'] = async (request: Types.PostV1CurrencyRequest): Promise<Types.PostV1CurrencyResponses> => {
  return await _postV1Currency(baseUrl, request)
}
const _getV1CurrencyId = async (url: string, request: Types.GetV1CurrencyIdRequest): Promise<Types.GetV1CurrencyIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/currency/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CurrencyId: Api['getV1CurrencyId'] = async (request: Types.GetV1CurrencyIdRequest): Promise<Types.GetV1CurrencyIdResponses> => {
  return await _getV1CurrencyId(baseUrl, request)
}
const _putV1CurrencyId = async (url: string, request: Types.PutV1CurrencyIdRequest): Promise<Types.PutV1CurrencyIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/currency/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CurrencyId: Api['putV1CurrencyId'] = async (request: Types.PutV1CurrencyIdRequest): Promise<Types.PutV1CurrencyIdResponses> => {
  return await _putV1CurrencyId(baseUrl, request)
}
const _deleteV1CurrencyId = async (url: string, request: Types.DeleteV1CurrencyIdRequest): Promise<Types.DeleteV1CurrencyIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/currency/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CurrencyId: Api['deleteV1CurrencyId'] = async (request: Types.DeleteV1CurrencyIdRequest): Promise<Types.DeleteV1CurrencyIdResponses> => {
  return await _deleteV1CurrencyId(baseUrl, request)
}
const _postV1CurrencyInfo = async (url: string, request: Types.PostV1CurrencyInfoRequest): Promise<Types.PostV1CurrencyInfoResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/currency/info`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CurrencyInfo: Api['postV1CurrencyInfo'] = async (request: Types.PostV1CurrencyInfoRequest): Promise<Types.PostV1CurrencyInfoResponses> => {
  return await _postV1CurrencyInfo(baseUrl, request)
}
const _postV1CurrencyImport = async (url: string, request: Types.PostV1CurrencyImportRequest): Promise<Types.PostV1CurrencyImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }

  const response = await fetch(`${url}/v1/currency/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CurrencyImport: Api['postV1CurrencyImport'] = async (request: Types.PostV1CurrencyImportRequest): Promise<Types.PostV1CurrencyImportResponses> => {
  return await _postV1CurrencyImport(baseUrl, request)
}
const _getV1CurrencyGenerateExcel = async (url: string, request: Types.GetV1CurrencyGenerateExcelRequest): Promise<Types.GetV1CurrencyGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CurrencyGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/currency/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CurrencyGenerateExcel: Api['getV1CurrencyGenerateExcel'] = async (request: Types.GetV1CurrencyGenerateExcelRequest): Promise<Types.GetV1CurrencyGenerateExcelResponses> => {
  return await _getV1CurrencyGenerateExcel(baseUrl, request)
}
const _getV1CurrencyGeneratePdf = async (url: string, request: Types.GetV1CurrencyGeneratePdfRequest): Promise<Types.GetV1CurrencyGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1CurrencyGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/currency/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CurrencyGeneratePdf: Api['getV1CurrencyGeneratePdf'] = async (request: Types.GetV1CurrencyGeneratePdfRequest): Promise<Types.GetV1CurrencyGeneratePdfResponses> => {
  return await _getV1CurrencyGeneratePdf(baseUrl, request)
}
const _getV1CurrencyExchange = async (url: string, request: Types.GetV1CurrencyExchangeRequest): Promise<Types.GetV1CurrencyExchangeResponses> => {
  const queryParameters: (keyof Types.GetV1CurrencyExchangeRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/currency-exchange/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CurrencyExchange: Api['getV1CurrencyExchange'] = async (request: Types.GetV1CurrencyExchangeRequest): Promise<Types.GetV1CurrencyExchangeResponses> => {
  return await _getV1CurrencyExchange(baseUrl, request)
}
const _postV1CurrencyExchange = async (url: string, request: Types.PostV1CurrencyExchangeRequest): Promise<Types.PostV1CurrencyExchangeResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/currency-exchange/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CurrencyExchange: Api['postV1CurrencyExchange'] = async (request: Types.PostV1CurrencyExchangeRequest): Promise<Types.PostV1CurrencyExchangeResponses> => {
  return await _postV1CurrencyExchange(baseUrl, request)
}
const _getV1CurrencyExchangeId = async (url: string, request: Types.GetV1CurrencyExchangeIdRequest): Promise<Types.GetV1CurrencyExchangeIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/currency-exchange/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CurrencyExchangeId: Api['getV1CurrencyExchangeId'] = async (request: Types.GetV1CurrencyExchangeIdRequest): Promise<Types.GetV1CurrencyExchangeIdResponses> => {
  return await _getV1CurrencyExchangeId(baseUrl, request)
}
const _putV1CurrencyExchangeId = async (url: string, request: Types.PutV1CurrencyExchangeIdRequest): Promise<Types.PutV1CurrencyExchangeIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/currency-exchange/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CurrencyExchangeId: Api['putV1CurrencyExchangeId'] = async (request: Types.PutV1CurrencyExchangeIdRequest): Promise<Types.PutV1CurrencyExchangeIdResponses> => {
  return await _putV1CurrencyExchangeId(baseUrl, request)
}
const _deleteV1CurrencyExchangeId = async (url: string, request: Types.DeleteV1CurrencyExchangeIdRequest): Promise<Types.DeleteV1CurrencyExchangeIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/currency-exchange/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CurrencyExchangeId: Api['deleteV1CurrencyExchangeId'] = async (request: Types.DeleteV1CurrencyExchangeIdRequest): Promise<Types.DeleteV1CurrencyExchangeIdResponses> => {
  return await _deleteV1CurrencyExchangeId(baseUrl, request)
}
const _postV1CurrencyExchangeImport = async (url: string, request: Types.PostV1CurrencyExchangeImportRequest): Promise<Types.PostV1CurrencyExchangeImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/currency-exchange/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CurrencyExchangeImport: Api['postV1CurrencyExchangeImport'] = async (request: Types.PostV1CurrencyExchangeImportRequest): Promise<Types.PostV1CurrencyExchangeImportResponses> => {
  return await _postV1CurrencyExchangeImport(baseUrl, request)
}
const _getV1CurrencyExchangeGenerateExcel = async (url: string, request: Types.GetV1CurrencyExchangeGenerateExcelRequest): Promise<Types.GetV1CurrencyExchangeGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CurrencyExchangeGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/currency-exchange/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CurrencyExchangeGenerateExcel: Api['getV1CurrencyExchangeGenerateExcel'] = async (request: Types.GetV1CurrencyExchangeGenerateExcelRequest): Promise<Types.GetV1CurrencyExchangeGenerateExcelResponses> => {
  return await _getV1CurrencyExchangeGenerateExcel(baseUrl, request)
}
const _getV1CurrencyExchangeGeneratePdf = async (url: string, request: Types.GetV1CurrencyExchangeGeneratePdfRequest): Promise<Types.GetV1CurrencyExchangeGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1CurrencyExchangeGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/currency-exchange/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CurrencyExchangeGeneratePdf: Api['getV1CurrencyExchangeGeneratePdf'] = async (request: Types.GetV1CurrencyExchangeGeneratePdfRequest): Promise<Types.GetV1CurrencyExchangeGeneratePdfResponses> => {
  return await _getV1CurrencyExchangeGeneratePdf(baseUrl, request)
}
const _postV1PaymentTerms = async (url: string, request: Types.PostV1PaymentTermsRequest): Promise<Types.PostV1PaymentTermsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-terms/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PaymentTerms: Api['postV1PaymentTerms'] = async (request: Types.PostV1PaymentTermsRequest): Promise<Types.PostV1PaymentTermsResponses> => {
  return await _postV1PaymentTerms(baseUrl, request)
}
const _getV1PaymentTerms = async (url: string, request: Types.GetV1PaymentTermsRequest): Promise<Types.GetV1PaymentTermsResponses> => {
  const queryParameters: (keyof Types.GetV1PaymentTermsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-terms/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PaymentTerms: Api['getV1PaymentTerms'] = async (request: Types.GetV1PaymentTermsRequest): Promise<Types.GetV1PaymentTermsResponses> => {
  return await _getV1PaymentTerms(baseUrl, request)
}
const _postV1PaymentTermsImport = async (url: string, request: Types.PostV1PaymentTermsImportRequest): Promise<Types.PostV1PaymentTermsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-terms/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PaymentTermsImport: Api['postV1PaymentTermsImport'] = async (request: Types.PostV1PaymentTermsImportRequest): Promise<Types.PostV1PaymentTermsImportResponses> => {
  return await _postV1PaymentTermsImport(baseUrl, request)
}
const _getV1PaymentTermsId = async (url: string, request: Types.GetV1PaymentTermsIdRequest): Promise<Types.GetV1PaymentTermsIdResponses> => {
  const queryParameters: (keyof Types.GetV1PaymentTermsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-terms/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PaymentTermsId: Api['getV1PaymentTermsId'] = async (request: Types.GetV1PaymentTermsIdRequest): Promise<Types.GetV1PaymentTermsIdResponses> => {
  return await _getV1PaymentTermsId(baseUrl, request)
}
const _putV1PaymentTermsId = async (url: string, request: Types.PutV1PaymentTermsIdRequest): Promise<Types.PutV1PaymentTermsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-terms/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PaymentTermsId: Api['putV1PaymentTermsId'] = async (request: Types.PutV1PaymentTermsIdRequest): Promise<Types.PutV1PaymentTermsIdResponses> => {
  return await _putV1PaymentTermsId(baseUrl, request)
}
const _deleteV1PaymentTermsId = async (url: string, request: Types.DeleteV1PaymentTermsIdRequest): Promise<Types.DeleteV1PaymentTermsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-terms/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PaymentTermsId: Api['deleteV1PaymentTermsId'] = async (request: Types.DeleteV1PaymentTermsIdRequest): Promise<Types.DeleteV1PaymentTermsIdResponses> => {
  return await _deleteV1PaymentTermsId(baseUrl, request)
}
const _getV1PaymentTermsDueDateTypes = async (url: string, request: Types.GetV1PaymentTermsDueDateTypesRequest): Promise<Types.GetV1PaymentTermsDueDateTypesResponses> => {
  const queryParameters: (keyof Types.GetV1PaymentTermsDueDateTypesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-terms/due-date-types?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PaymentTermsDueDateTypes: Api['getV1PaymentTermsDueDateTypes'] = async (request: Types.GetV1PaymentTermsDueDateTypesRequest): Promise<Types.GetV1PaymentTermsDueDateTypesResponses> => {
  return await _getV1PaymentTermsDueDateTypes(baseUrl, request)
}
const _getV1PaymentTermsGenerateExcel = async (url: string, request: Types.GetV1PaymentTermsGenerateExcelRequest): Promise<Types.GetV1PaymentTermsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1PaymentTermsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-terms/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PaymentTermsGenerateExcel: Api['getV1PaymentTermsGenerateExcel'] = async (request: Types.GetV1PaymentTermsGenerateExcelRequest): Promise<Types.GetV1PaymentTermsGenerateExcelResponses> => {
  return await _getV1PaymentTermsGenerateExcel(baseUrl, request)
}
const _getV1PaymentTermsGeneratePdf = async (url: string, request: Types.GetV1PaymentTermsGeneratePdfRequest): Promise<Types.GetV1PaymentTermsGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1PaymentTermsGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-terms/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PaymentTermsGeneratePdf: Api['getV1PaymentTermsGeneratePdf'] = async (request: Types.GetV1PaymentTermsGeneratePdfRequest): Promise<Types.GetV1PaymentTermsGeneratePdfResponses> => {
  return await _getV1PaymentTermsGeneratePdf(baseUrl, request)
}
const _postV1FiscalYear = async (url: string, request: Types.PostV1FiscalYearRequest): Promise<Types.PostV1FiscalYearResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/fiscal-year/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1FiscalYear: Api['postV1FiscalYear'] = async (request: Types.PostV1FiscalYearRequest): Promise<Types.PostV1FiscalYearResponses> => {
  return await _postV1FiscalYear(baseUrl, request)
}
const _getV1FiscalYear = async (url: string, request: Types.GetV1FiscalYearRequest): Promise<Types.GetV1FiscalYearResponses> => {
  const queryParameters: (keyof Types.GetV1FiscalYearRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/fiscal-year/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FiscalYear: Api['getV1FiscalYear'] = async (request: Types.GetV1FiscalYearRequest): Promise<Types.GetV1FiscalYearResponses> => {
  return await _getV1FiscalYear(baseUrl, request)
}
const _getV1FiscalYearId = async (url: string, request: Types.GetV1FiscalYearIdRequest): Promise<Types.GetV1FiscalYearIdResponses> => {
  const queryParameters: (keyof Types.GetV1FiscalYearIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/fiscal-year/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FiscalYearId: Api['getV1FiscalYearId'] = async (request: Types.GetV1FiscalYearIdRequest): Promise<Types.GetV1FiscalYearIdResponses> => {
  return await _getV1FiscalYearId(baseUrl, request)
}
const _putV1FiscalYearId = async (url: string, request: Types.PutV1FiscalYearIdRequest): Promise<Types.PutV1FiscalYearIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/fiscal-year/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1FiscalYearId: Api['putV1FiscalYearId'] = async (request: Types.PutV1FiscalYearIdRequest): Promise<Types.PutV1FiscalYearIdResponses> => {
  return await _putV1FiscalYearId(baseUrl, request)
}
const _deleteV1FiscalYearId = async (url: string, request: Types.DeleteV1FiscalYearIdRequest): Promise<Types.DeleteV1FiscalYearIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/fiscal-year/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1FiscalYearId: Api['deleteV1FiscalYearId'] = async (request: Types.DeleteV1FiscalYearIdRequest): Promise<Types.DeleteV1FiscalYearIdResponses> => {
  return await _deleteV1FiscalYearId(baseUrl, request)
}
const _getV1FiscalYearGenerateExcel = async (url: string, request: Types.GetV1FiscalYearGenerateExcelRequest): Promise<Types.GetV1FiscalYearGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1FiscalYearGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/fiscal-year/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FiscalYearGenerateExcel: Api['getV1FiscalYearGenerateExcel'] = async (request: Types.GetV1FiscalYearGenerateExcelRequest): Promise<Types.GetV1FiscalYearGenerateExcelResponses> => {
  return await _getV1FiscalYearGenerateExcel(baseUrl, request)
}
const _getV1FiscalYearGeneratePdf = async (url: string, request: Types.GetV1FiscalYearGeneratePdfRequest): Promise<Types.GetV1FiscalYearGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1FiscalYearGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/fiscal-year/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FiscalYearGeneratePdf: Api['getV1FiscalYearGeneratePdf'] = async (request: Types.GetV1FiscalYearGeneratePdfRequest): Promise<Types.GetV1FiscalYearGeneratePdfResponses> => {
  return await _getV1FiscalYearGeneratePdf(baseUrl, request)
}
const _getV1JournalTypes = async (url: string, request: Types.GetV1JournalTypesRequest): Promise<Types.GetV1JournalTypesResponses> => {
  const queryParameters: (keyof Types.GetV1JournalTypesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-types/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JournalTypes: Api['getV1JournalTypes'] = async (request: Types.GetV1JournalTypesRequest): Promise<Types.GetV1JournalTypesResponses> => {
  return await _getV1JournalTypes(baseUrl, request)
}
const _postV1JournalTypes = async (url: string, request: Types.PostV1JournalTypesRequest): Promise<Types.PostV1JournalTypesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-types/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1JournalTypes: Api['postV1JournalTypes'] = async (request: Types.PostV1JournalTypesRequest): Promise<Types.PostV1JournalTypesResponses> => {
  return await _postV1JournalTypes(baseUrl, request)
}
const _getV1JournalTypesId = async (url: string, request: Types.GetV1JournalTypesIdRequest): Promise<Types.GetV1JournalTypesIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-types/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JournalTypesId: Api['getV1JournalTypesId'] = async (request: Types.GetV1JournalTypesIdRequest): Promise<Types.GetV1JournalTypesIdResponses> => {
  return await _getV1JournalTypesId(baseUrl, request)
}
const _putV1JournalTypesId = async (url: string, request: Types.PutV1JournalTypesIdRequest): Promise<Types.PutV1JournalTypesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-types/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1JournalTypesId: Api['putV1JournalTypesId'] = async (request: Types.PutV1JournalTypesIdRequest): Promise<Types.PutV1JournalTypesIdResponses> => {
  return await _putV1JournalTypesId(baseUrl, request)
}
const _deleteV1JournalTypesId = async (url: string, request: Types.DeleteV1JournalTypesIdRequest): Promise<Types.DeleteV1JournalTypesIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-types/${request['id']}`, {
    method: 'DELETE',
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1JournalTypesId: Api['deleteV1JournalTypesId'] = async (request: Types.DeleteV1JournalTypesIdRequest): Promise<Types.DeleteV1JournalTypesIdResponses> => {
  return await _deleteV1JournalTypesId(baseUrl, request)
}
const _getV1JournalEntriesReferenceType = async (url: string, request: Types.GetV1JournalEntriesReferenceTypeRequest): Promise<Types.GetV1JournalEntriesReferenceTypeResponses> => {
  const queryParameters: (keyof Types.GetV1JournalEntriesReferenceTypeRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-entries/reference-type?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JournalEntriesReferenceType: Api['getV1JournalEntriesReferenceType'] = async (request: Types.GetV1JournalEntriesReferenceTypeRequest): Promise<Types.GetV1JournalEntriesReferenceTypeResponses> => {
  return await _getV1JournalEntriesReferenceType(baseUrl, request)
}
const _postV1JournalEntries = async (url: string, request: Types.PostV1JournalEntriesRequest): Promise<Types.PostV1JournalEntriesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-entries/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1JournalEntries: Api['postV1JournalEntries'] = async (request: Types.PostV1JournalEntriesRequest): Promise<Types.PostV1JournalEntriesResponses> => {
  return await _postV1JournalEntries(baseUrl, request)
}
const _getV1JournalEntries = async (url: string, request: Types.GetV1JournalEntriesRequest): Promise<Types.GetV1JournalEntriesResponses> => {
  const queryParameters: (keyof Types.GetV1JournalEntriesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-entries/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JournalEntries: Api['getV1JournalEntries'] = async (request: Types.GetV1JournalEntriesRequest): Promise<Types.GetV1JournalEntriesResponses> => {
  return await _getV1JournalEntries(baseUrl, request)
}
const _postV1JournalEntriesImport = async (url: string, request: Types.PostV1JournalEntriesImportRequest): Promise<Types.PostV1JournalEntriesImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-entries/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1JournalEntriesImport: Api['postV1JournalEntriesImport'] = async (request: Types.PostV1JournalEntriesImportRequest): Promise<Types.PostV1JournalEntriesImportResponses> => {
  return await _postV1JournalEntriesImport(baseUrl, request)
}
const _getV1JournalEntriesId = async (url: string, request: Types.GetV1JournalEntriesIdRequest): Promise<Types.GetV1JournalEntriesIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-entries/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JournalEntriesId: Api['getV1JournalEntriesId'] = async (request: Types.GetV1JournalEntriesIdRequest): Promise<Types.GetV1JournalEntriesIdResponses> => {
  return await _getV1JournalEntriesId(baseUrl, request)
}
const _putV1JournalEntriesId = async (url: string, request: Types.PutV1JournalEntriesIdRequest): Promise<Types.PutV1JournalEntriesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-entries/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1JournalEntriesId: Api['putV1JournalEntriesId'] = async (request: Types.PutV1JournalEntriesIdRequest): Promise<Types.PutV1JournalEntriesIdResponses> => {
  return await _putV1JournalEntriesId(baseUrl, request)
}
const _deleteV1JournalEntriesId = async (url: string, request: Types.DeleteV1JournalEntriesIdRequest): Promise<Types.DeleteV1JournalEntriesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-entries/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1JournalEntriesId: Api['deleteV1JournalEntriesId'] = async (request: Types.DeleteV1JournalEntriesIdRequest): Promise<Types.DeleteV1JournalEntriesIdResponses> => {
  return await _deleteV1JournalEntriesId(baseUrl, request)
}
const _postV1JournalEntriesAddApprover = async (url: string, request: Types.PostV1JournalEntriesAddApproverRequest): Promise<Types.PostV1JournalEntriesAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-entries/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1JournalEntriesAddApprover: Api['postV1JournalEntriesAddApprover'] = async (request: Types.PostV1JournalEntriesAddApproverRequest): Promise<Types.PostV1JournalEntriesAddApproverResponses> => {
  return await _postV1JournalEntriesAddApprover(baseUrl, request)
}
const _putV1JournalEntriesApprovalStatusId = async (url: string, request: Types.PutV1JournalEntriesApprovalStatusIdRequest): Promise<Types.PutV1JournalEntriesApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-entries/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1JournalEntriesApprovalStatusId: Api['putV1JournalEntriesApprovalStatusId'] = async (request: Types.PutV1JournalEntriesApprovalStatusIdRequest): Promise<Types.PutV1JournalEntriesApprovalStatusIdResponses> => {
  return await _putV1JournalEntriesApprovalStatusId(baseUrl, request)
}
const _getV1JournalEntriesIdExportType = async (url: string, request: Types.GetV1JournalEntriesIdExportTypeRequest): Promise<Types.GetV1JournalEntriesIdExportTypeResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-entries/${request['id']}/export/${request['type']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JournalEntriesIdExportType: Api['getV1JournalEntriesIdExportType'] = async (request: Types.GetV1JournalEntriesIdExportTypeRequest): Promise<Types.GetV1JournalEntriesIdExportTypeResponses> => {
  return await _getV1JournalEntriesIdExportType(baseUrl, request)
}
const _getV1JournalEntriesGenerateExcel = async (url: string, request: Types.GetV1JournalEntriesGenerateExcelRequest): Promise<Types.GetV1JournalEntriesGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1JournalEntriesGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-entries/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JournalEntriesGenerateExcel: Api['getV1JournalEntriesGenerateExcel'] = async (request: Types.GetV1JournalEntriesGenerateExcelRequest): Promise<Types.GetV1JournalEntriesGenerateExcelResponses> => {
  return await _getV1JournalEntriesGenerateExcel(baseUrl, request)
}
const _getV1JournalEntriesGeneratePdf = async (url: string, request: Types.GetV1JournalEntriesGeneratePdfRequest): Promise<Types.GetV1JournalEntriesGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1JournalEntriesGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'columns', 'selectedRows']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-entries/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JournalEntriesGeneratePdf: Api['getV1JournalEntriesGeneratePdf'] = async (request: Types.GetV1JournalEntriesGeneratePdfRequest): Promise<Types.GetV1JournalEntriesGeneratePdfResponses> => {
  return await _getV1JournalEntriesGeneratePdf(baseUrl, request)
}
const _getV1JournalEntriesIdDownload = async (url: string, request: Types.GetV1JournalEntriesIdDownloadRequest): Promise<Types.GetV1JournalEntriesIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1JournalEntriesIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/journal-entries/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JournalEntriesIdDownload: Api['getV1JournalEntriesIdDownload'] = async (request: Types.GetV1JournalEntriesIdDownloadRequest): Promise<Types.GetV1JournalEntriesIdDownloadResponses> => {
  return await _getV1JournalEntriesIdDownload(baseUrl, request)
}
const _postV1Parties = async (url: string, request: Types.PostV1PartiesRequest): Promise<Types.PostV1PartiesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/parties/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Parties: Api['postV1Parties'] = async (request: Types.PostV1PartiesRequest): Promise<Types.PostV1PartiesResponses> => {
  return await _postV1Parties(baseUrl, request)
}
const _getV1Parties = async (url: string, request: Types.GetV1PartiesRequest): Promise<Types.GetV1PartiesResponses> => {
  const queryParameters: (keyof Types.GetV1PartiesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/parties/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Parties: Api['getV1Parties'] = async (request: Types.GetV1PartiesRequest): Promise<Types.GetV1PartiesResponses> => {
  return await _getV1Parties(baseUrl, request)
}
const _getV1PartiesId = async (url: string, request: Types.GetV1PartiesIdRequest): Promise<Types.GetV1PartiesIdResponses> => {
  const queryParameters: (keyof Types.GetV1PartiesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/parties/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PartiesId: Api['getV1PartiesId'] = async (request: Types.GetV1PartiesIdRequest): Promise<Types.GetV1PartiesIdResponses> => {
  return await _getV1PartiesId(baseUrl, request)
}
const _putV1PartiesId = async (url: string, request: Types.PutV1PartiesIdRequest): Promise<Types.PutV1PartiesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/parties/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PartiesId: Api['putV1PartiesId'] = async (request: Types.PutV1PartiesIdRequest): Promise<Types.PutV1PartiesIdResponses> => {
  return await _putV1PartiesId(baseUrl, request)
}
const _deleteV1PartiesId = async (url: string, request: Types.DeleteV1PartiesIdRequest): Promise<Types.DeleteV1PartiesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/parties/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PartiesId: Api['deleteV1PartiesId'] = async (request: Types.DeleteV1PartiesIdRequest): Promise<Types.DeleteV1PartiesIdResponses> => {
  return await _deleteV1PartiesId(baseUrl, request)
}
const _postV1PartiesImport = async (url: string, request: Types.PostV1PartiesImportRequest): Promise<Types.PostV1PartiesImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }

  const response = await fetch(`${url}/v1/parties/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PartiesImport: Api['postV1PartiesImport'] = async (request: Types.PostV1PartiesImportRequest): Promise<Types.PostV1PartiesImportResponses> => {
  return await _postV1PartiesImport(baseUrl, request)
}
const _getV1PartiesIndustry = async (url: string, request: Types.GetV1PartiesIndustryRequest): Promise<Types.GetV1PartiesIndustryResponses> => {
  const queryParameters: (keyof Types.GetV1PartiesIndustryRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/parties/industry?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PartiesIndustry: Api['getV1PartiesIndustry'] = async (request: Types.GetV1PartiesIndustryRequest): Promise<Types.GetV1PartiesIndustryResponses> => {
  return await _getV1PartiesIndustry(baseUrl, request)
}
const _postV1PartiesIndustry = async (url: string, request: Types.PostV1PartiesIndustryRequest): Promise<Types.PostV1PartiesIndustryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/parties/industry`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PartiesIndustry: Api['postV1PartiesIndustry'] = async (request: Types.PostV1PartiesIndustryRequest): Promise<Types.PostV1PartiesIndustryResponses> => {
  return await _postV1PartiesIndustry(baseUrl, request)
}
const _getV1PartiesSelectOptions = async (url: string, request: Types.GetV1PartiesSelectOptionsRequest): Promise<Types.GetV1PartiesSelectOptionsResponses> => {
  const queryParameters: (keyof Types.GetV1PartiesSelectOptionsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/parties/select-options?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PartiesSelectOptions: Api['getV1PartiesSelectOptions'] = async (request: Types.GetV1PartiesSelectOptionsRequest): Promise<Types.GetV1PartiesSelectOptionsResponses> => {
  return await _getV1PartiesSelectOptions(baseUrl, request)
}
const _getV1PartiesGenerateExcel = async (url: string, request: Types.GetV1PartiesGenerateExcelRequest): Promise<Types.GetV1PartiesGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1PartiesGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/parties/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PartiesGenerateExcel: Api['getV1PartiesGenerateExcel'] = async (request: Types.GetV1PartiesGenerateExcelRequest): Promise<Types.GetV1PartiesGenerateExcelResponses> => {
  return await _getV1PartiesGenerateExcel(baseUrl, request)
}
const _getV1PartiesGeneratePdf = async (url: string, request: Types.GetV1PartiesGeneratePdfRequest): Promise<Types.GetV1PartiesGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1PartiesGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/parties/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PartiesGeneratePdf: Api['getV1PartiesGeneratePdf'] = async (request: Types.GetV1PartiesGeneratePdfRequest): Promise<Types.GetV1PartiesGeneratePdfResponses> => {
  return await _getV1PartiesGeneratePdf(baseUrl, request)
}
const _postV1PartiesCheck = async (url: string, request: Types.PostV1PartiesCheckRequest): Promise<Types.PostV1PartiesCheckResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/parties/check`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PartiesCheck: Api['postV1PartiesCheck'] = async (request: Types.PostV1PartiesCheckRequest): Promise<Types.PostV1PartiesCheckResponses> => {
  return await _postV1PartiesCheck(baseUrl, request)
}
const _getV1PartiesIdFetchSoldItems = async (url: string, request: Types.GetV1PartiesIdFetchSoldItemsRequest): Promise<Types.GetV1PartiesIdFetchSoldItemsResponses> => {
  const queryParameters: (keyof Types.GetV1PartiesIdFetchSoldItemsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/parties/${request['id']}/fetch-sold-items?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PartiesIdFetchSoldItems: Api['getV1PartiesIdFetchSoldItems'] = async (request: Types.GetV1PartiesIdFetchSoldItemsRequest): Promise<Types.GetV1PartiesIdFetchSoldItemsResponses> => {
  return await _getV1PartiesIdFetchSoldItems(baseUrl, request)
}
const _getV1PartiesIdFetchPurchaseItems = async (url: string, request: Types.GetV1PartiesIdFetchPurchaseItemsRequest): Promise<Types.GetV1PartiesIdFetchPurchaseItemsResponses> => {
  const queryParameters: (keyof Types.GetV1PartiesIdFetchPurchaseItemsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/parties/${request['id']}/fetch-purchase-items?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PartiesIdFetchPurchaseItems: Api['getV1PartiesIdFetchPurchaseItems'] = async (request: Types.GetV1PartiesIdFetchPurchaseItemsRequest): Promise<Types.GetV1PartiesIdFetchPurchaseItemsResponses> => {
  return await _getV1PartiesIdFetchPurchaseItems(baseUrl, request)
}
const _postV1PaymentEntriesEntries = async (url: string, request: Types.PostV1PaymentEntriesEntriesRequest): Promise<Types.PostV1PaymentEntriesEntriesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-entries/entries`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PaymentEntriesEntries: Api['postV1PaymentEntriesEntries'] = async (request: Types.PostV1PaymentEntriesEntriesRequest): Promise<Types.PostV1PaymentEntriesEntriesResponses> => {
  return await _postV1PaymentEntriesEntries(baseUrl, request)
}
const _getV1PaymentEntriesEntries = async (url: string, request: Types.GetV1PaymentEntriesEntriesRequest): Promise<Types.GetV1PaymentEntriesEntriesResponses> => {
  const queryParameters: (keyof Types.GetV1PaymentEntriesEntriesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-entries/entries?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PaymentEntriesEntries: Api['getV1PaymentEntriesEntries'] = async (request: Types.GetV1PaymentEntriesEntriesRequest): Promise<Types.GetV1PaymentEntriesEntriesResponses> => {
  return await _getV1PaymentEntriesEntries(baseUrl, request)
}
const _postV1PaymentEntriesImport = async (url: string, request: Types.PostV1PaymentEntriesImportRequest): Promise<Types.PostV1PaymentEntriesImportResponses> => {
  const queryParameters: (keyof Types.PostV1PaymentEntriesImportRequest)[]  = ['type']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-entries/import?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PaymentEntriesImport: Api['postV1PaymentEntriesImport'] = async (request: Types.PostV1PaymentEntriesImportRequest): Promise<Types.PostV1PaymentEntriesImportResponses> => {
  return await _postV1PaymentEntriesImport(baseUrl, request)
}
const _getV1PaymentEntriesEntriesIdType = async (url: string, request: Types.GetV1PaymentEntriesEntriesIdTypeRequest): Promise<Types.GetV1PaymentEntriesEntriesIdTypeResponses> => {
  const queryParameters: (keyof Types.GetV1PaymentEntriesEntriesIdTypeRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-entries/entries/${request['id']}/${request['type']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PaymentEntriesEntriesIdType: Api['getV1PaymentEntriesEntriesIdType'] = async (request: Types.GetV1PaymentEntriesEntriesIdTypeRequest): Promise<Types.GetV1PaymentEntriesEntriesIdTypeResponses> => {
  return await _getV1PaymentEntriesEntriesIdType(baseUrl, request)
}
const _putV1PaymentEntriesEntriesId = async (url: string, request: Types.PutV1PaymentEntriesEntriesIdRequest): Promise<Types.PutV1PaymentEntriesEntriesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-entries/entries/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PaymentEntriesEntriesId: Api['putV1PaymentEntriesEntriesId'] = async (request: Types.PutV1PaymentEntriesEntriesIdRequest): Promise<Types.PutV1PaymentEntriesEntriesIdResponses> => {
  return await _putV1PaymentEntriesEntriesId(baseUrl, request)
}
const _deleteV1PaymentEntriesEntriesId = async (url: string, request: Types.DeleteV1PaymentEntriesEntriesIdRequest): Promise<Types.DeleteV1PaymentEntriesEntriesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-entries/entries/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PaymentEntriesEntriesId: Api['deleteV1PaymentEntriesEntriesId'] = async (request: Types.DeleteV1PaymentEntriesEntriesIdRequest): Promise<Types.DeleteV1PaymentEntriesEntriesIdResponses> => {
  return await _deleteV1PaymentEntriesEntriesId(baseUrl, request)
}
const _postV1PaymentEntriesAddApprover = async (url: string, request: Types.PostV1PaymentEntriesAddApproverRequest): Promise<Types.PostV1PaymentEntriesAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-entries/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PaymentEntriesAddApprover: Api['postV1PaymentEntriesAddApprover'] = async (request: Types.PostV1PaymentEntriesAddApproverRequest): Promise<Types.PostV1PaymentEntriesAddApproverResponses> => {
  return await _postV1PaymentEntriesAddApprover(baseUrl, request)
}
const _putV1PaymentEntriesApprovalStatusId = async (url: string, request: Types.PutV1PaymentEntriesApprovalStatusIdRequest): Promise<Types.PutV1PaymentEntriesApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-entries/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PaymentEntriesApprovalStatusId: Api['putV1PaymentEntriesApprovalStatusId'] = async (request: Types.PutV1PaymentEntriesApprovalStatusIdRequest): Promise<Types.PutV1PaymentEntriesApprovalStatusIdResponses> => {
  return await _putV1PaymentEntriesApprovalStatusId(baseUrl, request)
}
const _getV1PaymentEntriesPurchaseInvoicesId = async (url: string, request: Types.GetV1PaymentEntriesPurchaseInvoicesIdRequest): Promise<Types.GetV1PaymentEntriesPurchaseInvoicesIdResponses> => {
  const queryParameters: (keyof Types.GetV1PaymentEntriesPurchaseInvoicesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-entries/purchase-invoices/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PaymentEntriesPurchaseInvoicesId: Api['getV1PaymentEntriesPurchaseInvoicesId'] = async (request: Types.GetV1PaymentEntriesPurchaseInvoicesIdRequest): Promise<Types.GetV1PaymentEntriesPurchaseInvoicesIdResponses> => {
  return await _getV1PaymentEntriesPurchaseInvoicesId(baseUrl, request)
}
const _getV1PaymentEntriesSalesInvoicesId = async (url: string, request: Types.GetV1PaymentEntriesSalesInvoicesIdRequest): Promise<Types.GetV1PaymentEntriesSalesInvoicesIdResponses> => {
  const queryParameters: (keyof Types.GetV1PaymentEntriesSalesInvoicesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-entries/sales-invoices/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PaymentEntriesSalesInvoicesId: Api['getV1PaymentEntriesSalesInvoicesId'] = async (request: Types.GetV1PaymentEntriesSalesInvoicesIdRequest): Promise<Types.GetV1PaymentEntriesSalesInvoicesIdResponses> => {
  return await _getV1PaymentEntriesSalesInvoicesId(baseUrl, request)
}
const _getV1PaymentEntriesCreditNoteId = async (url: string, request: Types.GetV1PaymentEntriesCreditNoteIdRequest): Promise<Types.GetV1PaymentEntriesCreditNoteIdResponses> => {
  const queryParameters: (keyof Types.GetV1PaymentEntriesCreditNoteIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-entries/credit-note/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PaymentEntriesCreditNoteId: Api['getV1PaymentEntriesCreditNoteId'] = async (request: Types.GetV1PaymentEntriesCreditNoteIdRequest): Promise<Types.GetV1PaymentEntriesCreditNoteIdResponses> => {
  return await _getV1PaymentEntriesCreditNoteId(baseUrl, request)
}
const _getV1PaymentEntriesDebitNoteId = async (url: string, request: Types.GetV1PaymentEntriesDebitNoteIdRequest): Promise<Types.GetV1PaymentEntriesDebitNoteIdResponses> => {
  const queryParameters: (keyof Types.GetV1PaymentEntriesDebitNoteIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-entries/debit-note/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PaymentEntriesDebitNoteId: Api['getV1PaymentEntriesDebitNoteId'] = async (request: Types.GetV1PaymentEntriesDebitNoteIdRequest): Promise<Types.GetV1PaymentEntriesDebitNoteIdResponses> => {
  return await _getV1PaymentEntriesDebitNoteId(baseUrl, request)
}
const _getV1PaymentEntriesExpenseReimbursementsId = async (url: string, request: Types.GetV1PaymentEntriesExpenseReimbursementsIdRequest): Promise<Types.GetV1PaymentEntriesExpenseReimbursementsIdResponses> => {
  const queryParameters: (keyof Types.GetV1PaymentEntriesExpenseReimbursementsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-entries/expense-reimbursements/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PaymentEntriesExpenseReimbursementsId: Api['getV1PaymentEntriesExpenseReimbursementsId'] = async (request: Types.GetV1PaymentEntriesExpenseReimbursementsIdRequest): Promise<Types.GetV1PaymentEntriesExpenseReimbursementsIdResponses> => {
  return await _getV1PaymentEntriesExpenseReimbursementsId(baseUrl, request)
}
const _putV1PaymentEntriesExpenseReimbursementsApprovalStatusId = async (url: string, request: Types.PutV1PaymentEntriesExpenseReimbursementsApprovalStatusIdRequest): Promise<Types.PutV1PaymentEntriesExpenseReimbursementsApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-entries/expense-reimbursements/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PaymentEntriesExpenseReimbursementsApprovalStatusId: Api['putV1PaymentEntriesExpenseReimbursementsApprovalStatusId'] = async (request: Types.PutV1PaymentEntriesExpenseReimbursementsApprovalStatusIdRequest): Promise<Types.PutV1PaymentEntriesExpenseReimbursementsApprovalStatusIdResponses> => {
  return await _putV1PaymentEntriesExpenseReimbursementsApprovalStatusId(baseUrl, request)
}
const _getV1PaymentEntriesEntriesTypeIdDownload = async (url: string, request: Types.GetV1PaymentEntriesEntriesTypeIdDownloadRequest): Promise<Types.GetV1PaymentEntriesEntriesTypeIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1PaymentEntriesEntriesTypeIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-entries/entries/${request['type']}/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PaymentEntriesEntriesTypeIdDownload: Api['getV1PaymentEntriesEntriesTypeIdDownload'] = async (request: Types.GetV1PaymentEntriesEntriesTypeIdDownloadRequest): Promise<Types.GetV1PaymentEntriesEntriesTypeIdDownloadResponses> => {
  return await _getV1PaymentEntriesEntriesTypeIdDownload(baseUrl, request)
}
const _getV1PaymentEntriesGenerateExcel = async (url: string, request: Types.GetV1PaymentEntriesGenerateExcelRequest): Promise<Types.GetV1PaymentEntriesGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1PaymentEntriesGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-entries/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PaymentEntriesGenerateExcel: Api['getV1PaymentEntriesGenerateExcel'] = async (request: Types.GetV1PaymentEntriesGenerateExcelRequest): Promise<Types.GetV1PaymentEntriesGenerateExcelResponses> => {
  return await _getV1PaymentEntriesGenerateExcel(baseUrl, request)
}
const _getV1PaymentEntriesGeneratePdf = async (url: string, request: Types.GetV1PaymentEntriesGeneratePdfRequest): Promise<Types.GetV1PaymentEntriesGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1PaymentEntriesGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'columns', 'selectedRows']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/payment-entries/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PaymentEntriesGeneratePdf: Api['getV1PaymentEntriesGeneratePdf'] = async (request: Types.GetV1PaymentEntriesGeneratePdfRequest): Promise<Types.GetV1PaymentEntriesGeneratePdfResponses> => {
  return await _getV1PaymentEntriesGeneratePdf(baseUrl, request)
}
const _getV1PurchaseInvoicesUom = async (url: string, request: Types.GetV1PurchaseInvoicesUomRequest): Promise<Types.GetV1PurchaseInvoicesUomResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseInvoicesUomRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/uom?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseInvoicesUom: Api['getV1PurchaseInvoicesUom'] = async (request: Types.GetV1PurchaseInvoicesUomRequest): Promise<Types.GetV1PurchaseInvoicesUomResponses> => {
  return await _getV1PurchaseInvoicesUom(baseUrl, request)
}
const _getV1PurchaseInvoicesIncoterms = async (url: string, request: Types.GetV1PurchaseInvoicesIncotermsRequest): Promise<Types.GetV1PurchaseInvoicesIncotermsResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseInvoicesIncotermsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/incoterms?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseInvoicesIncoterms: Api['getV1PurchaseInvoicesIncoterms'] = async (request: Types.GetV1PurchaseInvoicesIncotermsRequest): Promise<Types.GetV1PurchaseInvoicesIncotermsResponses> => {
  return await _getV1PurchaseInvoicesIncoterms(baseUrl, request)
}
const _getV1PurchaseInvoicesItems = async (url: string, request: Types.GetV1PurchaseInvoicesItemsRequest): Promise<Types.GetV1PurchaseInvoicesItemsResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseInvoicesItemsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/items?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseInvoicesItems: Api['getV1PurchaseInvoicesItems'] = async (request: Types.GetV1PurchaseInvoicesItemsRequest): Promise<Types.GetV1PurchaseInvoicesItemsResponses> => {
  return await _getV1PurchaseInvoicesItems(baseUrl, request)
}
const _getV1PurchaseInvoicesDiscountItemId = async (url: string, request: Types.GetV1PurchaseInvoicesDiscountItemIdRequest): Promise<Types.GetV1PurchaseInvoicesDiscountItemIdResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseInvoicesDiscountItemIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/discount-item/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseInvoicesDiscountItemId: Api['getV1PurchaseInvoicesDiscountItemId'] = async (request: Types.GetV1PurchaseInvoicesDiscountItemIdRequest): Promise<Types.GetV1PurchaseInvoicesDiscountItemIdResponses> => {
  return await _getV1PurchaseInvoicesDiscountItemId(baseUrl, request)
}
const _getV1PurchaseInvoicesWarehouses = async (url: string, request: Types.GetV1PurchaseInvoicesWarehousesRequest): Promise<Types.GetV1PurchaseInvoicesWarehousesResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseInvoicesWarehousesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/warehouses?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseInvoicesWarehouses: Api['getV1PurchaseInvoicesWarehouses'] = async (request: Types.GetV1PurchaseInvoicesWarehousesRequest): Promise<Types.GetV1PurchaseInvoicesWarehousesResponses> => {
  return await _getV1PurchaseInvoicesWarehouses(baseUrl, request)
}
const _getV1PurchaseInvoicesSuppliers = async (url: string, request: Types.GetV1PurchaseInvoicesSuppliersRequest): Promise<Types.GetV1PurchaseInvoicesSuppliersResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseInvoicesSuppliersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/suppliers?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseInvoicesSuppliers: Api['getV1PurchaseInvoicesSuppliers'] = async (request: Types.GetV1PurchaseInvoicesSuppliersRequest): Promise<Types.GetV1PurchaseInvoicesSuppliersResponses> => {
  return await _getV1PurchaseInvoicesSuppliers(baseUrl, request)
}
const _getV1PurchaseInvoicesSuppliersId = async (url: string, request: Types.GetV1PurchaseInvoicesSuppliersIdRequest): Promise<Types.GetV1PurchaseInvoicesSuppliersIdResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseInvoicesSuppliersIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/suppliers/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseInvoicesSuppliersId: Api['getV1PurchaseInvoicesSuppliersId'] = async (request: Types.GetV1PurchaseInvoicesSuppliersIdRequest): Promise<Types.GetV1PurchaseInvoicesSuppliersIdResponses> => {
  return await _getV1PurchaseInvoicesSuppliersId(baseUrl, request)
}
const _postV1PurchaseInvoices = async (url: string, request: Types.PostV1PurchaseInvoicesRequest): Promise<Types.PostV1PurchaseInvoicesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseInvoices: Api['postV1PurchaseInvoices'] = async (request: Types.PostV1PurchaseInvoicesRequest): Promise<Types.PostV1PurchaseInvoicesResponses> => {
  return await _postV1PurchaseInvoices(baseUrl, request)
}
const _getV1PurchaseInvoices = async (url: string, request: Types.GetV1PurchaseInvoicesRequest): Promise<Types.GetV1PurchaseInvoicesResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseInvoicesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseInvoices: Api['getV1PurchaseInvoices'] = async (request: Types.GetV1PurchaseInvoicesRequest): Promise<Types.GetV1PurchaseInvoicesResponses> => {
  return await _getV1PurchaseInvoices(baseUrl, request)
}
const _postV1PurchaseInvoicesImport = async (url: string, request: Types.PostV1PurchaseInvoicesImportRequest): Promise<Types.PostV1PurchaseInvoicesImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseInvoicesImport: Api['postV1PurchaseInvoicesImport'] = async (request: Types.PostV1PurchaseInvoicesImportRequest): Promise<Types.PostV1PurchaseInvoicesImportResponses> => {
  return await _postV1PurchaseInvoicesImport(baseUrl, request)
}
const _getV1PurchaseInvoicesId = async (url: string, request: Types.GetV1PurchaseInvoicesIdRequest): Promise<Types.GetV1PurchaseInvoicesIdResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseInvoicesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseInvoicesId: Api['getV1PurchaseInvoicesId'] = async (request: Types.GetV1PurchaseInvoicesIdRequest): Promise<Types.GetV1PurchaseInvoicesIdResponses> => {
  return await _getV1PurchaseInvoicesId(baseUrl, request)
}
const _putV1PurchaseInvoicesId = async (url: string, request: Types.PutV1PurchaseInvoicesIdRequest): Promise<Types.PutV1PurchaseInvoicesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PurchaseInvoicesId: Api['putV1PurchaseInvoicesId'] = async (request: Types.PutV1PurchaseInvoicesIdRequest): Promise<Types.PutV1PurchaseInvoicesIdResponses> => {
  return await _putV1PurchaseInvoicesId(baseUrl, request)
}
const _deleteV1PurchaseInvoicesId = async (url: string, request: Types.DeleteV1PurchaseInvoicesIdRequest): Promise<Types.DeleteV1PurchaseInvoicesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PurchaseInvoicesId: Api['deleteV1PurchaseInvoicesId'] = async (request: Types.DeleteV1PurchaseInvoicesIdRequest): Promise<Types.DeleteV1PurchaseInvoicesIdResponses> => {
  return await _deleteV1PurchaseInvoicesId(baseUrl, request)
}
const _postV1PurchaseInvoicesItemEntry = async (url: string, request: Types.PostV1PurchaseInvoicesItemEntryRequest): Promise<Types.PostV1PurchaseInvoicesItemEntryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/item-entry/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseInvoicesItemEntry: Api['postV1PurchaseInvoicesItemEntry'] = async (request: Types.PostV1PurchaseInvoicesItemEntryRequest): Promise<Types.PostV1PurchaseInvoicesItemEntryResponses> => {
  return await _postV1PurchaseInvoicesItemEntry(baseUrl, request)
}
const _getV1PurchaseInvoicesItemEntryId = async (url: string, request: Types.GetV1PurchaseInvoicesItemEntryIdRequest): Promise<Types.GetV1PurchaseInvoicesItemEntryIdResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseInvoicesItemEntryIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/item-entry/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseInvoicesItemEntryId: Api['getV1PurchaseInvoicesItemEntryId'] = async (request: Types.GetV1PurchaseInvoicesItemEntryIdRequest): Promise<Types.GetV1PurchaseInvoicesItemEntryIdResponses> => {
  return await _getV1PurchaseInvoicesItemEntryId(baseUrl, request)
}
const _putV1PurchaseInvoicesItemEntryId = async (url: string, request: Types.PutV1PurchaseInvoicesItemEntryIdRequest): Promise<Types.PutV1PurchaseInvoicesItemEntryIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/item-entry/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PurchaseInvoicesItemEntryId: Api['putV1PurchaseInvoicesItemEntryId'] = async (request: Types.PutV1PurchaseInvoicesItemEntryIdRequest): Promise<Types.PutV1PurchaseInvoicesItemEntryIdResponses> => {
  return await _putV1PurchaseInvoicesItemEntryId(baseUrl, request)
}
const _deleteV1PurchaseInvoicesItemEntryId = async (url: string, request: Types.DeleteV1PurchaseInvoicesItemEntryIdRequest): Promise<Types.DeleteV1PurchaseInvoicesItemEntryIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/item-entry/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PurchaseInvoicesItemEntryId: Api['deleteV1PurchaseInvoicesItemEntryId'] = async (request: Types.DeleteV1PurchaseInvoicesItemEntryIdRequest): Promise<Types.DeleteV1PurchaseInvoicesItemEntryIdResponses> => {
  return await _deleteV1PurchaseInvoicesItemEntryId(baseUrl, request)
}
const _postV1PurchaseInvoicesExpenseEntry = async (url: string, request: Types.PostV1PurchaseInvoicesExpenseEntryRequest): Promise<Types.PostV1PurchaseInvoicesExpenseEntryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/expense-entry/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseInvoicesExpenseEntry: Api['postV1PurchaseInvoicesExpenseEntry'] = async (request: Types.PostV1PurchaseInvoicesExpenseEntryRequest): Promise<Types.PostV1PurchaseInvoicesExpenseEntryResponses> => {
  return await _postV1PurchaseInvoicesExpenseEntry(baseUrl, request)
}
const _getV1PurchaseInvoicesExpenseEntryId = async (url: string, request: Types.GetV1PurchaseInvoicesExpenseEntryIdRequest): Promise<Types.GetV1PurchaseInvoicesExpenseEntryIdResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseInvoicesExpenseEntryIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/expense-entry/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseInvoicesExpenseEntryId: Api['getV1PurchaseInvoicesExpenseEntryId'] = async (request: Types.GetV1PurchaseInvoicesExpenseEntryIdRequest): Promise<Types.GetV1PurchaseInvoicesExpenseEntryIdResponses> => {
  return await _getV1PurchaseInvoicesExpenseEntryId(baseUrl, request)
}
const _putV1PurchaseInvoicesExpenseEntryId = async (url: string, request: Types.PutV1PurchaseInvoicesExpenseEntryIdRequest): Promise<Types.PutV1PurchaseInvoicesExpenseEntryIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/expense-entry/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PurchaseInvoicesExpenseEntryId: Api['putV1PurchaseInvoicesExpenseEntryId'] = async (request: Types.PutV1PurchaseInvoicesExpenseEntryIdRequest): Promise<Types.PutV1PurchaseInvoicesExpenseEntryIdResponses> => {
  return await _putV1PurchaseInvoicesExpenseEntryId(baseUrl, request)
}
const _deleteV1PurchaseInvoicesExpenseEntryId = async (url: string, request: Types.DeleteV1PurchaseInvoicesExpenseEntryIdRequest): Promise<Types.DeleteV1PurchaseInvoicesExpenseEntryIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/expense-entry/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PurchaseInvoicesExpenseEntryId: Api['deleteV1PurchaseInvoicesExpenseEntryId'] = async (request: Types.DeleteV1PurchaseInvoicesExpenseEntryIdRequest): Promise<Types.DeleteV1PurchaseInvoicesExpenseEntryIdResponses> => {
  return await _deleteV1PurchaseInvoicesExpenseEntryId(baseUrl, request)
}
const _postV1PurchaseInvoicesAddApprover = async (url: string, request: Types.PostV1PurchaseInvoicesAddApproverRequest): Promise<Types.PostV1PurchaseInvoicesAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseInvoicesAddApprover: Api['postV1PurchaseInvoicesAddApprover'] = async (request: Types.PostV1PurchaseInvoicesAddApproverRequest): Promise<Types.PostV1PurchaseInvoicesAddApproverResponses> => {
  return await _postV1PurchaseInvoicesAddApprover(baseUrl, request)
}
const _putV1PurchaseInvoicesApprovalStatusId = async (url: string, request: Types.PutV1PurchaseInvoicesApprovalStatusIdRequest): Promise<Types.PutV1PurchaseInvoicesApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PurchaseInvoicesApprovalStatusId: Api['putV1PurchaseInvoicesApprovalStatusId'] = async (request: Types.PutV1PurchaseInvoicesApprovalStatusIdRequest): Promise<Types.PutV1PurchaseInvoicesApprovalStatusIdResponses> => {
  return await _putV1PurchaseInvoicesApprovalStatusId(baseUrl, request)
}
const _postV1PurchaseInvoicesAddRecurringDetails = async (url: string, request: Types.PostV1PurchaseInvoicesAddRecurringDetailsRequest): Promise<Types.PostV1PurchaseInvoicesAddRecurringDetailsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/add-recurring-details`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseInvoicesAddRecurringDetails: Api['postV1PurchaseInvoicesAddRecurringDetails'] = async (request: Types.PostV1PurchaseInvoicesAddRecurringDetailsRequest): Promise<Types.PostV1PurchaseInvoicesAddRecurringDetailsResponses> => {
  return await _postV1PurchaseInvoicesAddRecurringDetails(baseUrl, request)
}
const _getV1PurchaseInvoicesIdDownload = async (url: string, request: Types.GetV1PurchaseInvoicesIdDownloadRequest): Promise<Types.GetV1PurchaseInvoicesIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseInvoicesIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseInvoicesIdDownload: Api['getV1PurchaseInvoicesIdDownload'] = async (request: Types.GetV1PurchaseInvoicesIdDownloadRequest): Promise<Types.GetV1PurchaseInvoicesIdDownloadResponses> => {
  return await _getV1PurchaseInvoicesIdDownload(baseUrl, request)
}
const _getV1PurchaseInvoicesIdSendEmail = async (url: string, request: Types.GetV1PurchaseInvoicesIdSendEmailRequest): Promise<Types.GetV1PurchaseInvoicesIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseInvoicesIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseInvoicesIdSendEmail: Api['getV1PurchaseInvoicesIdSendEmail'] = async (request: Types.GetV1PurchaseInvoicesIdSendEmailRequest): Promise<Types.GetV1PurchaseInvoicesIdSendEmailResponses> => {
  return await _getV1PurchaseInvoicesIdSendEmail(baseUrl, request)
}
const _getV1PurchaseInvoicesGeneratePdf = async (url: string, request: Types.GetV1PurchaseInvoicesGeneratePdfRequest): Promise<Types.GetV1PurchaseInvoicesGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseInvoicesGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'columns', 'selectedRows']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseInvoicesGeneratePdf: Api['getV1PurchaseInvoicesGeneratePdf'] = async (request: Types.GetV1PurchaseInvoicesGeneratePdfRequest): Promise<Types.GetV1PurchaseInvoicesGeneratePdfResponses> => {
  return await _getV1PurchaseInvoicesGeneratePdf(baseUrl, request)
}
const _getV1PurchaseInvoicesGenerateExcel = async (url: string, request: Types.GetV1PurchaseInvoicesGenerateExcelRequest): Promise<Types.GetV1PurchaseInvoicesGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseInvoicesGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseInvoicesGenerateExcel: Api['getV1PurchaseInvoicesGenerateExcel'] = async (request: Types.GetV1PurchaseInvoicesGenerateExcelRequest): Promise<Types.GetV1PurchaseInvoicesGenerateExcelResponses> => {
  return await _getV1PurchaseInvoicesGenerateExcel(baseUrl, request)
}
const _getV1PurchaseInvoicesIdFetchAdvancePayment = async (url: string, request: Types.GetV1PurchaseInvoicesIdFetchAdvancePaymentRequest): Promise<Types.GetV1PurchaseInvoicesIdFetchAdvancePaymentResponses> => {
  const queryParameters: (keyof Types.GetV1PurchaseInvoicesIdFetchAdvancePaymentRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/${request['id']}/fetch-advance-payment?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PurchaseInvoicesIdFetchAdvancePayment: Api['getV1PurchaseInvoicesIdFetchAdvancePayment'] = async (request: Types.GetV1PurchaseInvoicesIdFetchAdvancePaymentRequest): Promise<Types.GetV1PurchaseInvoicesIdFetchAdvancePaymentResponses> => {
  return await _getV1PurchaseInvoicesIdFetchAdvancePayment(baseUrl, request)
}
const _postV1PurchaseInvoicesIdApplyAdvancePayment = async (url: string, request: Types.PostV1PurchaseInvoicesIdApplyAdvancePaymentRequest): Promise<Types.PostV1PurchaseInvoicesIdApplyAdvancePaymentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/purchase-invoices/${request['id']}/apply-advance-payment`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PurchaseInvoicesIdApplyAdvancePayment: Api['postV1PurchaseInvoicesIdApplyAdvancePayment'] = async (request: Types.PostV1PurchaseInvoicesIdApplyAdvancePaymentRequest): Promise<Types.PostV1PurchaseInvoicesIdApplyAdvancePaymentResponses> => {
  return await _postV1PurchaseInvoicesIdApplyAdvancePayment(baseUrl, request)
}
const _postV1Assets = async (url: string, request: Types.PostV1AssetsRequest): Promise<Types.PostV1AssetsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Assets: Api['postV1Assets'] = async (request: Types.PostV1AssetsRequest): Promise<Types.PostV1AssetsResponses> => {
  return await _postV1Assets(baseUrl, request)
}
const _getV1Assets = async (url: string, request: Types.GetV1AssetsRequest): Promise<Types.GetV1AssetsResponses> => {
  const queryParameters: (keyof Types.GetV1AssetsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Assets: Api['getV1Assets'] = async (request: Types.GetV1AssetsRequest): Promise<Types.GetV1AssetsResponses> => {
  return await _getV1Assets(baseUrl, request)
}
const _postV1AssetsImport = async (url: string, request: Types.PostV1AssetsImportRequest): Promise<Types.PostV1AssetsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AssetsImport: Api['postV1AssetsImport'] = async (request: Types.PostV1AssetsImportRequest): Promise<Types.PostV1AssetsImportResponses> => {
  return await _postV1AssetsImport(baseUrl, request)
}
const _getV1AssetsId = async (url: string, request: Types.GetV1AssetsIdRequest): Promise<Types.GetV1AssetsIdResponses> => {
  const queryParameters: (keyof Types.GetV1AssetsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetsId: Api['getV1AssetsId'] = async (request: Types.GetV1AssetsIdRequest): Promise<Types.GetV1AssetsIdResponses> => {
  return await _getV1AssetsId(baseUrl, request)
}
const _putV1AssetsId = async (url: string, request: Types.PutV1AssetsIdRequest): Promise<Types.PutV1AssetsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1AssetsId: Api['putV1AssetsId'] = async (request: Types.PutV1AssetsIdRequest): Promise<Types.PutV1AssetsIdResponses> => {
  return await _putV1AssetsId(baseUrl, request)
}
const _deleteV1AssetsId = async (url: string, request: Types.DeleteV1AssetsIdRequest): Promise<Types.DeleteV1AssetsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1AssetsId: Api['deleteV1AssetsId'] = async (request: Types.DeleteV1AssetsIdRequest): Promise<Types.DeleteV1AssetsIdResponses> => {
  return await _deleteV1AssetsId(baseUrl, request)
}
const _deleteV1AssetsDepreciationBoardsId = async (url: string, request: Types.DeleteV1AssetsDepreciationBoardsIdRequest): Promise<Types.DeleteV1AssetsDepreciationBoardsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/depreciation-boards/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1AssetsDepreciationBoardsId: Api['deleteV1AssetsDepreciationBoardsId'] = async (request: Types.DeleteV1AssetsDepreciationBoardsIdRequest): Promise<Types.DeleteV1AssetsDepreciationBoardsIdResponses> => {
  return await _deleteV1AssetsDepreciationBoardsId(baseUrl, request)
}
const _getV1AssetsFixedAssetAccounts = async (url: string, request: Types.GetV1AssetsFixedAssetAccountsRequest): Promise<Types.GetV1AssetsFixedAssetAccountsResponses> => {
  const queryParameters: (keyof Types.GetV1AssetsFixedAssetAccountsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/fixed-asset-accounts?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetsFixedAssetAccounts: Api['getV1AssetsFixedAssetAccounts'] = async (request: Types.GetV1AssetsFixedAssetAccountsRequest): Promise<Types.GetV1AssetsFixedAssetAccountsResponses> => {
  return await _getV1AssetsFixedAssetAccounts(baseUrl, request)
}
const _getV1AssetsDepreciationAccounts = async (url: string, request: Types.GetV1AssetsDepreciationAccountsRequest): Promise<Types.GetV1AssetsDepreciationAccountsResponses> => {
  const queryParameters: (keyof Types.GetV1AssetsDepreciationAccountsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/depreciation-accounts?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetsDepreciationAccounts: Api['getV1AssetsDepreciationAccounts'] = async (request: Types.GetV1AssetsDepreciationAccountsRequest): Promise<Types.GetV1AssetsDepreciationAccountsResponses> => {
  return await _getV1AssetsDepreciationAccounts(baseUrl, request)
}
const _getV1AssetsExpenseAccounts = async (url: string, request: Types.GetV1AssetsExpenseAccountsRequest): Promise<Types.GetV1AssetsExpenseAccountsResponses> => {
  const queryParameters: (keyof Types.GetV1AssetsExpenseAccountsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/expense-accounts?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetsExpenseAccounts: Api['getV1AssetsExpenseAccounts'] = async (request: Types.GetV1AssetsExpenseAccountsRequest): Promise<Types.GetV1AssetsExpenseAccountsResponses> => {
  return await _getV1AssetsExpenseAccounts(baseUrl, request)
}
const _getV1AssetsJournalTypes = async (url: string, request: Types.GetV1AssetsJournalTypesRequest): Promise<Types.GetV1AssetsJournalTypesResponses> => {
  const queryParameters: (keyof Types.GetV1AssetsJournalTypesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/journal-types?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetsJournalTypes: Api['getV1AssetsJournalTypes'] = async (request: Types.GetV1AssetsJournalTypesRequest): Promise<Types.GetV1AssetsJournalTypesResponses> => {
  return await _getV1AssetsJournalTypes(baseUrl, request)
}
const _getV1AssetsAssetTypes = async (url: string, request: Types.GetV1AssetsAssetTypesRequest): Promise<Types.GetV1AssetsAssetTypesResponses> => {
  const queryParameters: (keyof Types.GetV1AssetsAssetTypesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/asset-types?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetsAssetTypes: Api['getV1AssetsAssetTypes'] = async (request: Types.GetV1AssetsAssetTypesRequest): Promise<Types.GetV1AssetsAssetTypesResponses> => {
  return await _getV1AssetsAssetTypes(baseUrl, request)
}
const _getV1AssetsDepreciationBoards = async (url: string, request: Types.GetV1AssetsDepreciationBoardsRequest): Promise<Types.GetV1AssetsDepreciationBoardsResponses> => {
  const queryParameters: (keyof Types.GetV1AssetsDepreciationBoardsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/depreciation-boards?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetsDepreciationBoards: Api['getV1AssetsDepreciationBoards'] = async (request: Types.GetV1AssetsDepreciationBoardsRequest): Promise<Types.GetV1AssetsDepreciationBoardsResponses> => {
  return await _getV1AssetsDepreciationBoards(baseUrl, request)
}
const _postV1AssetsDisposalLogs = async (url: string, request: Types.PostV1AssetsDisposalLogsRequest): Promise<Types.PostV1AssetsDisposalLogsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/disposal-logs`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AssetsDisposalLogs: Api['postV1AssetsDisposalLogs'] = async (request: Types.PostV1AssetsDisposalLogsRequest): Promise<Types.PostV1AssetsDisposalLogsResponses> => {
  return await _postV1AssetsDisposalLogs(baseUrl, request)
}
const _postV1AssetsReevaluationLogs = async (url: string, request: Types.PostV1AssetsReevaluationLogsRequest): Promise<Types.PostV1AssetsReevaluationLogsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/reevaluation-logs`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AssetsReevaluationLogs: Api['postV1AssetsReevaluationLogs'] = async (request: Types.PostV1AssetsReevaluationLogsRequest): Promise<Types.PostV1AssetsReevaluationLogsResponses> => {
  return await _postV1AssetsReevaluationLogs(baseUrl, request)
}
const _postV1AssetsDevaluationLogs = async (url: string, request: Types.PostV1AssetsDevaluationLogsRequest): Promise<Types.PostV1AssetsDevaluationLogsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/devaluation-logs`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AssetsDevaluationLogs: Api['postV1AssetsDevaluationLogs'] = async (request: Types.PostV1AssetsDevaluationLogsRequest): Promise<Types.PostV1AssetsDevaluationLogsResponses> => {
  return await _postV1AssetsDevaluationLogs(baseUrl, request)
}
const _deleteV1AssetsInsuranceEntryId = async (url: string, request: Types.DeleteV1AssetsInsuranceEntryIdRequest): Promise<Types.DeleteV1AssetsInsuranceEntryIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/insurance-entry/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1AssetsInsuranceEntryId: Api['deleteV1AssetsInsuranceEntryId'] = async (request: Types.DeleteV1AssetsInsuranceEntryIdRequest): Promise<Types.DeleteV1AssetsInsuranceEntryIdResponses> => {
  return await _deleteV1AssetsInsuranceEntryId(baseUrl, request)
}
const _getV1AssetsGenerateExcel = async (url: string, request: Types.GetV1AssetsGenerateExcelRequest): Promise<Types.GetV1AssetsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1AssetsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetsGenerateExcel: Api['getV1AssetsGenerateExcel'] = async (request: Types.GetV1AssetsGenerateExcelRequest): Promise<Types.GetV1AssetsGenerateExcelResponses> => {
  return await _getV1AssetsGenerateExcel(baseUrl, request)
}
const _getV1AssetsGeneratePdf = async (url: string, request: Types.GetV1AssetsGeneratePdfRequest): Promise<Types.GetV1AssetsGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1AssetsGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetsGeneratePdf: Api['getV1AssetsGeneratePdf'] = async (request: Types.GetV1AssetsGeneratePdfRequest): Promise<Types.GetV1AssetsGeneratePdfResponses> => {
  return await _getV1AssetsGeneratePdf(baseUrl, request)
}
const _postV1AssetsNextSequence = async (url: string, request: Types.PostV1AssetsNextSequenceRequest): Promise<Types.PostV1AssetsNextSequenceResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/next-sequence`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AssetsNextSequence: Api['postV1AssetsNextSequence'] = async (request: Types.PostV1AssetsNextSequenceRequest): Promise<Types.PostV1AssetsNextSequenceResponses> => {
  return await _postV1AssetsNextSequence(baseUrl, request)
}
const _postV1AssetsCheckUniqueness = async (url: string, request: Types.PostV1AssetsCheckUniquenessRequest): Promise<Types.PostV1AssetsCheckUniquenessResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets/check-uniqueness`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AssetsCheckUniqueness: Api['postV1AssetsCheckUniqueness'] = async (request: Types.PostV1AssetsCheckUniquenessRequest): Promise<Types.PostV1AssetsCheckUniquenessResponses> => {
  return await _postV1AssetsCheckUniqueness(baseUrl, request)
}
const _postV1AssetsTransfer = async (url: string, request: Types.PostV1AssetsTransferRequest): Promise<Types.PostV1AssetsTransferResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets-transfer/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AssetsTransfer: Api['postV1AssetsTransfer'] = async (request: Types.PostV1AssetsTransferRequest): Promise<Types.PostV1AssetsTransferResponses> => {
  return await _postV1AssetsTransfer(baseUrl, request)
}
const _getV1AssetsTransfer = async (url: string, request: Types.GetV1AssetsTransferRequest): Promise<Types.GetV1AssetsTransferResponses> => {
  const queryParameters: (keyof Types.GetV1AssetsTransferRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets-transfer/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetsTransfer: Api['getV1AssetsTransfer'] = async (request: Types.GetV1AssetsTransferRequest): Promise<Types.GetV1AssetsTransferResponses> => {
  return await _getV1AssetsTransfer(baseUrl, request)
}
const _getV1AssetsTransferId = async (url: string, request: Types.GetV1AssetsTransferIdRequest): Promise<Types.GetV1AssetsTransferIdResponses> => {
  const queryParameters: (keyof Types.GetV1AssetsTransferIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets-transfer/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetsTransferId: Api['getV1AssetsTransferId'] = async (request: Types.GetV1AssetsTransferIdRequest): Promise<Types.GetV1AssetsTransferIdResponses> => {
  return await _getV1AssetsTransferId(baseUrl, request)
}
const _putV1AssetsTransferId = async (url: string, request: Types.PutV1AssetsTransferIdRequest): Promise<Types.PutV1AssetsTransferIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets-transfer/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1AssetsTransferId: Api['putV1AssetsTransferId'] = async (request: Types.PutV1AssetsTransferIdRequest): Promise<Types.PutV1AssetsTransferIdResponses> => {
  return await _putV1AssetsTransferId(baseUrl, request)
}
const _deleteV1AssetsTransferId = async (url: string, request: Types.DeleteV1AssetsTransferIdRequest): Promise<Types.DeleteV1AssetsTransferIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets-transfer/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1AssetsTransferId: Api['deleteV1AssetsTransferId'] = async (request: Types.DeleteV1AssetsTransferIdRequest): Promise<Types.DeleteV1AssetsTransferIdResponses> => {
  return await _deleteV1AssetsTransferId(baseUrl, request)
}
const _postV1AssetsTransferAddApprover = async (url: string, request: Types.PostV1AssetsTransferAddApproverRequest): Promise<Types.PostV1AssetsTransferAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets-transfer/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AssetsTransferAddApprover: Api['postV1AssetsTransferAddApprover'] = async (request: Types.PostV1AssetsTransferAddApproverRequest): Promise<Types.PostV1AssetsTransferAddApproverResponses> => {
  return await _postV1AssetsTransferAddApprover(baseUrl, request)
}
const _putV1AssetsTransferApprovalStatusId = async (url: string, request: Types.PutV1AssetsTransferApprovalStatusIdRequest): Promise<Types.PutV1AssetsTransferApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets-transfer/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1AssetsTransferApprovalStatusId: Api['putV1AssetsTransferApprovalStatusId'] = async (request: Types.PutV1AssetsTransferApprovalStatusIdRequest): Promise<Types.PutV1AssetsTransferApprovalStatusIdResponses> => {
  return await _putV1AssetsTransferApprovalStatusId(baseUrl, request)
}
const _getV1AssetsTransferGenerateExcel = async (url: string, request: Types.GetV1AssetsTransferGenerateExcelRequest): Promise<Types.GetV1AssetsTransferGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1AssetsTransferGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets-transfer/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetsTransferGenerateExcel: Api['getV1AssetsTransferGenerateExcel'] = async (request: Types.GetV1AssetsTransferGenerateExcelRequest): Promise<Types.GetV1AssetsTransferGenerateExcelResponses> => {
  return await _getV1AssetsTransferGenerateExcel(baseUrl, request)
}
const _getV1AssetsTransferGeneratePdf = async (url: string, request: Types.GetV1AssetsTransferGeneratePdfRequest): Promise<Types.GetV1AssetsTransferGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1AssetsTransferGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/assets-transfer/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1AssetsTransferGeneratePdf: Api['getV1AssetsTransferGeneratePdf'] = async (request: Types.GetV1AssetsTransferGeneratePdfRequest): Promise<Types.GetV1AssetsTransferGeneratePdfResponses> => {
  return await _getV1AssetsTransferGeneratePdf(baseUrl, request)
}
const _postV1ExpenseReimbursement = async (url: string, request: Types.PostV1ExpenseReimbursementRequest): Promise<Types.PostV1ExpenseReimbursementResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/expense-reimbursement/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ExpenseReimbursement: Api['postV1ExpenseReimbursement'] = async (request: Types.PostV1ExpenseReimbursementRequest): Promise<Types.PostV1ExpenseReimbursementResponses> => {
  return await _postV1ExpenseReimbursement(baseUrl, request)
}
const _getV1ExpenseReimbursement = async (url: string, request: Types.GetV1ExpenseReimbursementRequest): Promise<Types.GetV1ExpenseReimbursementResponses> => {
  const queryParameters: (keyof Types.GetV1ExpenseReimbursementRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/expense-reimbursement/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ExpenseReimbursement: Api['getV1ExpenseReimbursement'] = async (request: Types.GetV1ExpenseReimbursementRequest): Promise<Types.GetV1ExpenseReimbursementResponses> => {
  return await _getV1ExpenseReimbursement(baseUrl, request)
}
const _getV1ExpenseReimbursementId = async (url: string, request: Types.GetV1ExpenseReimbursementIdRequest): Promise<Types.GetV1ExpenseReimbursementIdResponses> => {
  const queryParameters: (keyof Types.GetV1ExpenseReimbursementIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/expense-reimbursement/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ExpenseReimbursementId: Api['getV1ExpenseReimbursementId'] = async (request: Types.GetV1ExpenseReimbursementIdRequest): Promise<Types.GetV1ExpenseReimbursementIdResponses> => {
  return await _getV1ExpenseReimbursementId(baseUrl, request)
}
const _deleteV1ExpenseReimbursementId = async (url: string, request: Types.DeleteV1ExpenseReimbursementIdRequest): Promise<Types.DeleteV1ExpenseReimbursementIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/expense-reimbursement/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ExpenseReimbursementId: Api['deleteV1ExpenseReimbursementId'] = async (request: Types.DeleteV1ExpenseReimbursementIdRequest): Promise<Types.DeleteV1ExpenseReimbursementIdResponses> => {
  return await _deleteV1ExpenseReimbursementId(baseUrl, request)
}
const _putV1ExpenseReimbursementId = async (url: string, request: Types.PutV1ExpenseReimbursementIdRequest): Promise<Types.PutV1ExpenseReimbursementIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/expense-reimbursement/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ExpenseReimbursementId: Api['putV1ExpenseReimbursementId'] = async (request: Types.PutV1ExpenseReimbursementIdRequest): Promise<Types.PutV1ExpenseReimbursementIdResponses> => {
  return await _putV1ExpenseReimbursementId(baseUrl, request)
}
const _getV1ExpenseReimbursementExpenseCategories = async (url: string, request: Types.GetV1ExpenseReimbursementExpenseCategoriesRequest): Promise<Types.GetV1ExpenseReimbursementExpenseCategoriesResponses> => {
  const queryParameters: (keyof Types.GetV1ExpenseReimbursementExpenseCategoriesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/expense-reimbursement/expense-categories?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ExpenseReimbursementExpenseCategories: Api['getV1ExpenseReimbursementExpenseCategories'] = async (request: Types.GetV1ExpenseReimbursementExpenseCategoriesRequest): Promise<Types.GetV1ExpenseReimbursementExpenseCategoriesResponses> => {
  return await _getV1ExpenseReimbursementExpenseCategories(baseUrl, request)
}
const _getV1ExpenseReimbursementEmployees = async (url: string, request: Types.GetV1ExpenseReimbursementEmployeesRequest): Promise<Types.GetV1ExpenseReimbursementEmployeesResponses> => {
  const queryParameters: (keyof Types.GetV1ExpenseReimbursementEmployeesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/expense-reimbursement/employees?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ExpenseReimbursementEmployees: Api['getV1ExpenseReimbursementEmployees'] = async (request: Types.GetV1ExpenseReimbursementEmployeesRequest): Promise<Types.GetV1ExpenseReimbursementEmployeesResponses> => {
  return await _getV1ExpenseReimbursementEmployees(baseUrl, request)
}
const _postV1ExpenseReimbursementAddApprover = async (url: string, request: Types.PostV1ExpenseReimbursementAddApproverRequest): Promise<Types.PostV1ExpenseReimbursementAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/expense-reimbursement/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ExpenseReimbursementAddApprover: Api['postV1ExpenseReimbursementAddApprover'] = async (request: Types.PostV1ExpenseReimbursementAddApproverRequest): Promise<Types.PostV1ExpenseReimbursementAddApproverResponses> => {
  return await _postV1ExpenseReimbursementAddApprover(baseUrl, request)
}
const _putV1ExpenseReimbursementApprovalStatusId = async (url: string, request: Types.PutV1ExpenseReimbursementApprovalStatusIdRequest): Promise<Types.PutV1ExpenseReimbursementApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/expense-reimbursement/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ExpenseReimbursementApprovalStatusId: Api['putV1ExpenseReimbursementApprovalStatusId'] = async (request: Types.PutV1ExpenseReimbursementApprovalStatusIdRequest): Promise<Types.PutV1ExpenseReimbursementApprovalStatusIdResponses> => {
  return await _putV1ExpenseReimbursementApprovalStatusId(baseUrl, request)
}
const _getV1ExpenseReimbursementIdDownload = async (url: string, request: Types.GetV1ExpenseReimbursementIdDownloadRequest): Promise<Types.GetV1ExpenseReimbursementIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1ExpenseReimbursementIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/expense-reimbursement/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ExpenseReimbursementIdDownload: Api['getV1ExpenseReimbursementIdDownload'] = async (request: Types.GetV1ExpenseReimbursementIdDownloadRequest): Promise<Types.GetV1ExpenseReimbursementIdDownloadResponses> => {
  return await _getV1ExpenseReimbursementIdDownload(baseUrl, request)
}
const _getV1ExpenseReimbursementIdDisallowedExpenseDownload = async (url: string, request: Types.GetV1ExpenseReimbursementIdDisallowedExpenseDownloadRequest): Promise<Types.GetV1ExpenseReimbursementIdDisallowedExpenseDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1ExpenseReimbursementIdDisallowedExpenseDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/expense-reimbursement/${request['id']}/disallowed-expense/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ExpenseReimbursementIdDisallowedExpenseDownload: Api['getV1ExpenseReimbursementIdDisallowedExpenseDownload'] = async (request: Types.GetV1ExpenseReimbursementIdDisallowedExpenseDownloadRequest): Promise<Types.GetV1ExpenseReimbursementIdDisallowedExpenseDownloadResponses> => {
  return await _getV1ExpenseReimbursementIdDisallowedExpenseDownload(baseUrl, request)
}
const _getV1ExpenseReimbursementGenerateExcel = async (url: string, request: Types.GetV1ExpenseReimbursementGenerateExcelRequest): Promise<Types.GetV1ExpenseReimbursementGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1ExpenseReimbursementGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/expense-reimbursement/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ExpenseReimbursementGenerateExcel: Api['getV1ExpenseReimbursementGenerateExcel'] = async (request: Types.GetV1ExpenseReimbursementGenerateExcelRequest): Promise<Types.GetV1ExpenseReimbursementGenerateExcelResponses> => {
  return await _getV1ExpenseReimbursementGenerateExcel(baseUrl, request)
}
const _getV1ExpenseReimbursementGeneratePdf = async (url: string, request: Types.GetV1ExpenseReimbursementGeneratePdfRequest): Promise<Types.GetV1ExpenseReimbursementGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1ExpenseReimbursementGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/expense-reimbursement/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ExpenseReimbursementGeneratePdf: Api['getV1ExpenseReimbursementGeneratePdf'] = async (request: Types.GetV1ExpenseReimbursementGeneratePdfRequest): Promise<Types.GetV1ExpenseReimbursementGeneratePdfResponses> => {
  return await _getV1ExpenseReimbursementGeneratePdf(baseUrl, request)
}
const _postV1Budget = async (url: string, request: Types.PostV1BudgetRequest): Promise<Types.PostV1BudgetResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/budget/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Budget: Api['postV1Budget'] = async (request: Types.PostV1BudgetRequest): Promise<Types.PostV1BudgetResponses> => {
  return await _postV1Budget(baseUrl, request)
}
const _getV1Budget = async (url: string, request: Types.GetV1BudgetRequest): Promise<Types.GetV1BudgetResponses> => {
  const queryParameters: (keyof Types.GetV1BudgetRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/budget/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Budget: Api['getV1Budget'] = async (request: Types.GetV1BudgetRequest): Promise<Types.GetV1BudgetResponses> => {
  return await _getV1Budget(baseUrl, request)
}
const _getV1BudgetId = async (url: string, request: Types.GetV1BudgetIdRequest): Promise<Types.GetV1BudgetIdResponses> => {
  const queryParameters: (keyof Types.GetV1BudgetIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/budget/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BudgetId: Api['getV1BudgetId'] = async (request: Types.GetV1BudgetIdRequest): Promise<Types.GetV1BudgetIdResponses> => {
  return await _getV1BudgetId(baseUrl, request)
}
const _putV1BudgetId = async (url: string, request: Types.PutV1BudgetIdRequest): Promise<Types.PutV1BudgetIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/budget/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1BudgetId: Api['putV1BudgetId'] = async (request: Types.PutV1BudgetIdRequest): Promise<Types.PutV1BudgetIdResponses> => {
  return await _putV1BudgetId(baseUrl, request)
}
const _deleteV1BudgetId = async (url: string, request: Types.DeleteV1BudgetIdRequest): Promise<Types.DeleteV1BudgetIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/budget/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1BudgetId: Api['deleteV1BudgetId'] = async (request: Types.DeleteV1BudgetIdRequest): Promise<Types.DeleteV1BudgetIdResponses> => {
  return await _deleteV1BudgetId(baseUrl, request)
}
const _getV1BudgetBudgetTypes = async (url: string, request: Types.GetV1BudgetBudgetTypesRequest): Promise<Types.GetV1BudgetBudgetTypesResponses> => {
  const queryParameters: (keyof Types.GetV1BudgetBudgetTypesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/budget/budget-types?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BudgetBudgetTypes: Api['getV1BudgetBudgetTypes'] = async (request: Types.GetV1BudgetBudgetTypesRequest): Promise<Types.GetV1BudgetBudgetTypesResponses> => {
  return await _getV1BudgetBudgetTypes(baseUrl, request)
}
const _getV1BudgetBudgetMonths = async (url: string, request: Types.GetV1BudgetBudgetMonthsRequest): Promise<Types.GetV1BudgetBudgetMonthsResponses> => {
  const queryParameters: (keyof Types.GetV1BudgetBudgetMonthsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/budget/budget-months?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BudgetBudgetMonths: Api['getV1BudgetBudgetMonths'] = async (request: Types.GetV1BudgetBudgetMonthsRequest): Promise<Types.GetV1BudgetBudgetMonthsResponses> => {
  return await _getV1BudgetBudgetMonths(baseUrl, request)
}
const _postV1BudgetAddApprover = async (url: string, request: Types.PostV1BudgetAddApproverRequest): Promise<Types.PostV1BudgetAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/budget/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1BudgetAddApprover: Api['postV1BudgetAddApprover'] = async (request: Types.PostV1BudgetAddApproverRequest): Promise<Types.PostV1BudgetAddApproverResponses> => {
  return await _postV1BudgetAddApprover(baseUrl, request)
}
const _putV1BudgetApprovalStatusId = async (url: string, request: Types.PutV1BudgetApprovalStatusIdRequest): Promise<Types.PutV1BudgetApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/budget/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1BudgetApprovalStatusId: Api['putV1BudgetApprovalStatusId'] = async (request: Types.PutV1BudgetApprovalStatusIdRequest): Promise<Types.PutV1BudgetApprovalStatusIdResponses> => {
  return await _putV1BudgetApprovalStatusId(baseUrl, request)
}
const _getV1BudgetBudgetComparisonId = async (url: string, request: Types.GetV1BudgetBudgetComparisonIdRequest): Promise<Types.GetV1BudgetBudgetComparisonIdResponses> => {
  const queryParameters: (keyof Types.GetV1BudgetBudgetComparisonIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/budget/budget-comparison/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BudgetBudgetComparisonId: Api['getV1BudgetBudgetComparisonId'] = async (request: Types.GetV1BudgetBudgetComparisonIdRequest): Promise<Types.GetV1BudgetBudgetComparisonIdResponses> => {
  return await _getV1BudgetBudgetComparisonId(baseUrl, request)
}
const _getV1BudgetGenerateExcel = async (url: string, request: Types.GetV1BudgetGenerateExcelRequest): Promise<Types.GetV1BudgetGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1BudgetGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/budget/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BudgetGenerateExcel: Api['getV1BudgetGenerateExcel'] = async (request: Types.GetV1BudgetGenerateExcelRequest): Promise<Types.GetV1BudgetGenerateExcelResponses> => {
  return await _getV1BudgetGenerateExcel(baseUrl, request)
}
const _getV1BudgetGeneratePdf = async (url: string, request: Types.GetV1BudgetGeneratePdfRequest): Promise<Types.GetV1BudgetGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1BudgetGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/budget/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BudgetGeneratePdf: Api['getV1BudgetGeneratePdf'] = async (request: Types.GetV1BudgetGeneratePdfRequest): Promise<Types.GetV1BudgetGeneratePdfResponses> => {
  return await _getV1BudgetGeneratePdf(baseUrl, request)
}
const _getV1FileUpload = async (url: string, request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  const queryParameters: (keyof Types.GetV1FileUploadRequest)[]  = ['key', 'mimeType', 'partCount']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['file-size'] !== undefined) {
    headers['file-size'] = request['file-size']
    delete request['file-size']
  }

  const response = await fetch(`${url}/v1/file-upload/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FileUpload: Api['getV1FileUpload'] = async (request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  return await _getV1FileUpload(baseUrl, request)
}
const _postV1FileUploadMarkComplete = async (url: string, request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/file-upload/mark-complete`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1FileUploadMarkComplete: Api['postV1FileUploadMarkComplete'] = async (request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  return await _postV1FileUploadMarkComplete(baseUrl, request)
}
const _postV1CreditNotes = async (url: string, request: Types.PostV1CreditNotesRequest): Promise<Types.PostV1CreditNotesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CreditNotes: Api['postV1CreditNotes'] = async (request: Types.PostV1CreditNotesRequest): Promise<Types.PostV1CreditNotesResponses> => {
  return await _postV1CreditNotes(baseUrl, request)
}
const _getV1CreditNotes = async (url: string, request: Types.GetV1CreditNotesRequest): Promise<Types.GetV1CreditNotesResponses> => {
  const queryParameters: (keyof Types.GetV1CreditNotesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CreditNotes: Api['getV1CreditNotes'] = async (request: Types.GetV1CreditNotesRequest): Promise<Types.GetV1CreditNotesResponses> => {
  return await _getV1CreditNotes(baseUrl, request)
}
const _postV1CreditNotesImport = async (url: string, request: Types.PostV1CreditNotesImportRequest): Promise<Types.PostV1CreditNotesImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CreditNotesImport: Api['postV1CreditNotesImport'] = async (request: Types.PostV1CreditNotesImportRequest): Promise<Types.PostV1CreditNotesImportResponses> => {
  return await _postV1CreditNotesImport(baseUrl, request)
}
const _getV1CreditNotesId = async (url: string, request: Types.GetV1CreditNotesIdRequest): Promise<Types.GetV1CreditNotesIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CreditNotesId: Api['getV1CreditNotesId'] = async (request: Types.GetV1CreditNotesIdRequest): Promise<Types.GetV1CreditNotesIdResponses> => {
  return await _getV1CreditNotesId(baseUrl, request)
}
const _putV1CreditNotesId = async (url: string, request: Types.PutV1CreditNotesIdRequest): Promise<Types.PutV1CreditNotesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CreditNotesId: Api['putV1CreditNotesId'] = async (request: Types.PutV1CreditNotesIdRequest): Promise<Types.PutV1CreditNotesIdResponses> => {
  return await _putV1CreditNotesId(baseUrl, request)
}
const _deleteV1CreditNotesId = async (url: string, request: Types.DeleteV1CreditNotesIdRequest): Promise<Types.DeleteV1CreditNotesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CreditNotesId: Api['deleteV1CreditNotesId'] = async (request: Types.DeleteV1CreditNotesIdRequest): Promise<Types.DeleteV1CreditNotesIdResponses> => {
  return await _deleteV1CreditNotesId(baseUrl, request)
}
const _postV1CreditNotesItemEntries = async (url: string, request: Types.PostV1CreditNotesItemEntriesRequest): Promise<Types.PostV1CreditNotesItemEntriesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/item-entries`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CreditNotesItemEntries: Api['postV1CreditNotesItemEntries'] = async (request: Types.PostV1CreditNotesItemEntriesRequest): Promise<Types.PostV1CreditNotesItemEntriesResponses> => {
  return await _postV1CreditNotesItemEntries(baseUrl, request)
}
const _getV1CreditNotesItemEntriesId = async (url: string, request: Types.GetV1CreditNotesItemEntriesIdRequest): Promise<Types.GetV1CreditNotesItemEntriesIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/item-entries/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CreditNotesItemEntriesId: Api['getV1CreditNotesItemEntriesId'] = async (request: Types.GetV1CreditNotesItemEntriesIdRequest): Promise<Types.GetV1CreditNotesItemEntriesIdResponses> => {
  return await _getV1CreditNotesItemEntriesId(baseUrl, request)
}
const _putV1CreditNotesItemEntriesId = async (url: string, request: Types.PutV1CreditNotesItemEntriesIdRequest): Promise<Types.PutV1CreditNotesItemEntriesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/item-entries/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CreditNotesItemEntriesId: Api['putV1CreditNotesItemEntriesId'] = async (request: Types.PutV1CreditNotesItemEntriesIdRequest): Promise<Types.PutV1CreditNotesItemEntriesIdResponses> => {
  return await _putV1CreditNotesItemEntriesId(baseUrl, request)
}
const _deleteV1CreditNotesItemEntriesId = async (url: string, request: Types.DeleteV1CreditNotesItemEntriesIdRequest): Promise<Types.DeleteV1CreditNotesItemEntriesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/item-entries/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CreditNotesItemEntriesId: Api['deleteV1CreditNotesItemEntriesId'] = async (request: Types.DeleteV1CreditNotesItemEntriesIdRequest): Promise<Types.DeleteV1CreditNotesItemEntriesIdResponses> => {
  return await _deleteV1CreditNotesItemEntriesId(baseUrl, request)
}
const _postV1CreditNotesExpenseEntries = async (url: string, request: Types.PostV1CreditNotesExpenseEntriesRequest): Promise<Types.PostV1CreditNotesExpenseEntriesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/expense-entries`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CreditNotesExpenseEntries: Api['postV1CreditNotesExpenseEntries'] = async (request: Types.PostV1CreditNotesExpenseEntriesRequest): Promise<Types.PostV1CreditNotesExpenseEntriesResponses> => {
  return await _postV1CreditNotesExpenseEntries(baseUrl, request)
}
const _getV1CreditNotesExpenseEntriesId = async (url: string, request: Types.GetV1CreditNotesExpenseEntriesIdRequest): Promise<Types.GetV1CreditNotesExpenseEntriesIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/expense-entries/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CreditNotesExpenseEntriesId: Api['getV1CreditNotesExpenseEntriesId'] = async (request: Types.GetV1CreditNotesExpenseEntriesIdRequest): Promise<Types.GetV1CreditNotesExpenseEntriesIdResponses> => {
  return await _getV1CreditNotesExpenseEntriesId(baseUrl, request)
}
const _putV1CreditNotesExpenseEntriesId = async (url: string, request: Types.PutV1CreditNotesExpenseEntriesIdRequest): Promise<Types.PutV1CreditNotesExpenseEntriesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/expense-entries/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CreditNotesExpenseEntriesId: Api['putV1CreditNotesExpenseEntriesId'] = async (request: Types.PutV1CreditNotesExpenseEntriesIdRequest): Promise<Types.PutV1CreditNotesExpenseEntriesIdResponses> => {
  return await _putV1CreditNotesExpenseEntriesId(baseUrl, request)
}
const _deleteV1CreditNotesExpenseEntriesId = async (url: string, request: Types.DeleteV1CreditNotesExpenseEntriesIdRequest): Promise<Types.DeleteV1CreditNotesExpenseEntriesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/expense-entries/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CreditNotesExpenseEntriesId: Api['deleteV1CreditNotesExpenseEntriesId'] = async (request: Types.DeleteV1CreditNotesExpenseEntriesIdRequest): Promise<Types.DeleteV1CreditNotesExpenseEntriesIdResponses> => {
  return await _deleteV1CreditNotesExpenseEntriesId(baseUrl, request)
}
const _postV1CreditNotesInvoiceDetails = async (url: string, request: Types.PostV1CreditNotesInvoiceDetailsRequest): Promise<Types.PostV1CreditNotesInvoiceDetailsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/invoice-details`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CreditNotesInvoiceDetails: Api['postV1CreditNotesInvoiceDetails'] = async (request: Types.PostV1CreditNotesInvoiceDetailsRequest): Promise<Types.PostV1CreditNotesInvoiceDetailsResponses> => {
  return await _postV1CreditNotesInvoiceDetails(baseUrl, request)
}
const _postV1CreditNotesAddApprover = async (url: string, request: Types.PostV1CreditNotesAddApproverRequest): Promise<Types.PostV1CreditNotesAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CreditNotesAddApprover: Api['postV1CreditNotesAddApprover'] = async (request: Types.PostV1CreditNotesAddApproverRequest): Promise<Types.PostV1CreditNotesAddApproverResponses> => {
  return await _postV1CreditNotesAddApprover(baseUrl, request)
}
const _putV1CreditNotesApprovalStatusId = async (url: string, request: Types.PutV1CreditNotesApprovalStatusIdRequest): Promise<Types.PutV1CreditNotesApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CreditNotesApprovalStatusId: Api['putV1CreditNotesApprovalStatusId'] = async (request: Types.PutV1CreditNotesApprovalStatusIdRequest): Promise<Types.PutV1CreditNotesApprovalStatusIdResponses> => {
  return await _putV1CreditNotesApprovalStatusId(baseUrl, request)
}
const _getV1CreditNotesCustomerInvoiceId = async (url: string, request: Types.GetV1CreditNotesCustomerInvoiceIdRequest): Promise<Types.GetV1CreditNotesCustomerInvoiceIdResponses> => {
  const queryParameters: (keyof Types.GetV1CreditNotesCustomerInvoiceIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/customer-invoice/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CreditNotesCustomerInvoiceId: Api['getV1CreditNotesCustomerInvoiceId'] = async (request: Types.GetV1CreditNotesCustomerInvoiceIdRequest): Promise<Types.GetV1CreditNotesCustomerInvoiceIdResponses> => {
  return await _getV1CreditNotesCustomerInvoiceId(baseUrl, request)
}
const _getV1CreditNotesVoidId = async (url: string, request: Types.GetV1CreditNotesVoidIdRequest): Promise<Types.GetV1CreditNotesVoidIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/void/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CreditNotesVoidId: Api['getV1CreditNotesVoidId'] = async (request: Types.GetV1CreditNotesVoidIdRequest): Promise<Types.GetV1CreditNotesVoidIdResponses> => {
  return await _getV1CreditNotesVoidId(baseUrl, request)
}
const _getV1CreditNotesIdDownload = async (url: string, request: Types.GetV1CreditNotesIdDownloadRequest): Promise<Types.GetV1CreditNotesIdDownloadResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/${request['id']}/download`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CreditNotesIdDownload: Api['getV1CreditNotesIdDownload'] = async (request: Types.GetV1CreditNotesIdDownloadRequest): Promise<Types.GetV1CreditNotesIdDownloadResponses> => {
  return await _getV1CreditNotesIdDownload(baseUrl, request)
}
const _getV1CreditNotesGenerateExcel = async (url: string, request: Types.GetV1CreditNotesGenerateExcelRequest): Promise<Types.GetV1CreditNotesGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CreditNotesGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CreditNotesGenerateExcel: Api['getV1CreditNotesGenerateExcel'] = async (request: Types.GetV1CreditNotesGenerateExcelRequest): Promise<Types.GetV1CreditNotesGenerateExcelResponses> => {
  return await _getV1CreditNotesGenerateExcel(baseUrl, request)
}
const _getV1CreditNotesGeneratePdf = async (url: string, request: Types.GetV1CreditNotesGeneratePdfRequest): Promise<Types.GetV1CreditNotesGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1CreditNotesGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/credit-notes/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CreditNotesGeneratePdf: Api['getV1CreditNotesGeneratePdf'] = async (request: Types.GetV1CreditNotesGeneratePdfRequest): Promise<Types.GetV1CreditNotesGeneratePdfResponses> => {
  return await _getV1CreditNotesGeneratePdf(baseUrl, request)
}
const _postV1DebitNotes = async (url: string, request: Types.PostV1DebitNotesRequest): Promise<Types.PostV1DebitNotesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DebitNotes: Api['postV1DebitNotes'] = async (request: Types.PostV1DebitNotesRequest): Promise<Types.PostV1DebitNotesResponses> => {
  return await _postV1DebitNotes(baseUrl, request)
}
const _getV1DebitNotes = async (url: string, request: Types.GetV1DebitNotesRequest): Promise<Types.GetV1DebitNotesResponses> => {
  const queryParameters: (keyof Types.GetV1DebitNotesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DebitNotes: Api['getV1DebitNotes'] = async (request: Types.GetV1DebitNotesRequest): Promise<Types.GetV1DebitNotesResponses> => {
  return await _getV1DebitNotes(baseUrl, request)
}
const _postV1DebitNotesImport = async (url: string, request: Types.PostV1DebitNotesImportRequest): Promise<Types.PostV1DebitNotesImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DebitNotesImport: Api['postV1DebitNotesImport'] = async (request: Types.PostV1DebitNotesImportRequest): Promise<Types.PostV1DebitNotesImportResponses> => {
  return await _postV1DebitNotesImport(baseUrl, request)
}
const _getV1DebitNotesId = async (url: string, request: Types.GetV1DebitNotesIdRequest): Promise<Types.GetV1DebitNotesIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DebitNotesId: Api['getV1DebitNotesId'] = async (request: Types.GetV1DebitNotesIdRequest): Promise<Types.GetV1DebitNotesIdResponses> => {
  return await _getV1DebitNotesId(baseUrl, request)
}
const _putV1DebitNotesId = async (url: string, request: Types.PutV1DebitNotesIdRequest): Promise<Types.PutV1DebitNotesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DebitNotesId: Api['putV1DebitNotesId'] = async (request: Types.PutV1DebitNotesIdRequest): Promise<Types.PutV1DebitNotesIdResponses> => {
  return await _putV1DebitNotesId(baseUrl, request)
}
const _deleteV1DebitNotesId = async (url: string, request: Types.DeleteV1DebitNotesIdRequest): Promise<Types.DeleteV1DebitNotesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DebitNotesId: Api['deleteV1DebitNotesId'] = async (request: Types.DeleteV1DebitNotesIdRequest): Promise<Types.DeleteV1DebitNotesIdResponses> => {
  return await _deleteV1DebitNotesId(baseUrl, request)
}
const _postV1DebitNotesItemEntries = async (url: string, request: Types.PostV1DebitNotesItemEntriesRequest): Promise<Types.PostV1DebitNotesItemEntriesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/item-entries`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DebitNotesItemEntries: Api['postV1DebitNotesItemEntries'] = async (request: Types.PostV1DebitNotesItemEntriesRequest): Promise<Types.PostV1DebitNotesItemEntriesResponses> => {
  return await _postV1DebitNotesItemEntries(baseUrl, request)
}
const _getV1DebitNotesItemEntriesId = async (url: string, request: Types.GetV1DebitNotesItemEntriesIdRequest): Promise<Types.GetV1DebitNotesItemEntriesIdResponses> => {
  const queryParameters: (keyof Types.GetV1DebitNotesItemEntriesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/item-entries/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DebitNotesItemEntriesId: Api['getV1DebitNotesItemEntriesId'] = async (request: Types.GetV1DebitNotesItemEntriesIdRequest): Promise<Types.GetV1DebitNotesItemEntriesIdResponses> => {
  return await _getV1DebitNotesItemEntriesId(baseUrl, request)
}
const _putV1DebitNotesItemEntriesId = async (url: string, request: Types.PutV1DebitNotesItemEntriesIdRequest): Promise<Types.PutV1DebitNotesItemEntriesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/item-entries/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DebitNotesItemEntriesId: Api['putV1DebitNotesItemEntriesId'] = async (request: Types.PutV1DebitNotesItemEntriesIdRequest): Promise<Types.PutV1DebitNotesItemEntriesIdResponses> => {
  return await _putV1DebitNotesItemEntriesId(baseUrl, request)
}
const _deleteV1DebitNotesItemEntriesId = async (url: string, request: Types.DeleteV1DebitNotesItemEntriesIdRequest): Promise<Types.DeleteV1DebitNotesItemEntriesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/item-entries/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DebitNotesItemEntriesId: Api['deleteV1DebitNotesItemEntriesId'] = async (request: Types.DeleteV1DebitNotesItemEntriesIdRequest): Promise<Types.DeleteV1DebitNotesItemEntriesIdResponses> => {
  return await _deleteV1DebitNotesItemEntriesId(baseUrl, request)
}
const _postV1DebitNotesExpenseEntries = async (url: string, request: Types.PostV1DebitNotesExpenseEntriesRequest): Promise<Types.PostV1DebitNotesExpenseEntriesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/expense-entries`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DebitNotesExpenseEntries: Api['postV1DebitNotesExpenseEntries'] = async (request: Types.PostV1DebitNotesExpenseEntriesRequest): Promise<Types.PostV1DebitNotesExpenseEntriesResponses> => {
  return await _postV1DebitNotesExpenseEntries(baseUrl, request)
}
const _getV1DebitNotesExpenseEntriesId = async (url: string, request: Types.GetV1DebitNotesExpenseEntriesIdRequest): Promise<Types.GetV1DebitNotesExpenseEntriesIdResponses> => {
  const queryParameters: (keyof Types.GetV1DebitNotesExpenseEntriesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/expense-entries/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DebitNotesExpenseEntriesId: Api['getV1DebitNotesExpenseEntriesId'] = async (request: Types.GetV1DebitNotesExpenseEntriesIdRequest): Promise<Types.GetV1DebitNotesExpenseEntriesIdResponses> => {
  return await _getV1DebitNotesExpenseEntriesId(baseUrl, request)
}
const _putV1DebitNotesExpenseEntriesId = async (url: string, request: Types.PutV1DebitNotesExpenseEntriesIdRequest): Promise<Types.PutV1DebitNotesExpenseEntriesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/expense-entries/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DebitNotesExpenseEntriesId: Api['putV1DebitNotesExpenseEntriesId'] = async (request: Types.PutV1DebitNotesExpenseEntriesIdRequest): Promise<Types.PutV1DebitNotesExpenseEntriesIdResponses> => {
  return await _putV1DebitNotesExpenseEntriesId(baseUrl, request)
}
const _deleteV1DebitNotesExpenseEntriesId = async (url: string, request: Types.DeleteV1DebitNotesExpenseEntriesIdRequest): Promise<Types.DeleteV1DebitNotesExpenseEntriesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/expense-entries/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DebitNotesExpenseEntriesId: Api['deleteV1DebitNotesExpenseEntriesId'] = async (request: Types.DeleteV1DebitNotesExpenseEntriesIdRequest): Promise<Types.DeleteV1DebitNotesExpenseEntriesIdResponses> => {
  return await _deleteV1DebitNotesExpenseEntriesId(baseUrl, request)
}
const _postV1DebitNotesInvoiceDetails = async (url: string, request: Types.PostV1DebitNotesInvoiceDetailsRequest): Promise<Types.PostV1DebitNotesInvoiceDetailsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/invoice-details`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DebitNotesInvoiceDetails: Api['postV1DebitNotesInvoiceDetails'] = async (request: Types.PostV1DebitNotesInvoiceDetailsRequest): Promise<Types.PostV1DebitNotesInvoiceDetailsResponses> => {
  return await _postV1DebitNotesInvoiceDetails(baseUrl, request)
}
const _postV1DebitNotesAddApprover = async (url: string, request: Types.PostV1DebitNotesAddApproverRequest): Promise<Types.PostV1DebitNotesAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DebitNotesAddApprover: Api['postV1DebitNotesAddApprover'] = async (request: Types.PostV1DebitNotesAddApproverRequest): Promise<Types.PostV1DebitNotesAddApproverResponses> => {
  return await _postV1DebitNotesAddApprover(baseUrl, request)
}
const _putV1DebitNotesApprovalStatusId = async (url: string, request: Types.PutV1DebitNotesApprovalStatusIdRequest): Promise<Types.PutV1DebitNotesApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DebitNotesApprovalStatusId: Api['putV1DebitNotesApprovalStatusId'] = async (request: Types.PutV1DebitNotesApprovalStatusIdRequest): Promise<Types.PutV1DebitNotesApprovalStatusIdResponses> => {
  return await _putV1DebitNotesApprovalStatusId(baseUrl, request)
}
const _getV1DebitNotesVendorInvoiceId = async (url: string, request: Types.GetV1DebitNotesVendorInvoiceIdRequest): Promise<Types.GetV1DebitNotesVendorInvoiceIdResponses> => {
  const queryParameters: (keyof Types.GetV1DebitNotesVendorInvoiceIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/vendor-invoice/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DebitNotesVendorInvoiceId: Api['getV1DebitNotesVendorInvoiceId'] = async (request: Types.GetV1DebitNotesVendorInvoiceIdRequest): Promise<Types.GetV1DebitNotesVendorInvoiceIdResponses> => {
  return await _getV1DebitNotesVendorInvoiceId(baseUrl, request)
}
const _getV1DebitNotesReasons = async (url: string, request: Types.GetV1DebitNotesReasonsRequest): Promise<Types.GetV1DebitNotesReasonsResponses> => {
  const queryParameters: (keyof Types.GetV1DebitNotesReasonsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/reasons?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DebitNotesReasons: Api['getV1DebitNotesReasons'] = async (request: Types.GetV1DebitNotesReasonsRequest): Promise<Types.GetV1DebitNotesReasonsResponses> => {
  return await _getV1DebitNotesReasons(baseUrl, request)
}
const _postV1DebitNotesInvoiceNote = async (url: string, request: Types.PostV1DebitNotesInvoiceNoteRequest): Promise<Types.PostV1DebitNotesInvoiceNoteResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/invoice-note`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DebitNotesInvoiceNote: Api['postV1DebitNotesInvoiceNote'] = async (request: Types.PostV1DebitNotesInvoiceNoteRequest): Promise<Types.PostV1DebitNotesInvoiceNoteResponses> => {
  return await _postV1DebitNotesInvoiceNote(baseUrl, request)
}
const _getV1DebitNotesVoidId = async (url: string, request: Types.GetV1DebitNotesVoidIdRequest): Promise<Types.GetV1DebitNotesVoidIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/void/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DebitNotesVoidId: Api['getV1DebitNotesVoidId'] = async (request: Types.GetV1DebitNotesVoidIdRequest): Promise<Types.GetV1DebitNotesVoidIdResponses> => {
  return await _getV1DebitNotesVoidId(baseUrl, request)
}
const _getV1DebitNotesIdDownload = async (url: string, request: Types.GetV1DebitNotesIdDownloadRequest): Promise<Types.GetV1DebitNotesIdDownloadResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/${request['id']}/download`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DebitNotesIdDownload: Api['getV1DebitNotesIdDownload'] = async (request: Types.GetV1DebitNotesIdDownloadRequest): Promise<Types.GetV1DebitNotesIdDownloadResponses> => {
  return await _getV1DebitNotesIdDownload(baseUrl, request)
}
const _getV1DebitNotesGenerateExcel = async (url: string, request: Types.GetV1DebitNotesGenerateExcelRequest): Promise<Types.GetV1DebitNotesGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1DebitNotesGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DebitNotesGenerateExcel: Api['getV1DebitNotesGenerateExcel'] = async (request: Types.GetV1DebitNotesGenerateExcelRequest): Promise<Types.GetV1DebitNotesGenerateExcelResponses> => {
  return await _getV1DebitNotesGenerateExcel(baseUrl, request)
}
const _getV1DebitNotesGeneratePdf = async (url: string, request: Types.GetV1DebitNotesGeneratePdfRequest): Promise<Types.GetV1DebitNotesGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1DebitNotesGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/debit-notes/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DebitNotesGeneratePdf: Api['getV1DebitNotesGeneratePdf'] = async (request: Types.GetV1DebitNotesGeneratePdfRequest): Promise<Types.GetV1DebitNotesGeneratePdfResponses> => {
  return await _getV1DebitNotesGeneratePdf(baseUrl, request)
}
const _postV1SalesInvoices = async (url: string, request: Types.PostV1SalesInvoicesRequest): Promise<Types.PostV1SalesInvoicesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesInvoices: Api['postV1SalesInvoices'] = async (request: Types.PostV1SalesInvoicesRequest): Promise<Types.PostV1SalesInvoicesResponses> => {
  return await _postV1SalesInvoices(baseUrl, request)
}
const _getV1SalesInvoices = async (url: string, request: Types.GetV1SalesInvoicesRequest): Promise<Types.GetV1SalesInvoicesResponses> => {
  const queryParameters: (keyof Types.GetV1SalesInvoicesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesInvoices: Api['getV1SalesInvoices'] = async (request: Types.GetV1SalesInvoicesRequest): Promise<Types.GetV1SalesInvoicesResponses> => {
  return await _getV1SalesInvoices(baseUrl, request)
}
const _postV1SalesInvoicesImport = async (url: string, request: Types.PostV1SalesInvoicesImportRequest): Promise<Types.PostV1SalesInvoicesImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesInvoicesImport: Api['postV1SalesInvoicesImport'] = async (request: Types.PostV1SalesInvoicesImportRequest): Promise<Types.PostV1SalesInvoicesImportResponses> => {
  return await _postV1SalesInvoicesImport(baseUrl, request)
}
const _getV1SalesInvoicesId = async (url: string, request: Types.GetV1SalesInvoicesIdRequest): Promise<Types.GetV1SalesInvoicesIdResponses> => {
  const queryParameters: (keyof Types.GetV1SalesInvoicesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesInvoicesId: Api['getV1SalesInvoicesId'] = async (request: Types.GetV1SalesInvoicesIdRequest): Promise<Types.GetV1SalesInvoicesIdResponses> => {
  return await _getV1SalesInvoicesId(baseUrl, request)
}
const _putV1SalesInvoicesId = async (url: string, request: Types.PutV1SalesInvoicesIdRequest): Promise<Types.PutV1SalesInvoicesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1SalesInvoicesId: Api['putV1SalesInvoicesId'] = async (request: Types.PutV1SalesInvoicesIdRequest): Promise<Types.PutV1SalesInvoicesIdResponses> => {
  return await _putV1SalesInvoicesId(baseUrl, request)
}
const _deleteV1SalesInvoicesId = async (url: string, request: Types.DeleteV1SalesInvoicesIdRequest): Promise<Types.DeleteV1SalesInvoicesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1SalesInvoicesId: Api['deleteV1SalesInvoicesId'] = async (request: Types.DeleteV1SalesInvoicesIdRequest): Promise<Types.DeleteV1SalesInvoicesIdResponses> => {
  return await _deleteV1SalesInvoicesId(baseUrl, request)
}
const _getV1SalesInvoicesIdDownload = async (url: string, request: Types.GetV1SalesInvoicesIdDownloadRequest): Promise<Types.GetV1SalesInvoicesIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1SalesInvoicesIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesInvoicesIdDownload: Api['getV1SalesInvoicesIdDownload'] = async (request: Types.GetV1SalesInvoicesIdDownloadRequest): Promise<Types.GetV1SalesInvoicesIdDownloadResponses> => {
  return await _getV1SalesInvoicesIdDownload(baseUrl, request)
}
const _postV1SalesInvoicesItemEntry = async (url: string, request: Types.PostV1SalesInvoicesItemEntryRequest): Promise<Types.PostV1SalesInvoicesItemEntryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/item-entry/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesInvoicesItemEntry: Api['postV1SalesInvoicesItemEntry'] = async (request: Types.PostV1SalesInvoicesItemEntryRequest): Promise<Types.PostV1SalesInvoicesItemEntryResponses> => {
  return await _postV1SalesInvoicesItemEntry(baseUrl, request)
}
const _getV1SalesInvoicesItemEntryId = async (url: string, request: Types.GetV1SalesInvoicesItemEntryIdRequest): Promise<Types.GetV1SalesInvoicesItemEntryIdResponses> => {
  const queryParameters: (keyof Types.GetV1SalesInvoicesItemEntryIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/item-entry/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesInvoicesItemEntryId: Api['getV1SalesInvoicesItemEntryId'] = async (request: Types.GetV1SalesInvoicesItemEntryIdRequest): Promise<Types.GetV1SalesInvoicesItemEntryIdResponses> => {
  return await _getV1SalesInvoicesItemEntryId(baseUrl, request)
}
const _putV1SalesInvoicesItemEntryId = async (url: string, request: Types.PutV1SalesInvoicesItemEntryIdRequest): Promise<Types.PutV1SalesInvoicesItemEntryIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/item-entry/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1SalesInvoicesItemEntryId: Api['putV1SalesInvoicesItemEntryId'] = async (request: Types.PutV1SalesInvoicesItemEntryIdRequest): Promise<Types.PutV1SalesInvoicesItemEntryIdResponses> => {
  return await _putV1SalesInvoicesItemEntryId(baseUrl, request)
}
const _deleteV1SalesInvoicesItemEntryId = async (url: string, request: Types.DeleteV1SalesInvoicesItemEntryIdRequest): Promise<Types.DeleteV1SalesInvoicesItemEntryIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/item-entry/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1SalesInvoicesItemEntryId: Api['deleteV1SalesInvoicesItemEntryId'] = async (request: Types.DeleteV1SalesInvoicesItemEntryIdRequest): Promise<Types.DeleteV1SalesInvoicesItemEntryIdResponses> => {
  return await _deleteV1SalesInvoicesItemEntryId(baseUrl, request)
}
const _postV1SalesInvoicesAddApprover = async (url: string, request: Types.PostV1SalesInvoicesAddApproverRequest): Promise<Types.PostV1SalesInvoicesAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesInvoicesAddApprover: Api['postV1SalesInvoicesAddApprover'] = async (request: Types.PostV1SalesInvoicesAddApproverRequest): Promise<Types.PostV1SalesInvoicesAddApproverResponses> => {
  return await _postV1SalesInvoicesAddApprover(baseUrl, request)
}
const _putV1SalesInvoicesApprovalStatusId = async (url: string, request: Types.PutV1SalesInvoicesApprovalStatusIdRequest): Promise<Types.PutV1SalesInvoicesApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1SalesInvoicesApprovalStatusId: Api['putV1SalesInvoicesApprovalStatusId'] = async (request: Types.PutV1SalesInvoicesApprovalStatusIdRequest): Promise<Types.PutV1SalesInvoicesApprovalStatusIdResponses> => {
  return await _putV1SalesInvoicesApprovalStatusId(baseUrl, request)
}
const _getV1SalesInvoicesRequestPayment = async (url: string, request: Types.GetV1SalesInvoicesRequestPaymentRequest): Promise<Types.GetV1SalesInvoicesRequestPaymentResponses> => {
  const queryParameters: (keyof Types.GetV1SalesInvoicesRequestPaymentRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/request-payment?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesInvoicesRequestPayment: Api['getV1SalesInvoicesRequestPayment'] = async (request: Types.GetV1SalesInvoicesRequestPaymentRequest): Promise<Types.GetV1SalesInvoicesRequestPaymentResponses> => {
  return await _getV1SalesInvoicesRequestPayment(baseUrl, request)
}
const _getV1SalesInvoicesRequestPaymentId = async (url: string, request: Types.GetV1SalesInvoicesRequestPaymentIdRequest): Promise<Types.GetV1SalesInvoicesRequestPaymentIdResponses> => {
  const queryParameters: (keyof Types.GetV1SalesInvoicesRequestPaymentIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/request-payment/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesInvoicesRequestPaymentId: Api['getV1SalesInvoicesRequestPaymentId'] = async (request: Types.GetV1SalesInvoicesRequestPaymentIdRequest): Promise<Types.GetV1SalesInvoicesRequestPaymentIdResponses> => {
  return await _getV1SalesInvoicesRequestPaymentId(baseUrl, request)
}
const _postV1SalesInvoicesSendPaymentRequest = async (url: string, request: Types.PostV1SalesInvoicesSendPaymentRequestRequest): Promise<Types.PostV1SalesInvoicesSendPaymentRequestResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/send-payment-request`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesInvoicesSendPaymentRequest: Api['postV1SalesInvoicesSendPaymentRequest'] = async (request: Types.PostV1SalesInvoicesSendPaymentRequestRequest): Promise<Types.PostV1SalesInvoicesSendPaymentRequestResponses> => {
  return await _postV1SalesInvoicesSendPaymentRequest(baseUrl, request)
}
const _getV1SalesInvoicesIdSendEmail = async (url: string, request: Types.GetV1SalesInvoicesIdSendEmailRequest): Promise<Types.GetV1SalesInvoicesIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1SalesInvoicesIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesInvoicesIdSendEmail: Api['getV1SalesInvoicesIdSendEmail'] = async (request: Types.GetV1SalesInvoicesIdSendEmailRequest): Promise<Types.GetV1SalesInvoicesIdSendEmailResponses> => {
  return await _getV1SalesInvoicesIdSendEmail(baseUrl, request)
}
const _postV1SalesInvoicesPromotionCheck = async (url: string, request: Types.PostV1SalesInvoicesPromotionCheckRequest): Promise<Types.PostV1SalesInvoicesPromotionCheckResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/promotion/check`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesInvoicesPromotionCheck: Api['postV1SalesInvoicesPromotionCheck'] = async (request: Types.PostV1SalesInvoicesPromotionCheckRequest): Promise<Types.PostV1SalesInvoicesPromotionCheckResponses> => {
  return await _postV1SalesInvoicesPromotionCheck(baseUrl, request)
}
const _postV1SalesInvoicesPromotionApply = async (url: string, request: Types.PostV1SalesInvoicesPromotionApplyRequest): Promise<Types.PostV1SalesInvoicesPromotionApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/promotion/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesInvoicesPromotionApply: Api['postV1SalesInvoicesPromotionApply'] = async (request: Types.PostV1SalesInvoicesPromotionApplyRequest): Promise<Types.PostV1SalesInvoicesPromotionApplyResponses> => {
  return await _postV1SalesInvoicesPromotionApply(baseUrl, request)
}
const _postV1SalesInvoicesPromotionItemApply = async (url: string, request: Types.PostV1SalesInvoicesPromotionItemApplyRequest): Promise<Types.PostV1SalesInvoicesPromotionItemApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/promotion/item/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesInvoicesPromotionItemApply: Api['postV1SalesInvoicesPromotionItemApply'] = async (request: Types.PostV1SalesInvoicesPromotionItemApplyRequest): Promise<Types.PostV1SalesInvoicesPromotionItemApplyResponses> => {
  return await _postV1SalesInvoicesPromotionItemApply(baseUrl, request)
}
const _deleteV1SalesInvoicesPromotionId = async (url: string, request: Types.DeleteV1SalesInvoicesPromotionIdRequest): Promise<Types.DeleteV1SalesInvoicesPromotionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/promotion/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1SalesInvoicesPromotionId: Api['deleteV1SalesInvoicesPromotionId'] = async (request: Types.DeleteV1SalesInvoicesPromotionIdRequest): Promise<Types.DeleteV1SalesInvoicesPromotionIdResponses> => {
  return await _deleteV1SalesInvoicesPromotionId(baseUrl, request)
}
const _getV1SalesInvoicesIdPromotions = async (url: string, request: Types.GetV1SalesInvoicesIdPromotionsRequest): Promise<Types.GetV1SalesInvoicesIdPromotionsResponses> => {
  const queryParameters: (keyof Types.GetV1SalesInvoicesIdPromotionsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/${request['id']}/promotions?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesInvoicesIdPromotions: Api['getV1SalesInvoicesIdPromotions'] = async (request: Types.GetV1SalesInvoicesIdPromotionsRequest): Promise<Types.GetV1SalesInvoicesIdPromotionsResponses> => {
  return await _getV1SalesInvoicesIdPromotions(baseUrl, request)
}
const _postV1SalesInvoicesSaveDraft = async (url: string, request: Types.PostV1SalesInvoicesSaveDraftRequest): Promise<Types.PostV1SalesInvoicesSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesInvoicesSaveDraft: Api['postV1SalesInvoicesSaveDraft'] = async (request: Types.PostV1SalesInvoicesSaveDraftRequest): Promise<Types.PostV1SalesInvoicesSaveDraftResponses> => {
  return await _postV1SalesInvoicesSaveDraft(baseUrl, request)
}
const _getV1SalesInvoicesGenerateExcel = async (url: string, request: Types.GetV1SalesInvoicesGenerateExcelRequest): Promise<Types.GetV1SalesInvoicesGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1SalesInvoicesGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesInvoicesGenerateExcel: Api['getV1SalesInvoicesGenerateExcel'] = async (request: Types.GetV1SalesInvoicesGenerateExcelRequest): Promise<Types.GetV1SalesInvoicesGenerateExcelResponses> => {
  return await _getV1SalesInvoicesGenerateExcel(baseUrl, request)
}
const _getV1SalesInvoicesGeneratePdf = async (url: string, request: Types.GetV1SalesInvoicesGeneratePdfRequest): Promise<Types.GetV1SalesInvoicesGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1SalesInvoicesGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesInvoicesGeneratePdf: Api['getV1SalesInvoicesGeneratePdf'] = async (request: Types.GetV1SalesInvoicesGeneratePdfRequest): Promise<Types.GetV1SalesInvoicesGeneratePdfResponses> => {
  return await _getV1SalesInvoicesGeneratePdf(baseUrl, request)
}
const _getV1SalesInvoicesRequestPaymentGenerateExcel = async (url: string, request: Types.GetV1SalesInvoicesRequestPaymentGenerateExcelRequest): Promise<Types.GetV1SalesInvoicesRequestPaymentGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1SalesInvoicesRequestPaymentGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/sales-invoices/request-payment/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesInvoicesRequestPaymentGenerateExcel: Api['getV1SalesInvoicesRequestPaymentGenerateExcel'] = async (request: Types.GetV1SalesInvoicesRequestPaymentGenerateExcelRequest): Promise<Types.GetV1SalesInvoicesRequestPaymentGenerateExcelResponses> => {
  return await _getV1SalesInvoicesRequestPaymentGenerateExcel(baseUrl, request)
}
const _getV1SalesInvoicesIdFetchAdvancePayment = async (url: string, request: Types.GetV1SalesInvoicesIdFetchAdvancePaymentRequest): Promise<Types.GetV1SalesInvoicesIdFetchAdvancePaymentResponses> => {
  const queryParameters: (keyof Types.GetV1SalesInvoicesIdFetchAdvancePaymentRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/${request['id']}/fetch-advance-payment?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesInvoicesIdFetchAdvancePayment: Api['getV1SalesInvoicesIdFetchAdvancePayment'] = async (request: Types.GetV1SalesInvoicesIdFetchAdvancePaymentRequest): Promise<Types.GetV1SalesInvoicesIdFetchAdvancePaymentResponses> => {
  return await _getV1SalesInvoicesIdFetchAdvancePayment(baseUrl, request)
}
const _postV1SalesInvoicesIdApplyAdvancePayment = async (url: string, request: Types.PostV1SalesInvoicesIdApplyAdvancePaymentRequest): Promise<Types.PostV1SalesInvoicesIdApplyAdvancePaymentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-invoices/${request['id']}/apply-advance-payment`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesInvoicesIdApplyAdvancePayment: Api['postV1SalesInvoicesIdApplyAdvancePayment'] = async (request: Types.PostV1SalesInvoicesIdApplyAdvancePaymentRequest): Promise<Types.PostV1SalesInvoicesIdApplyAdvancePaymentResponses> => {
  return await _postV1SalesInvoicesIdApplyAdvancePayment(baseUrl, request)
}
const _postV1ReportsGeneralLedgerReport = async (url: string, request: Types.PostV1ReportsGeneralLedgerReportRequest): Promise<Types.PostV1ReportsGeneralLedgerReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/general-ledger-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsGeneralLedgerReport: Api['postV1ReportsGeneralLedgerReport'] = async (request: Types.PostV1ReportsGeneralLedgerReportRequest): Promise<Types.PostV1ReportsGeneralLedgerReportResponses> => {
  return await _postV1ReportsGeneralLedgerReport(baseUrl, request)
}
const _postV1ReportsProfitLossStatement = async (url: string, request: Types.PostV1ReportsProfitLossStatementRequest): Promise<Types.PostV1ReportsProfitLossStatementResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/profit-loss-statement`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsProfitLossStatement: Api['postV1ReportsProfitLossStatement'] = async (request: Types.PostV1ReportsProfitLossStatementRequest): Promise<Types.PostV1ReportsProfitLossStatementResponses> => {
  return await _postV1ReportsProfitLossStatement(baseUrl, request)
}
const _postV1ReportsBalanceSheet = async (url: string, request: Types.PostV1ReportsBalanceSheetRequest): Promise<Types.PostV1ReportsBalanceSheetResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/balance-sheet`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsBalanceSheet: Api['postV1ReportsBalanceSheet'] = async (request: Types.PostV1ReportsBalanceSheetRequest): Promise<Types.PostV1ReportsBalanceSheetResponses> => {
  return await _postV1ReportsBalanceSheet(baseUrl, request)
}
const _postV1ReportsTrialBalance = async (url: string, request: Types.PostV1ReportsTrialBalanceRequest): Promise<Types.PostV1ReportsTrialBalanceResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/trial-balance`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsTrialBalance: Api['postV1ReportsTrialBalance'] = async (request: Types.PostV1ReportsTrialBalanceRequest): Promise<Types.PostV1ReportsTrialBalanceResponses> => {
  return await _postV1ReportsTrialBalance(baseUrl, request)
}
const _postV1ReportsJournalReport = async (url: string, request: Types.PostV1ReportsJournalReportRequest): Promise<Types.PostV1ReportsJournalReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/journal-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsJournalReport: Api['postV1ReportsJournalReport'] = async (request: Types.PostV1ReportsJournalReportRequest): Promise<Types.PostV1ReportsJournalReportResponses> => {
  return await _postV1ReportsJournalReport(baseUrl, request)
}
const _postV1ReportsAgedPayable = async (url: string, request: Types.PostV1ReportsAgedPayableRequest): Promise<Types.PostV1ReportsAgedPayableResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/aged-payable`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsAgedPayable: Api['postV1ReportsAgedPayable'] = async (request: Types.PostV1ReportsAgedPayableRequest): Promise<Types.PostV1ReportsAgedPayableResponses> => {
  return await _postV1ReportsAgedPayable(baseUrl, request)
}
const _postV1ReportsAgedReceivable = async (url: string, request: Types.PostV1ReportsAgedReceivableRequest): Promise<Types.PostV1ReportsAgedReceivableResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/aged-receivable`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsAgedReceivable: Api['postV1ReportsAgedReceivable'] = async (request: Types.PostV1ReportsAgedReceivableRequest): Promise<Types.PostV1ReportsAgedReceivableResponses> => {
  return await _postV1ReportsAgedReceivable(baseUrl, request)
}
const _postV1ReportsShareholderReport = async (url: string, request: Types.PostV1ReportsShareholderReportRequest): Promise<Types.PostV1ReportsShareholderReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/shareholder-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsShareholderReport: Api['postV1ReportsShareholderReport'] = async (request: Types.PostV1ReportsShareholderReportRequest): Promise<Types.PostV1ReportsShareholderReportResponses> => {
  return await _postV1ReportsShareholderReport(baseUrl, request)
}
const _postV1ReportsDepreciationScheduler = async (url: string, request: Types.PostV1ReportsDepreciationSchedulerRequest): Promise<Types.PostV1ReportsDepreciationSchedulerResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/depreciation-scheduler`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsDepreciationScheduler: Api['postV1ReportsDepreciationScheduler'] = async (request: Types.PostV1ReportsDepreciationSchedulerRequest): Promise<Types.PostV1ReportsDepreciationSchedulerResponses> => {
  return await _postV1ReportsDepreciationScheduler(baseUrl, request)
}
const _postV1ReportsCashflowReport = async (url: string, request: Types.PostV1ReportsCashflowReportRequest): Promise<Types.PostV1ReportsCashflowReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/cashflow-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsCashflowReport: Api['postV1ReportsCashflowReport'] = async (request: Types.PostV1ReportsCashflowReportRequest): Promise<Types.PostV1ReportsCashflowReportResponses> => {
  return await _postV1ReportsCashflowReport(baseUrl, request)
}
const _postV1ReportsJournalDetails = async (url: string, request: Types.PostV1ReportsJournalDetailsRequest): Promise<Types.PostV1ReportsJournalDetailsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/journal-details`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsJournalDetails: Api['postV1ReportsJournalDetails'] = async (request: Types.PostV1ReportsJournalDetailsRequest): Promise<Types.PostV1ReportsJournalDetailsResponses> => {
  return await _postV1ReportsJournalDetails(baseUrl, request)
}
const _getV1ReportsJournalItemsTypeId = async (url: string, request: Types.GetV1ReportsJournalItemsTypeIdRequest): Promise<Types.GetV1ReportsJournalItemsTypeIdResponses> => {
  const queryParameters: (keyof Types.GetV1ReportsJournalItemsTypeIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/journal-items/${request['type']}/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReportsJournalItemsTypeId: Api['getV1ReportsJournalItemsTypeId'] = async (request: Types.GetV1ReportsJournalItemsTypeIdRequest): Promise<Types.GetV1ReportsJournalItemsTypeIdResponses> => {
  return await _getV1ReportsJournalItemsTypeId(baseUrl, request)
}
const _postV1ReportsReportSummary = async (url: string, request: Types.PostV1ReportsReportSummaryRequest): Promise<Types.PostV1ReportsReportSummaryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/report-summary`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsReportSummary: Api['postV1ReportsReportSummary'] = async (request: Types.PostV1ReportsReportSummaryRequest): Promise<Types.PostV1ReportsReportSummaryResponses> => {
  return await _postV1ReportsReportSummary(baseUrl, request)
}
const _postV1ReportsGeneralLedgerReportDownload = async (url: string, request: Types.PostV1ReportsGeneralLedgerReportDownloadRequest): Promise<Types.PostV1ReportsGeneralLedgerReportDownloadResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/general-ledger-report/download`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsGeneralLedgerReportDownload: Api['postV1ReportsGeneralLedgerReportDownload'] = async (request: Types.PostV1ReportsGeneralLedgerReportDownloadRequest): Promise<Types.PostV1ReportsGeneralLedgerReportDownloadResponses> => {
  return await _postV1ReportsGeneralLedgerReportDownload(baseUrl, request)
}
const _postV1ReportsVatReport = async (url: string, request: Types.PostV1ReportsVatReportRequest): Promise<Types.PostV1ReportsVatReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/vat-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsVatReport: Api['postV1ReportsVatReport'] = async (request: Types.PostV1ReportsVatReportRequest): Promise<Types.PostV1ReportsVatReportResponses> => {
  return await _postV1ReportsVatReport(baseUrl, request)
}
const _postV1ReportsVatReportNarration = async (url: string, request: Types.PostV1ReportsVatReportNarrationRequest): Promise<Types.PostV1ReportsVatReportNarrationResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/vat-report/narration/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsVatReportNarration: Api['postV1ReportsVatReportNarration'] = async (request: Types.PostV1ReportsVatReportNarrationRequest): Promise<Types.PostV1ReportsVatReportNarrationResponses> => {
  return await _postV1ReportsVatReportNarration(baseUrl, request)
}
const _postV1ReportsVatReportDetails = async (url: string, request: Types.PostV1ReportsVatReportDetailsRequest): Promise<Types.PostV1ReportsVatReportDetailsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/vat-report/details`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsVatReportDetails: Api['postV1ReportsVatReportDetails'] = async (request: Types.PostV1ReportsVatReportDetailsRequest): Promise<Types.PostV1ReportsVatReportDetailsResponses> => {
  return await _postV1ReportsVatReportDetails(baseUrl, request)
}
const _postV1ReportsVatReportDownload = async (url: string, request: Types.PostV1ReportsVatReportDownloadRequest): Promise<Types.PostV1ReportsVatReportDownloadResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/vat-report/download`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsVatReportDownload: Api['postV1ReportsVatReportDownload'] = async (request: Types.PostV1ReportsVatReportDownloadRequest): Promise<Types.PostV1ReportsVatReportDownloadResponses> => {
  return await _postV1ReportsVatReportDownload(baseUrl, request)
}
const _postV1ReportsCustomerSoa = async (url: string, request: Types.PostV1ReportsCustomerSoaRequest): Promise<Types.PostV1ReportsCustomerSoaResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/customer-soa`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsCustomerSoa: Api['postV1ReportsCustomerSoa'] = async (request: Types.PostV1ReportsCustomerSoaRequest): Promise<Types.PostV1ReportsCustomerSoaResponses> => {
  return await _postV1ReportsCustomerSoa(baseUrl, request)
}
const _postV1ReportsVendorSoa = async (url: string, request: Types.PostV1ReportsVendorSoaRequest): Promise<Types.PostV1ReportsVendorSoaResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/vendor-soa`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsVendorSoa: Api['postV1ReportsVendorSoa'] = async (request: Types.PostV1ReportsVendorSoaRequest): Promise<Types.PostV1ReportsVendorSoaResponses> => {
  return await _postV1ReportsVendorSoa(baseUrl, request)
}
const _postV1ReportsCollectionRegisterReport = async (url: string, request: Types.PostV1ReportsCollectionRegisterReportRequest): Promise<Types.PostV1ReportsCollectionRegisterReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/collection-register-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsCollectionRegisterReport: Api['postV1ReportsCollectionRegisterReport'] = async (request: Types.PostV1ReportsCollectionRegisterReportRequest): Promise<Types.PostV1ReportsCollectionRegisterReportResponses> => {
  return await _postV1ReportsCollectionRegisterReport(baseUrl, request)
}
const _postV1ReportsExpenseAnalysis = async (url: string, request: Types.PostV1ReportsExpenseAnalysisRequest): Promise<Types.PostV1ReportsExpenseAnalysisResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/expense-analysis`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsExpenseAnalysis: Api['postV1ReportsExpenseAnalysis'] = async (request: Types.PostV1ReportsExpenseAnalysisRequest): Promise<Types.PostV1ReportsExpenseAnalysisResponses> => {
  return await _postV1ReportsExpenseAnalysis(baseUrl, request)
}
const _postV1ReportsTaxSummary = async (url: string, request: Types.PostV1ReportsTaxSummaryRequest): Promise<Types.PostV1ReportsTaxSummaryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/tax-summary`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsTaxSummary: Api['postV1ReportsTaxSummary'] = async (request: Types.PostV1ReportsTaxSummaryRequest): Promise<Types.PostV1ReportsTaxSummaryResponses> => {
  return await _postV1ReportsTaxSummary(baseUrl, request)
}
const _postV1ReportsFixedAssetsRegister = async (url: string, request: Types.PostV1ReportsFixedAssetsRegisterRequest): Promise<Types.PostV1ReportsFixedAssetsRegisterResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/fixed-assets-register`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsFixedAssetsRegister: Api['postV1ReportsFixedAssetsRegister'] = async (request: Types.PostV1ReportsFixedAssetsRegisterRequest): Promise<Types.PostV1ReportsFixedAssetsRegisterResponses> => {
  return await _postV1ReportsFixedAssetsRegister(baseUrl, request)
}
const _postV1ReportsExport = async (url: string, request: Types.PostV1ReportsExportRequest): Promise<Types.PostV1ReportsExportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/export`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsExport: Api['postV1ReportsExport'] = async (request: Types.PostV1ReportsExportRequest): Promise<Types.PostV1ReportsExportResponses> => {
  return await _postV1ReportsExport(baseUrl, request)
}
const _getV1ReconciliatonList = async (url: string, request: Types.GetV1ReconciliatonListRequest): Promise<Types.GetV1ReconciliatonListResponses> => {
  const queryParameters: (keyof Types.GetV1ReconciliatonListRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reconciliaton/list?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReconciliatonList: Api['getV1ReconciliatonList'] = async (request: Types.GetV1ReconciliatonListRequest): Promise<Types.GetV1ReconciliatonListResponses> => {
  return await _getV1ReconciliatonList(baseUrl, request)
}
const _postV1ReconciliatonBankIdTransactions = async (url: string, request: Types.PostV1ReconciliatonBankIdTransactionsRequest): Promise<Types.PostV1ReconciliatonBankIdTransactionsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reconciliaton/bank/${request['id']}/transactions`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReconciliatonBankIdTransactions: Api['postV1ReconciliatonBankIdTransactions'] = async (request: Types.PostV1ReconciliatonBankIdTransactionsRequest): Promise<Types.PostV1ReconciliatonBankIdTransactionsResponses> => {
  return await _postV1ReconciliatonBankIdTransactions(baseUrl, request)
}
const _getV1ReconciliatonBankIdTransactions = async (url: string, request: Types.GetV1ReconciliatonBankIdTransactionsRequest): Promise<Types.GetV1ReconciliatonBankIdTransactionsResponses> => {
  const queryParameters: (keyof Types.GetV1ReconciliatonBankIdTransactionsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reconciliaton/bank/${request['id']}/transactions?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReconciliatonBankIdTransactions: Api['getV1ReconciliatonBankIdTransactions'] = async (request: Types.GetV1ReconciliatonBankIdTransactionsRequest): Promise<Types.GetV1ReconciliatonBankIdTransactionsResponses> => {
  return await _getV1ReconciliatonBankIdTransactions(baseUrl, request)
}
const _getV1ReconciliatonBankIdTransactionsTranIdPayment = async (url: string, request: Types.GetV1ReconciliatonBankIdTransactionsTranIdPaymentRequest): Promise<Types.GetV1ReconciliatonBankIdTransactionsTranIdPaymentResponses> => {
  const queryParameters: (keyof Types.GetV1ReconciliatonBankIdTransactionsTranIdPaymentRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reconciliaton/bank/${request['id']}/transactions/${request['tranId']}/payment?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReconciliatonBankIdTransactionsTranIdPayment: Api['getV1ReconciliatonBankIdTransactionsTranIdPayment'] = async (request: Types.GetV1ReconciliatonBankIdTransactionsTranIdPaymentRequest): Promise<Types.GetV1ReconciliatonBankIdTransactionsTranIdPaymentResponses> => {
  return await _getV1ReconciliatonBankIdTransactionsTranIdPayment(baseUrl, request)
}
const _patchV1ReconciliatonBankIdTransactionsTranIdReconcile = async (url: string, request: Types.PatchV1ReconciliatonBankIdTransactionsTranIdReconcileRequest): Promise<Types.PatchV1ReconciliatonBankIdTransactionsTranIdReconcileResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reconciliaton/bank/${request['id']}/transactions/${request['tranId']}/reconcile`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1ReconciliatonBankIdTransactionsTranIdReconcile: Api['patchV1ReconciliatonBankIdTransactionsTranIdReconcile'] = async (request: Types.PatchV1ReconciliatonBankIdTransactionsTranIdReconcileRequest): Promise<Types.PatchV1ReconciliatonBankIdTransactionsTranIdReconcileResponses> => {
  return await _patchV1ReconciliatonBankIdTransactionsTranIdReconcile(baseUrl, request)
}
const _getV1ReconciliatonGenerateExcel = async (url: string, request: Types.GetV1ReconciliatonGenerateExcelRequest): Promise<Types.GetV1ReconciliatonGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1ReconciliatonGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reconciliaton/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReconciliatonGenerateExcel: Api['getV1ReconciliatonGenerateExcel'] = async (request: Types.GetV1ReconciliatonGenerateExcelRequest): Promise<Types.GetV1ReconciliatonGenerateExcelResponses> => {
  return await _getV1ReconciliatonGenerateExcel(baseUrl, request)
}
const _getV1ReconciliatonGeneratePdf = async (url: string, request: Types.GetV1ReconciliatonGeneratePdfRequest): Promise<Types.GetV1ReconciliatonGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1ReconciliatonGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reconciliaton/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReconciliatonGeneratePdf: Api['getV1ReconciliatonGeneratePdf'] = async (request: Types.GetV1ReconciliatonGeneratePdfRequest): Promise<Types.GetV1ReconciliatonGeneratePdfResponses> => {
  return await _getV1ReconciliatonGeneratePdf(baseUrl, request)
}
const _getV1CommissionAuthorize = async (url: string, request: Types.GetV1CommissionAuthorizeRequest): Promise<Types.GetV1CommissionAuthorizeResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionAuthorizeRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission/authorize/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionAuthorize: Api['getV1CommissionAuthorize'] = async (request: Types.GetV1CommissionAuthorizeRequest): Promise<Types.GetV1CommissionAuthorizeResponses> => {
  return await _getV1CommissionAuthorize(baseUrl, request)
}
const _postV1CommissionAuthorizeId = async (url: string, request: Types.PostV1CommissionAuthorizeIdRequest): Promise<Types.PostV1CommissionAuthorizeIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission/authorize/${request['id']}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CommissionAuthorizeId: Api['postV1CommissionAuthorizeId'] = async (request: Types.PostV1CommissionAuthorizeIdRequest): Promise<Types.PostV1CommissionAuthorizeIdResponses> => {
  return await _postV1CommissionAuthorizeId(baseUrl, request)
}
const _postV1CommissionAuthorizeIdTransaction = async (url: string, request: Types.PostV1CommissionAuthorizeIdTransactionRequest): Promise<Types.PostV1CommissionAuthorizeIdTransactionResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission/authorize/${request['id']}/transaction`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CommissionAuthorizeIdTransaction: Api['postV1CommissionAuthorizeIdTransaction'] = async (request: Types.PostV1CommissionAuthorizeIdTransactionRequest): Promise<Types.PostV1CommissionAuthorizeIdTransactionResponses> => {
  return await _postV1CommissionAuthorizeIdTransaction(baseUrl, request)
}
const _getV1CommissionAuthorizeIdTransactionTranId = async (url: string, request: Types.GetV1CommissionAuthorizeIdTransactionTranIdRequest): Promise<Types.GetV1CommissionAuthorizeIdTransactionTranIdResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionAuthorizeIdTransactionTranIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission/authorize/${request['id']}/transaction/${request['tranId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionAuthorizeIdTransactionTranId: Api['getV1CommissionAuthorizeIdTransactionTranId'] = async (request: Types.GetV1CommissionAuthorizeIdTransactionTranIdRequest): Promise<Types.GetV1CommissionAuthorizeIdTransactionTranIdResponses> => {
  return await _getV1CommissionAuthorizeIdTransactionTranId(baseUrl, request)
}
const _getV1Commission = async (url: string, request: Types.GetV1CommissionRequest): Promise<Types.GetV1CommissionResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Commission: Api['getV1Commission'] = async (request: Types.GetV1CommissionRequest): Promise<Types.GetV1CommissionResponses> => {
  return await _getV1Commission(baseUrl, request)
}
const _getV1CommissionId = async (url: string, request: Types.GetV1CommissionIdRequest): Promise<Types.GetV1CommissionIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionId: Api['getV1CommissionId'] = async (request: Types.GetV1CommissionIdRequest): Promise<Types.GetV1CommissionIdResponses> => {
  return await _getV1CommissionId(baseUrl, request)
}
const _postV1CommissionIdAuthorised = async (url: string, request: Types.PostV1CommissionIdAuthorisedRequest): Promise<Types.PostV1CommissionIdAuthorisedResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission/${request['id']}/authorised`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CommissionIdAuthorised: Api['postV1CommissionIdAuthorised'] = async (request: Types.PostV1CommissionIdAuthorisedRequest): Promise<Types.PostV1CommissionIdAuthorisedResponses> => {
  return await _postV1CommissionIdAuthorised(baseUrl, request)
}
const _getV1CommissionAuthorizeGenerateExcel = async (url: string, request: Types.GetV1CommissionAuthorizeGenerateExcelRequest): Promise<Types.GetV1CommissionAuthorizeGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionAuthorizeGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission/authorize/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionAuthorizeGenerateExcel: Api['getV1CommissionAuthorizeGenerateExcel'] = async (request: Types.GetV1CommissionAuthorizeGenerateExcelRequest): Promise<Types.GetV1CommissionAuthorizeGenerateExcelResponses> => {
  return await _getV1CommissionAuthorizeGenerateExcel(baseUrl, request)
}
const _getV1CommissionGenerateExcel = async (url: string, request: Types.GetV1CommissionGenerateExcelRequest): Promise<Types.GetV1CommissionGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionGenerateExcel: Api['getV1CommissionGenerateExcel'] = async (request: Types.GetV1CommissionGenerateExcelRequest): Promise<Types.GetV1CommissionGenerateExcelResponses> => {
  return await _getV1CommissionGenerateExcel(baseUrl, request)
}
const _getV1CommissionAuthorizeGeneratePdf = async (url: string, request: Types.GetV1CommissionAuthorizeGeneratePdfRequest): Promise<Types.GetV1CommissionAuthorizeGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionAuthorizeGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission/authorize/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionAuthorizeGeneratePdf: Api['getV1CommissionAuthorizeGeneratePdf'] = async (request: Types.GetV1CommissionAuthorizeGeneratePdfRequest): Promise<Types.GetV1CommissionAuthorizeGeneratePdfResponses> => {
  return await _getV1CommissionAuthorizeGeneratePdf(baseUrl, request)
}
const _getV1CommissionGeneratePdf = async (url: string, request: Types.GetV1CommissionGeneratePdfRequest): Promise<Types.GetV1CommissionGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionGeneratePdf: Api['getV1CommissionGeneratePdf'] = async (request: Types.GetV1CommissionGeneratePdfRequest): Promise<Types.GetV1CommissionGeneratePdfResponses> => {
  return await _getV1CommissionGeneratePdf(baseUrl, request)
}
const _postV1CommissionPlans = async (url: string, request: Types.PostV1CommissionPlansRequest): Promise<Types.PostV1CommissionPlansResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-plans/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CommissionPlans: Api['postV1CommissionPlans'] = async (request: Types.PostV1CommissionPlansRequest): Promise<Types.PostV1CommissionPlansResponses> => {
  return await _postV1CommissionPlans(baseUrl, request)
}
const _getV1CommissionPlans = async (url: string, request: Types.GetV1CommissionPlansRequest): Promise<Types.GetV1CommissionPlansResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionPlansRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-plans/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionPlans: Api['getV1CommissionPlans'] = async (request: Types.GetV1CommissionPlansRequest): Promise<Types.GetV1CommissionPlansResponses> => {
  return await _getV1CommissionPlans(baseUrl, request)
}
const _postV1CommissionPlansSaveDraft = async (url: string, request: Types.PostV1CommissionPlansSaveDraftRequest): Promise<Types.PostV1CommissionPlansSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-plans/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CommissionPlansSaveDraft: Api['postV1CommissionPlansSaveDraft'] = async (request: Types.PostV1CommissionPlansSaveDraftRequest): Promise<Types.PostV1CommissionPlansSaveDraftResponses> => {
  return await _postV1CommissionPlansSaveDraft(baseUrl, request)
}
const _getV1CommissionPlansId = async (url: string, request: Types.GetV1CommissionPlansIdRequest): Promise<Types.GetV1CommissionPlansIdResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionPlansIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-plans/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionPlansId: Api['getV1CommissionPlansId'] = async (request: Types.GetV1CommissionPlansIdRequest): Promise<Types.GetV1CommissionPlansIdResponses> => {
  return await _getV1CommissionPlansId(baseUrl, request)
}
const _putV1CommissionPlansId = async (url: string, request: Types.PutV1CommissionPlansIdRequest): Promise<Types.PutV1CommissionPlansIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-plans/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CommissionPlansId: Api['putV1CommissionPlansId'] = async (request: Types.PutV1CommissionPlansIdRequest): Promise<Types.PutV1CommissionPlansIdResponses> => {
  return await _putV1CommissionPlansId(baseUrl, request)
}
const _deleteV1CommissionPlansId = async (url: string, request: Types.DeleteV1CommissionPlansIdRequest): Promise<Types.DeleteV1CommissionPlansIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-plans/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CommissionPlansId: Api['deleteV1CommissionPlansId'] = async (request: Types.DeleteV1CommissionPlansIdRequest): Promise<Types.DeleteV1CommissionPlansIdResponses> => {
  return await _deleteV1CommissionPlansId(baseUrl, request)
}
const _postV1CommissionPlansIdTier = async (url: string, request: Types.PostV1CommissionPlansIdTierRequest): Promise<Types.PostV1CommissionPlansIdTierResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-plans/${request['id']}/tier`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CommissionPlansIdTier: Api['postV1CommissionPlansIdTier'] = async (request: Types.PostV1CommissionPlansIdTierRequest): Promise<Types.PostV1CommissionPlansIdTierResponses> => {
  return await _postV1CommissionPlansIdTier(baseUrl, request)
}
const _putV1CommissionPlansIdTierTierId = async (url: string, request: Types.PutV1CommissionPlansIdTierTierIdRequest): Promise<Types.PutV1CommissionPlansIdTierTierIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-plans/${request['id']}/tier/${request['tierId']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CommissionPlansIdTierTierId: Api['putV1CommissionPlansIdTierTierId'] = async (request: Types.PutV1CommissionPlansIdTierTierIdRequest): Promise<Types.PutV1CommissionPlansIdTierTierIdResponses> => {
  return await _putV1CommissionPlansIdTierTierId(baseUrl, request)
}
const _getV1CommissionPlansIdTierTierId = async (url: string, request: Types.GetV1CommissionPlansIdTierTierIdRequest): Promise<Types.GetV1CommissionPlansIdTierTierIdResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionPlansIdTierTierIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-plans/${request['id']}/tier/${request['tierId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionPlansIdTierTierId: Api['getV1CommissionPlansIdTierTierId'] = async (request: Types.GetV1CommissionPlansIdTierTierIdRequest): Promise<Types.GetV1CommissionPlansIdTierTierIdResponses> => {
  return await _getV1CommissionPlansIdTierTierId(baseUrl, request)
}
const _deleteV1CommissionPlansIdTierTierId = async (url: string, request: Types.DeleteV1CommissionPlansIdTierTierIdRequest): Promise<Types.DeleteV1CommissionPlansIdTierTierIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-plans/${request['id']}/tier/${request['tierId']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CommissionPlansIdTierTierId: Api['deleteV1CommissionPlansIdTierTierId'] = async (request: Types.DeleteV1CommissionPlansIdTierTierIdRequest): Promise<Types.DeleteV1CommissionPlansIdTierTierIdResponses> => {
  return await _deleteV1CommissionPlansIdTierTierId(baseUrl, request)
}
const _getV1CommissionPlansGenerateExcel = async (url: string, request: Types.GetV1CommissionPlansGenerateExcelRequest): Promise<Types.GetV1CommissionPlansGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionPlansGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-plans/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionPlansGenerateExcel: Api['getV1CommissionPlansGenerateExcel'] = async (request: Types.GetV1CommissionPlansGenerateExcelRequest): Promise<Types.GetV1CommissionPlansGenerateExcelResponses> => {
  return await _getV1CommissionPlansGenerateExcel(baseUrl, request)
}
const _getV1CommissionPlansGeneratePdf = async (url: string, request: Types.GetV1CommissionPlansGeneratePdfRequest): Promise<Types.GetV1CommissionPlansGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionPlansGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-plans/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionPlansGeneratePdf: Api['getV1CommissionPlansGeneratePdf'] = async (request: Types.GetV1CommissionPlansGeneratePdfRequest): Promise<Types.GetV1CommissionPlansGeneratePdfResponses> => {
  return await _getV1CommissionPlansGeneratePdf(baseUrl, request)
}
const _postV1CommissionTargets = async (url: string, request: Types.PostV1CommissionTargetsRequest): Promise<Types.PostV1CommissionTargetsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-targets/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CommissionTargets: Api['postV1CommissionTargets'] = async (request: Types.PostV1CommissionTargetsRequest): Promise<Types.PostV1CommissionTargetsResponses> => {
  return await _postV1CommissionTargets(baseUrl, request)
}
const _getV1CommissionTargets = async (url: string, request: Types.GetV1CommissionTargetsRequest): Promise<Types.GetV1CommissionTargetsResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionTargetsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-targets/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionTargets: Api['getV1CommissionTargets'] = async (request: Types.GetV1CommissionTargetsRequest): Promise<Types.GetV1CommissionTargetsResponses> => {
  return await _getV1CommissionTargets(baseUrl, request)
}
const _postV1CommissionTargetsSaveDraft = async (url: string, request: Types.PostV1CommissionTargetsSaveDraftRequest): Promise<Types.PostV1CommissionTargetsSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-targets/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CommissionTargetsSaveDraft: Api['postV1CommissionTargetsSaveDraft'] = async (request: Types.PostV1CommissionTargetsSaveDraftRequest): Promise<Types.PostV1CommissionTargetsSaveDraftResponses> => {
  return await _postV1CommissionTargetsSaveDraft(baseUrl, request)
}
const _getV1CommissionTargetsId = async (url: string, request: Types.GetV1CommissionTargetsIdRequest): Promise<Types.GetV1CommissionTargetsIdResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionTargetsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-targets/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionTargetsId: Api['getV1CommissionTargetsId'] = async (request: Types.GetV1CommissionTargetsIdRequest): Promise<Types.GetV1CommissionTargetsIdResponses> => {
  return await _getV1CommissionTargetsId(baseUrl, request)
}
const _putV1CommissionTargetsId = async (url: string, request: Types.PutV1CommissionTargetsIdRequest): Promise<Types.PutV1CommissionTargetsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-targets/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CommissionTargetsId: Api['putV1CommissionTargetsId'] = async (request: Types.PutV1CommissionTargetsIdRequest): Promise<Types.PutV1CommissionTargetsIdResponses> => {
  return await _putV1CommissionTargetsId(baseUrl, request)
}
const _deleteV1CommissionTargetsId = async (url: string, request: Types.DeleteV1CommissionTargetsIdRequest): Promise<Types.DeleteV1CommissionTargetsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-targets/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CommissionTargetsId: Api['deleteV1CommissionTargetsId'] = async (request: Types.DeleteV1CommissionTargetsIdRequest): Promise<Types.DeleteV1CommissionTargetsIdResponses> => {
  return await _deleteV1CommissionTargetsId(baseUrl, request)
}
const _getV1CommissionTargetsGenerateExcel = async (url: string, request: Types.GetV1CommissionTargetsGenerateExcelRequest): Promise<Types.GetV1CommissionTargetsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionTargetsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-targets/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionTargetsGenerateExcel: Api['getV1CommissionTargetsGenerateExcel'] = async (request: Types.GetV1CommissionTargetsGenerateExcelRequest): Promise<Types.GetV1CommissionTargetsGenerateExcelResponses> => {
  return await _getV1CommissionTargetsGenerateExcel(baseUrl, request)
}
const _getV1CommissionTargetsGeneratePdf = async (url: string, request: Types.GetV1CommissionTargetsGeneratePdfRequest): Promise<Types.GetV1CommissionTargetsGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionTargetsGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-targets/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionTargetsGeneratePdf: Api['getV1CommissionTargetsGeneratePdf'] = async (request: Types.GetV1CommissionTargetsGeneratePdfRequest): Promise<Types.GetV1CommissionTargetsGeneratePdfResponses> => {
  return await _getV1CommissionTargetsGeneratePdf(baseUrl, request)
}
const _postV1CommissionAssignment = async (url: string, request: Types.PostV1CommissionAssignmentRequest): Promise<Types.PostV1CommissionAssignmentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-assignment/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CommissionAssignment: Api['postV1CommissionAssignment'] = async (request: Types.PostV1CommissionAssignmentRequest): Promise<Types.PostV1CommissionAssignmentResponses> => {
  return await _postV1CommissionAssignment(baseUrl, request)
}
const _getV1CommissionAssignment = async (url: string, request: Types.GetV1CommissionAssignmentRequest): Promise<Types.GetV1CommissionAssignmentResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionAssignmentRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-assignment/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionAssignment: Api['getV1CommissionAssignment'] = async (request: Types.GetV1CommissionAssignmentRequest): Promise<Types.GetV1CommissionAssignmentResponses> => {
  return await _getV1CommissionAssignment(baseUrl, request)
}
const _postV1CommissionAssignmentSaveDraft = async (url: string, request: Types.PostV1CommissionAssignmentSaveDraftRequest): Promise<Types.PostV1CommissionAssignmentSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-assignment/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CommissionAssignmentSaveDraft: Api['postV1CommissionAssignmentSaveDraft'] = async (request: Types.PostV1CommissionAssignmentSaveDraftRequest): Promise<Types.PostV1CommissionAssignmentSaveDraftResponses> => {
  return await _postV1CommissionAssignmentSaveDraft(baseUrl, request)
}
const _getV1CommissionAssignmentId = async (url: string, request: Types.GetV1CommissionAssignmentIdRequest): Promise<Types.GetV1CommissionAssignmentIdResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionAssignmentIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-assignment/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionAssignmentId: Api['getV1CommissionAssignmentId'] = async (request: Types.GetV1CommissionAssignmentIdRequest): Promise<Types.GetV1CommissionAssignmentIdResponses> => {
  return await _getV1CommissionAssignmentId(baseUrl, request)
}
const _putV1CommissionAssignmentId = async (url: string, request: Types.PutV1CommissionAssignmentIdRequest): Promise<Types.PutV1CommissionAssignmentIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-assignment/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CommissionAssignmentId: Api['putV1CommissionAssignmentId'] = async (request: Types.PutV1CommissionAssignmentIdRequest): Promise<Types.PutV1CommissionAssignmentIdResponses> => {
  return await _putV1CommissionAssignmentId(baseUrl, request)
}
const _deleteV1CommissionAssignmentId = async (url: string, request: Types.DeleteV1CommissionAssignmentIdRequest): Promise<Types.DeleteV1CommissionAssignmentIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-assignment/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CommissionAssignmentId: Api['deleteV1CommissionAssignmentId'] = async (request: Types.DeleteV1CommissionAssignmentIdRequest): Promise<Types.DeleteV1CommissionAssignmentIdResponses> => {
  return await _deleteV1CommissionAssignmentId(baseUrl, request)
}
const _postV1CommissionAssignmentIdSalesperson = async (url: string, request: Types.PostV1CommissionAssignmentIdSalespersonRequest): Promise<Types.PostV1CommissionAssignmentIdSalespersonResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-assignment/${request['id']}/salesperson`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CommissionAssignmentIdSalesperson: Api['postV1CommissionAssignmentIdSalesperson'] = async (request: Types.PostV1CommissionAssignmentIdSalespersonRequest): Promise<Types.PostV1CommissionAssignmentIdSalespersonResponses> => {
  return await _postV1CommissionAssignmentIdSalesperson(baseUrl, request)
}
const _putV1CommissionAssignmentIdSalespersonSalespersonId = async (url: string, request: Types.PutV1CommissionAssignmentIdSalespersonSalespersonIdRequest): Promise<Types.PutV1CommissionAssignmentIdSalespersonSalespersonIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-assignment/${request['id']}/salesperson/${request['salespersonId']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CommissionAssignmentIdSalespersonSalespersonId: Api['putV1CommissionAssignmentIdSalespersonSalespersonId'] = async (request: Types.PutV1CommissionAssignmentIdSalespersonSalespersonIdRequest): Promise<Types.PutV1CommissionAssignmentIdSalespersonSalespersonIdResponses> => {
  return await _putV1CommissionAssignmentIdSalespersonSalespersonId(baseUrl, request)
}
const _getV1CommissionAssignmentIdSalespersonSalespersonId = async (url: string, request: Types.GetV1CommissionAssignmentIdSalespersonSalespersonIdRequest): Promise<Types.GetV1CommissionAssignmentIdSalespersonSalespersonIdResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionAssignmentIdSalespersonSalespersonIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-assignment/${request['id']}/salesperson/${request['salespersonId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionAssignmentIdSalespersonSalespersonId: Api['getV1CommissionAssignmentIdSalespersonSalespersonId'] = async (request: Types.GetV1CommissionAssignmentIdSalespersonSalespersonIdRequest): Promise<Types.GetV1CommissionAssignmentIdSalespersonSalespersonIdResponses> => {
  return await _getV1CommissionAssignmentIdSalespersonSalespersonId(baseUrl, request)
}
const _deleteV1CommissionAssignmentIdSalespersonSalespersonId = async (url: string, request: Types.DeleteV1CommissionAssignmentIdSalespersonSalespersonIdRequest): Promise<Types.DeleteV1CommissionAssignmentIdSalespersonSalespersonIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-assignment/${request['id']}/salesperson/${request['salespersonId']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CommissionAssignmentIdSalespersonSalespersonId: Api['deleteV1CommissionAssignmentIdSalespersonSalespersonId'] = async (request: Types.DeleteV1CommissionAssignmentIdSalespersonSalespersonIdRequest): Promise<Types.DeleteV1CommissionAssignmentIdSalespersonSalespersonIdResponses> => {
  return await _deleteV1CommissionAssignmentIdSalespersonSalespersonId(baseUrl, request)
}
const _getV1CommissionAssignmentGenerateExcel = async (url: string, request: Types.GetV1CommissionAssignmentGenerateExcelRequest): Promise<Types.GetV1CommissionAssignmentGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionAssignmentGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-assignment/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionAssignmentGenerateExcel: Api['getV1CommissionAssignmentGenerateExcel'] = async (request: Types.GetV1CommissionAssignmentGenerateExcelRequest): Promise<Types.GetV1CommissionAssignmentGenerateExcelResponses> => {
  return await _getV1CommissionAssignmentGenerateExcel(baseUrl, request)
}
const _getV1CommissionAssignmentGeneratePdf = async (url: string, request: Types.GetV1CommissionAssignmentGeneratePdfRequest): Promise<Types.GetV1CommissionAssignmentGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1CommissionAssignmentGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/commission-assignment/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CommissionAssignmentGeneratePdf: Api['getV1CommissionAssignmentGeneratePdf'] = async (request: Types.GetV1CommissionAssignmentGeneratePdfRequest): Promise<Types.GetV1CommissionAssignmentGeneratePdfResponses> => {
  return await _getV1CommissionAssignmentGeneratePdf(baseUrl, request)
}
const _getV1CashExpensesUom = async (url: string, request: Types.GetV1CashExpensesUomRequest): Promise<Types.GetV1CashExpensesUomResponses> => {
  const queryParameters: (keyof Types.GetV1CashExpensesUomRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/uom?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CashExpensesUom: Api['getV1CashExpensesUom'] = async (request: Types.GetV1CashExpensesUomRequest): Promise<Types.GetV1CashExpensesUomResponses> => {
  return await _getV1CashExpensesUom(baseUrl, request)
}
const _getV1CashExpensesIncoterms = async (url: string, request: Types.GetV1CashExpensesIncotermsRequest): Promise<Types.GetV1CashExpensesIncotermsResponses> => {
  const queryParameters: (keyof Types.GetV1CashExpensesIncotermsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/incoterms?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CashExpensesIncoterms: Api['getV1CashExpensesIncoterms'] = async (request: Types.GetV1CashExpensesIncotermsRequest): Promise<Types.GetV1CashExpensesIncotermsResponses> => {
  return await _getV1CashExpensesIncoterms(baseUrl, request)
}
const _getV1CashExpensesItems = async (url: string, request: Types.GetV1CashExpensesItemsRequest): Promise<Types.GetV1CashExpensesItemsResponses> => {
  const queryParameters: (keyof Types.GetV1CashExpensesItemsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/items?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CashExpensesItems: Api['getV1CashExpensesItems'] = async (request: Types.GetV1CashExpensesItemsRequest): Promise<Types.GetV1CashExpensesItemsResponses> => {
  return await _getV1CashExpensesItems(baseUrl, request)
}
const _getV1CashExpensesDiscountItemId = async (url: string, request: Types.GetV1CashExpensesDiscountItemIdRequest): Promise<Types.GetV1CashExpensesDiscountItemIdResponses> => {
  const queryParameters: (keyof Types.GetV1CashExpensesDiscountItemIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/discount-item/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CashExpensesDiscountItemId: Api['getV1CashExpensesDiscountItemId'] = async (request: Types.GetV1CashExpensesDiscountItemIdRequest): Promise<Types.GetV1CashExpensesDiscountItemIdResponses> => {
  return await _getV1CashExpensesDiscountItemId(baseUrl, request)
}
const _getV1CashExpensesWarehouses = async (url: string, request: Types.GetV1CashExpensesWarehousesRequest): Promise<Types.GetV1CashExpensesWarehousesResponses> => {
  const queryParameters: (keyof Types.GetV1CashExpensesWarehousesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/warehouses?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CashExpensesWarehouses: Api['getV1CashExpensesWarehouses'] = async (request: Types.GetV1CashExpensesWarehousesRequest): Promise<Types.GetV1CashExpensesWarehousesResponses> => {
  return await _getV1CashExpensesWarehouses(baseUrl, request)
}
const _getV1CashExpensesSuppliers = async (url: string, request: Types.GetV1CashExpensesSuppliersRequest): Promise<Types.GetV1CashExpensesSuppliersResponses> => {
  const queryParameters: (keyof Types.GetV1CashExpensesSuppliersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/suppliers?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CashExpensesSuppliers: Api['getV1CashExpensesSuppliers'] = async (request: Types.GetV1CashExpensesSuppliersRequest): Promise<Types.GetV1CashExpensesSuppliersResponses> => {
  return await _getV1CashExpensesSuppliers(baseUrl, request)
}
const _getV1CashExpensesSuppliersId = async (url: string, request: Types.GetV1CashExpensesSuppliersIdRequest): Promise<Types.GetV1CashExpensesSuppliersIdResponses> => {
  const queryParameters: (keyof Types.GetV1CashExpensesSuppliersIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/suppliers/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CashExpensesSuppliersId: Api['getV1CashExpensesSuppliersId'] = async (request: Types.GetV1CashExpensesSuppliersIdRequest): Promise<Types.GetV1CashExpensesSuppliersIdResponses> => {
  return await _getV1CashExpensesSuppliersId(baseUrl, request)
}
const _postV1CashExpenses = async (url: string, request: Types.PostV1CashExpensesRequest): Promise<Types.PostV1CashExpensesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CashExpenses: Api['postV1CashExpenses'] = async (request: Types.PostV1CashExpensesRequest): Promise<Types.PostV1CashExpensesResponses> => {
  return await _postV1CashExpenses(baseUrl, request)
}
const _getV1CashExpenses = async (url: string, request: Types.GetV1CashExpensesRequest): Promise<Types.GetV1CashExpensesResponses> => {
  const queryParameters: (keyof Types.GetV1CashExpensesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CashExpenses: Api['getV1CashExpenses'] = async (request: Types.GetV1CashExpensesRequest): Promise<Types.GetV1CashExpensesResponses> => {
  return await _getV1CashExpenses(baseUrl, request)
}
const _postV1CashExpensesImport = async (url: string, request: Types.PostV1CashExpensesImportRequest): Promise<Types.PostV1CashExpensesImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CashExpensesImport: Api['postV1CashExpensesImport'] = async (request: Types.PostV1CashExpensesImportRequest): Promise<Types.PostV1CashExpensesImportResponses> => {
  return await _postV1CashExpensesImport(baseUrl, request)
}
const _getV1CashExpensesId = async (url: string, request: Types.GetV1CashExpensesIdRequest): Promise<Types.GetV1CashExpensesIdResponses> => {
  const queryParameters: (keyof Types.GetV1CashExpensesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CashExpensesId: Api['getV1CashExpensesId'] = async (request: Types.GetV1CashExpensesIdRequest): Promise<Types.GetV1CashExpensesIdResponses> => {
  return await _getV1CashExpensesId(baseUrl, request)
}
const _putV1CashExpensesId = async (url: string, request: Types.PutV1CashExpensesIdRequest): Promise<Types.PutV1CashExpensesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CashExpensesId: Api['putV1CashExpensesId'] = async (request: Types.PutV1CashExpensesIdRequest): Promise<Types.PutV1CashExpensesIdResponses> => {
  return await _putV1CashExpensesId(baseUrl, request)
}
const _deleteV1CashExpensesId = async (url: string, request: Types.DeleteV1CashExpensesIdRequest): Promise<Types.DeleteV1CashExpensesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CashExpensesId: Api['deleteV1CashExpensesId'] = async (request: Types.DeleteV1CashExpensesIdRequest): Promise<Types.DeleteV1CashExpensesIdResponses> => {
  return await _deleteV1CashExpensesId(baseUrl, request)
}
const _postV1CashExpensesItemEntry = async (url: string, request: Types.PostV1CashExpensesItemEntryRequest): Promise<Types.PostV1CashExpensesItemEntryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/item-entry/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CashExpensesItemEntry: Api['postV1CashExpensesItemEntry'] = async (request: Types.PostV1CashExpensesItemEntryRequest): Promise<Types.PostV1CashExpensesItemEntryResponses> => {
  return await _postV1CashExpensesItemEntry(baseUrl, request)
}
const _getV1CashExpensesItemEntryId = async (url: string, request: Types.GetV1CashExpensesItemEntryIdRequest): Promise<Types.GetV1CashExpensesItemEntryIdResponses> => {
  const queryParameters: (keyof Types.GetV1CashExpensesItemEntryIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/item-entry/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CashExpensesItemEntryId: Api['getV1CashExpensesItemEntryId'] = async (request: Types.GetV1CashExpensesItemEntryIdRequest): Promise<Types.GetV1CashExpensesItemEntryIdResponses> => {
  return await _getV1CashExpensesItemEntryId(baseUrl, request)
}
const _putV1CashExpensesItemEntryId = async (url: string, request: Types.PutV1CashExpensesItemEntryIdRequest): Promise<Types.PutV1CashExpensesItemEntryIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/item-entry/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CashExpensesItemEntryId: Api['putV1CashExpensesItemEntryId'] = async (request: Types.PutV1CashExpensesItemEntryIdRequest): Promise<Types.PutV1CashExpensesItemEntryIdResponses> => {
  return await _putV1CashExpensesItemEntryId(baseUrl, request)
}
const _deleteV1CashExpensesItemEntryId = async (url: string, request: Types.DeleteV1CashExpensesItemEntryIdRequest): Promise<Types.DeleteV1CashExpensesItemEntryIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/item-entry/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CashExpensesItemEntryId: Api['deleteV1CashExpensesItemEntryId'] = async (request: Types.DeleteV1CashExpensesItemEntryIdRequest): Promise<Types.DeleteV1CashExpensesItemEntryIdResponses> => {
  return await _deleteV1CashExpensesItemEntryId(baseUrl, request)
}
const _postV1CashExpensesExpenseEntry = async (url: string, request: Types.PostV1CashExpensesExpenseEntryRequest): Promise<Types.PostV1CashExpensesExpenseEntryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/expense-entry/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CashExpensesExpenseEntry: Api['postV1CashExpensesExpenseEntry'] = async (request: Types.PostV1CashExpensesExpenseEntryRequest): Promise<Types.PostV1CashExpensesExpenseEntryResponses> => {
  return await _postV1CashExpensesExpenseEntry(baseUrl, request)
}
const _getV1CashExpensesExpenseEntryId = async (url: string, request: Types.GetV1CashExpensesExpenseEntryIdRequest): Promise<Types.GetV1CashExpensesExpenseEntryIdResponses> => {
  const queryParameters: (keyof Types.GetV1CashExpensesExpenseEntryIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/expense-entry/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CashExpensesExpenseEntryId: Api['getV1CashExpensesExpenseEntryId'] = async (request: Types.GetV1CashExpensesExpenseEntryIdRequest): Promise<Types.GetV1CashExpensesExpenseEntryIdResponses> => {
  return await _getV1CashExpensesExpenseEntryId(baseUrl, request)
}
const _putV1CashExpensesExpenseEntryId = async (url: string, request: Types.PutV1CashExpensesExpenseEntryIdRequest): Promise<Types.PutV1CashExpensesExpenseEntryIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/expense-entry/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CashExpensesExpenseEntryId: Api['putV1CashExpensesExpenseEntryId'] = async (request: Types.PutV1CashExpensesExpenseEntryIdRequest): Promise<Types.PutV1CashExpensesExpenseEntryIdResponses> => {
  return await _putV1CashExpensesExpenseEntryId(baseUrl, request)
}
const _deleteV1CashExpensesExpenseEntryId = async (url: string, request: Types.DeleteV1CashExpensesExpenseEntryIdRequest): Promise<Types.DeleteV1CashExpensesExpenseEntryIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/expense-entry/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CashExpensesExpenseEntryId: Api['deleteV1CashExpensesExpenseEntryId'] = async (request: Types.DeleteV1CashExpensesExpenseEntryIdRequest): Promise<Types.DeleteV1CashExpensesExpenseEntryIdResponses> => {
  return await _deleteV1CashExpensesExpenseEntryId(baseUrl, request)
}
const _postV1CashExpensesAddApprover = async (url: string, request: Types.PostV1CashExpensesAddApproverRequest): Promise<Types.PostV1CashExpensesAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CashExpensesAddApprover: Api['postV1CashExpensesAddApprover'] = async (request: Types.PostV1CashExpensesAddApproverRequest): Promise<Types.PostV1CashExpensesAddApproverResponses> => {
  return await _postV1CashExpensesAddApprover(baseUrl, request)
}
const _putV1CashExpensesApprovalStatusId = async (url: string, request: Types.PutV1CashExpensesApprovalStatusIdRequest): Promise<Types.PutV1CashExpensesApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CashExpensesApprovalStatusId: Api['putV1CashExpensesApprovalStatusId'] = async (request: Types.PutV1CashExpensesApprovalStatusIdRequest): Promise<Types.PutV1CashExpensesApprovalStatusIdResponses> => {
  return await _putV1CashExpensesApprovalStatusId(baseUrl, request)
}
const _postV1CashExpensesAddRecurringDetails = async (url: string, request: Types.PostV1CashExpensesAddRecurringDetailsRequest): Promise<Types.PostV1CashExpensesAddRecurringDetailsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/add-recurring-details`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CashExpensesAddRecurringDetails: Api['postV1CashExpensesAddRecurringDetails'] = async (request: Types.PostV1CashExpensesAddRecurringDetailsRequest): Promise<Types.PostV1CashExpensesAddRecurringDetailsResponses> => {
  return await _postV1CashExpensesAddRecurringDetails(baseUrl, request)
}
const _getV1CashExpensesGenerateExcel = async (url: string, request: Types.GetV1CashExpensesGenerateExcelRequest): Promise<Types.GetV1CashExpensesGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CashExpensesGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CashExpensesGenerateExcel: Api['getV1CashExpensesGenerateExcel'] = async (request: Types.GetV1CashExpensesGenerateExcelRequest): Promise<Types.GetV1CashExpensesGenerateExcelResponses> => {
  return await _getV1CashExpensesGenerateExcel(baseUrl, request)
}
const _getV1CashExpensesGeneratePdf = async (url: string, request: Types.GetV1CashExpensesGeneratePdfRequest): Promise<Types.GetV1CashExpensesGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1CashExpensesGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cash-expenses/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CashExpensesGeneratePdf: Api['getV1CashExpensesGeneratePdf'] = async (request: Types.GetV1CashExpensesGeneratePdfRequest): Promise<Types.GetV1CashExpensesGeneratePdfResponses> => {
  return await _getV1CashExpensesGeneratePdf(baseUrl, request)
}
const _getV1ExcelTemplateGenerateTemplate = async (url: string, request: Types.GetV1ExcelTemplateGenerateTemplateRequest): Promise<Types.GetV1ExcelTemplateGenerateTemplateResponses> => {
  const queryParameters: (keyof Types.GetV1ExcelTemplateGenerateTemplateRequest)[]  = ['resource']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/excel-template/generate-template?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ExcelTemplateGenerateTemplate: Api['getV1ExcelTemplateGenerateTemplate'] = async (request: Types.GetV1ExcelTemplateGenerateTemplateRequest): Promise<Types.GetV1ExcelTemplateGenerateTemplateResponses> => {
  return await _getV1ExcelTemplateGenerateTemplate(baseUrl, request)
}
const _postV1DashboardFinancialSummary = async (url: string, request: Types.PostV1DashboardFinancialSummaryRequest): Promise<Types.PostV1DashboardFinancialSummaryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/financial-summary`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DashboardFinancialSummary: Api['postV1DashboardFinancialSummary'] = async (request: Types.PostV1DashboardFinancialSummaryRequest): Promise<Types.PostV1DashboardFinancialSummaryResponses> => {
  return await _postV1DashboardFinancialSummary(baseUrl, request)
}
const _postV1DashboardAgeingSummary = async (url: string, request: Types.PostV1DashboardAgeingSummaryRequest): Promise<Types.PostV1DashboardAgeingSummaryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/ageing-summary`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DashboardAgeingSummary: Api['postV1DashboardAgeingSummary'] = async (request: Types.PostV1DashboardAgeingSummaryRequest): Promise<Types.PostV1DashboardAgeingSummaryResponses> => {
  return await _postV1DashboardAgeingSummary(baseUrl, request)
}
const _postV1DashboardVendorSummary = async (url: string, request: Types.PostV1DashboardVendorSummaryRequest): Promise<Types.PostV1DashboardVendorSummaryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/vendor-summary`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DashboardVendorSummary: Api['postV1DashboardVendorSummary'] = async (request: Types.PostV1DashboardVendorSummaryRequest): Promise<Types.PostV1DashboardVendorSummaryResponses> => {
  return await _postV1DashboardVendorSummary(baseUrl, request)
}
const _postV1DashboardCustomerSummary = async (url: string, request: Types.PostV1DashboardCustomerSummaryRequest): Promise<Types.PostV1DashboardCustomerSummaryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/customer-summary`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DashboardCustomerSummary: Api['postV1DashboardCustomerSummary'] = async (request: Types.PostV1DashboardCustomerSummaryRequest): Promise<Types.PostV1DashboardCustomerSummaryResponses> => {
  return await _postV1DashboardCustomerSummary(baseUrl, request)
}
const _getV1Dashboard = async (url: string, request: Types.GetV1DashboardRequest): Promise<Types.GetV1DashboardResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Dashboard: Api['getV1Dashboard'] = async (request: Types.GetV1DashboardRequest): Promise<Types.GetV1DashboardResponses> => {
  return await _getV1Dashboard(baseUrl, request)
}
const _postV1DashboardCashflowSummary = async (url: string, request: Types.PostV1DashboardCashflowSummaryRequest): Promise<Types.PostV1DashboardCashflowSummaryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/cashflow-summary`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DashboardCashflowSummary: Api['postV1DashboardCashflowSummary'] = async (request: Types.PostV1DashboardCashflowSummaryRequest): Promise<Types.PostV1DashboardCashflowSummaryResponses> => {
  return await _postV1DashboardCashflowSummary(baseUrl, request)
}
const _getV1SettingsEntities = async (url: string, request: Types.GetV1SettingsEntitiesRequest): Promise<Types.GetV1SettingsEntitiesResponses> => {
  const queryParameters: (keyof Types.GetV1SettingsEntitiesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/settings/entities?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SettingsEntities: Api['getV1SettingsEntities'] = async (request: Types.GetV1SettingsEntitiesRequest): Promise<Types.GetV1SettingsEntitiesResponses> => {
  return await _getV1SettingsEntities(baseUrl, request)
}
const _postV1SettingsEntities = async (url: string, request: Types.PostV1SettingsEntitiesRequest): Promise<Types.PostV1SettingsEntitiesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/settings/entities`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SettingsEntities: Api['postV1SettingsEntities'] = async (request: Types.PostV1SettingsEntitiesRequest): Promise<Types.PostV1SettingsEntitiesResponses> => {
  return await _postV1SettingsEntities(baseUrl, request)
}
const _getV1SettingsEntitiesId = async (url: string, request: Types.GetV1SettingsEntitiesIdRequest): Promise<Types.GetV1SettingsEntitiesIdResponses> => {
  const queryParameters: (keyof Types.GetV1SettingsEntitiesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/settings/entities/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SettingsEntitiesId: Api['getV1SettingsEntitiesId'] = async (request: Types.GetV1SettingsEntitiesIdRequest): Promise<Types.GetV1SettingsEntitiesIdResponses> => {
  return await _getV1SettingsEntitiesId(baseUrl, request)
}
const _putV1SettingsEntitiesId = async (url: string, request: Types.PutV1SettingsEntitiesIdRequest): Promise<Types.PutV1SettingsEntitiesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/settings/entities/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1SettingsEntitiesId: Api['putV1SettingsEntitiesId'] = async (request: Types.PutV1SettingsEntitiesIdRequest): Promise<Types.PutV1SettingsEntitiesIdResponses> => {
  return await _putV1SettingsEntitiesId(baseUrl, request)
}
const _deleteV1SettingsEntitiesId = async (url: string, request: Types.DeleteV1SettingsEntitiesIdRequest): Promise<Types.DeleteV1SettingsEntitiesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/settings/entities/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1SettingsEntitiesId: Api['deleteV1SettingsEntitiesId'] = async (request: Types.DeleteV1SettingsEntitiesIdRequest): Promise<Types.DeleteV1SettingsEntitiesIdResponses> => {
  return await _deleteV1SettingsEntitiesId(baseUrl, request)
}
const _getV1SettingsConfigurations = async (url: string, request: Types.GetV1SettingsConfigurationsRequest): Promise<Types.GetV1SettingsConfigurationsResponses> => {
  const queryParameters: (keyof Types.GetV1SettingsConfigurationsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/settings/configurations?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SettingsConfigurations: Api['getV1SettingsConfigurations'] = async (request: Types.GetV1SettingsConfigurationsRequest): Promise<Types.GetV1SettingsConfigurationsResponses> => {
  return await _getV1SettingsConfigurations(baseUrl, request)
}
const _getV1PdcType = async (url: string, request: Types.GetV1PdcTypeRequest): Promise<Types.GetV1PdcTypeResponses> => {
  const queryParameters: (keyof Types.GetV1PdcTypeRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/pdc/${request['type']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PdcType: Api['getV1PdcType'] = async (request: Types.GetV1PdcTypeRequest): Promise<Types.GetV1PdcTypeResponses> => {
  return await _getV1PdcType(baseUrl, request)
}
const _postV1PdcSettleType = async (url: string, request: Types.PostV1PdcSettleTypeRequest): Promise<Types.PostV1PdcSettleTypeResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/pdc/settle/${request['type']}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PdcSettleType: Api['postV1PdcSettleType'] = async (request: Types.PostV1PdcSettleTypeRequest): Promise<Types.PostV1PdcSettleTypeResponses> => {
  return await _postV1PdcSettleType(baseUrl, request)
}
type BuildOptions = {
  headers?: Object
}
export default function build (url: string, options?: BuildOptions) {
  url = sanitizeUrl(url)
  if (options?.headers) {
    defaultHeaders = options.headers
  }
  return {
    postV1ChartOfAccount: _postV1ChartOfAccount.bind(url, ...arguments),
    getV1ChartOfAccount: _getV1ChartOfAccount.bind(url, ...arguments),
    postV1ChartOfAccountImport: _postV1ChartOfAccountImport.bind(url, ...arguments),
    getV1ChartOfAccountAccountTypeDetail: _getV1ChartOfAccountAccountTypeDetail.bind(url, ...arguments),
    getV1ChartOfAccountId: _getV1ChartOfAccountId.bind(url, ...arguments),
    putV1ChartOfAccountId: _putV1ChartOfAccountId.bind(url, ...arguments),
    deleteV1ChartOfAccountId: _deleteV1ChartOfAccountId.bind(url, ...arguments),
    getV1ChartOfAccountAccountType: _getV1ChartOfAccountAccountType.bind(url, ...arguments),
    getV1ChartOfAccountGenerateExcel: _getV1ChartOfAccountGenerateExcel.bind(url, ...arguments),
    getV1ChartOfAccountGeneratePdf: _getV1ChartOfAccountGeneratePdf.bind(url, ...arguments),
    postV1TaxCategory: _postV1TaxCategory.bind(url, ...arguments),
    getV1TaxCategory: _getV1TaxCategory.bind(url, ...arguments),
    postV1TaxCategoryImport: _postV1TaxCategoryImport.bind(url, ...arguments),
    getV1TaxCategorySalesAccount: _getV1TaxCategorySalesAccount.bind(url, ...arguments),
    getV1TaxCategoryPurchaseAccount: _getV1TaxCategoryPurchaseAccount.bind(url, ...arguments),
    getV1TaxCategoryId: _getV1TaxCategoryId.bind(url, ...arguments),
    putV1TaxCategoryId: _putV1TaxCategoryId.bind(url, ...arguments),
    deleteV1TaxCategoryId: _deleteV1TaxCategoryId.bind(url, ...arguments),
    getV1TaxCategoryGenerateExcel: _getV1TaxCategoryGenerateExcel.bind(url, ...arguments),
    getV1TaxCategoryGeneratePdf: _getV1TaxCategoryGeneratePdf.bind(url, ...arguments),
    postV1TaxCode: _postV1TaxCode.bind(url, ...arguments),
    getV1TaxCode: _getV1TaxCode.bind(url, ...arguments),
    postV1TaxCodeImport: _postV1TaxCodeImport.bind(url, ...arguments),
    getV1TaxCodeId: _getV1TaxCodeId.bind(url, ...arguments),
    putV1TaxCodeId: _putV1TaxCodeId.bind(url, ...arguments),
    deleteV1TaxCodeId: _deleteV1TaxCodeId.bind(url, ...arguments),
    getV1TaxCodeTaxCategoryDropdown: _getV1TaxCodeTaxCategoryDropdown.bind(url, ...arguments),
    getV1TaxCodeGenerateExcel: _getV1TaxCodeGenerateExcel.bind(url, ...arguments),
    getV1TaxCodeGeneratePdf: _getV1TaxCodeGeneratePdf.bind(url, ...arguments),
    postV1TaxTemplates: _postV1TaxTemplates.bind(url, ...arguments),
    getV1TaxTemplates: _getV1TaxTemplates.bind(url, ...arguments),
    postV1TaxTemplatesImport: _postV1TaxTemplatesImport.bind(url, ...arguments),
    getV1TaxTemplatesId: _getV1TaxTemplatesId.bind(url, ...arguments),
    putV1TaxTemplatesId: _putV1TaxTemplatesId.bind(url, ...arguments),
    deleteV1TaxTemplatesId: _deleteV1TaxTemplatesId.bind(url, ...arguments),
    getV1TaxTemplatesGenerateExcel: _getV1TaxTemplatesGenerateExcel.bind(url, ...arguments),
    getV1TaxTemplatesGeneratePdf: _getV1TaxTemplatesGeneratePdf.bind(url, ...arguments),
    postV1Banks: _postV1Banks.bind(url, ...arguments),
    getV1Banks: _getV1Banks.bind(url, ...arguments),
    postV1BanksImport: _postV1BanksImport.bind(url, ...arguments),
    getV1BanksId: _getV1BanksId.bind(url, ...arguments),
    putV1BanksId: _putV1BanksId.bind(url, ...arguments),
    deleteV1BanksId: _deleteV1BanksId.bind(url, ...arguments),
    getV1BanksGenerateExcel: _getV1BanksGenerateExcel.bind(url, ...arguments),
    getV1BanksGeneratePdf: _getV1BanksGeneratePdf.bind(url, ...arguments),
    postV1BankAccounts: _postV1BankAccounts.bind(url, ...arguments),
    getV1BankAccounts: _getV1BankAccounts.bind(url, ...arguments),
    postV1BankAccountsImport: _postV1BankAccountsImport.bind(url, ...arguments),
    getV1BankAccountsId: _getV1BankAccountsId.bind(url, ...arguments),
    putV1BankAccountsId: _putV1BankAccountsId.bind(url, ...arguments),
    deleteV1BankAccountsId: _deleteV1BankAccountsId.bind(url, ...arguments),
    getV1BankAccountsTypes: _getV1BankAccountsTypes.bind(url, ...arguments),
    getV1BankAccountsGenerateExcel: _getV1BankAccountsGenerateExcel.bind(url, ...arguments),
    getV1BankAccountsGeneratePdf: _getV1BankAccountsGeneratePdf.bind(url, ...arguments),
    getV1Currency: _getV1Currency.bind(url, ...arguments),
    postV1Currency: _postV1Currency.bind(url, ...arguments),
    getV1CurrencyId: _getV1CurrencyId.bind(url, ...arguments),
    putV1CurrencyId: _putV1CurrencyId.bind(url, ...arguments),
    deleteV1CurrencyId: _deleteV1CurrencyId.bind(url, ...arguments),
    postV1CurrencyInfo: _postV1CurrencyInfo.bind(url, ...arguments),
    postV1CurrencyImport: _postV1CurrencyImport.bind(url, ...arguments),
    getV1CurrencyGenerateExcel: _getV1CurrencyGenerateExcel.bind(url, ...arguments),
    getV1CurrencyGeneratePdf: _getV1CurrencyGeneratePdf.bind(url, ...arguments),
    getV1CurrencyExchange: _getV1CurrencyExchange.bind(url, ...arguments),
    postV1CurrencyExchange: _postV1CurrencyExchange.bind(url, ...arguments),
    getV1CurrencyExchangeId: _getV1CurrencyExchangeId.bind(url, ...arguments),
    putV1CurrencyExchangeId: _putV1CurrencyExchangeId.bind(url, ...arguments),
    deleteV1CurrencyExchangeId: _deleteV1CurrencyExchangeId.bind(url, ...arguments),
    postV1CurrencyExchangeImport: _postV1CurrencyExchangeImport.bind(url, ...arguments),
    getV1CurrencyExchangeGenerateExcel: _getV1CurrencyExchangeGenerateExcel.bind(url, ...arguments),
    getV1CurrencyExchangeGeneratePdf: _getV1CurrencyExchangeGeneratePdf.bind(url, ...arguments),
    postV1PaymentTerms: _postV1PaymentTerms.bind(url, ...arguments),
    getV1PaymentTerms: _getV1PaymentTerms.bind(url, ...arguments),
    postV1PaymentTermsImport: _postV1PaymentTermsImport.bind(url, ...arguments),
    getV1PaymentTermsId: _getV1PaymentTermsId.bind(url, ...arguments),
    putV1PaymentTermsId: _putV1PaymentTermsId.bind(url, ...arguments),
    deleteV1PaymentTermsId: _deleteV1PaymentTermsId.bind(url, ...arguments),
    getV1PaymentTermsDueDateTypes: _getV1PaymentTermsDueDateTypes.bind(url, ...arguments),
    getV1PaymentTermsGenerateExcel: _getV1PaymentTermsGenerateExcel.bind(url, ...arguments),
    getV1PaymentTermsGeneratePdf: _getV1PaymentTermsGeneratePdf.bind(url, ...arguments),
    postV1FiscalYear: _postV1FiscalYear.bind(url, ...arguments),
    getV1FiscalYear: _getV1FiscalYear.bind(url, ...arguments),
    getV1FiscalYearId: _getV1FiscalYearId.bind(url, ...arguments),
    putV1FiscalYearId: _putV1FiscalYearId.bind(url, ...arguments),
    deleteV1FiscalYearId: _deleteV1FiscalYearId.bind(url, ...arguments),
    getV1FiscalYearGenerateExcel: _getV1FiscalYearGenerateExcel.bind(url, ...arguments),
    getV1FiscalYearGeneratePdf: _getV1FiscalYearGeneratePdf.bind(url, ...arguments),
    getV1JournalEntriesReferenceType: _getV1JournalEntriesReferenceType.bind(url, ...arguments),
    postV1JournalEntries: _postV1JournalEntries.bind(url, ...arguments),
    getV1JournalEntries: _getV1JournalEntries.bind(url, ...arguments),
    postV1JournalEntriesImport: _postV1JournalEntriesImport.bind(url, ...arguments),
    getV1JournalEntriesId: _getV1JournalEntriesId.bind(url, ...arguments),
    putV1JournalEntriesId: _putV1JournalEntriesId.bind(url, ...arguments),
    deleteV1JournalEntriesId: _deleteV1JournalEntriesId.bind(url, ...arguments),
    postV1JournalEntriesAddApprover: _postV1JournalEntriesAddApprover.bind(url, ...arguments),
    putV1JournalEntriesApprovalStatusId: _putV1JournalEntriesApprovalStatusId.bind(url, ...arguments),
    getV1JournalEntriesIdExportType: _getV1JournalEntriesIdExportType.bind(url, ...arguments),
    getV1JournalEntriesGenerateExcel: _getV1JournalEntriesGenerateExcel.bind(url, ...arguments),
    getV1JournalEntriesGeneratePdf: _getV1JournalEntriesGeneratePdf.bind(url, ...arguments),
    getV1JournalEntriesIdDownload: _getV1JournalEntriesIdDownload.bind(url, ...arguments),
    postV1Parties: _postV1Parties.bind(url, ...arguments),
    getV1Parties: _getV1Parties.bind(url, ...arguments),
    getV1PartiesId: _getV1PartiesId.bind(url, ...arguments),
    putV1PartiesId: _putV1PartiesId.bind(url, ...arguments),
    deleteV1PartiesId: _deleteV1PartiesId.bind(url, ...arguments),
    postV1PartiesImport: _postV1PartiesImport.bind(url, ...arguments),
    getV1PartiesIndustry: _getV1PartiesIndustry.bind(url, ...arguments),
    postV1PartiesIndustry: _postV1PartiesIndustry.bind(url, ...arguments),
    getV1PartiesSelectOptions: _getV1PartiesSelectOptions.bind(url, ...arguments),
    getV1PartiesGenerateExcel: _getV1PartiesGenerateExcel.bind(url, ...arguments),
    getV1PartiesGeneratePdf: _getV1PartiesGeneratePdf.bind(url, ...arguments),
    postV1PartiesCheck: _postV1PartiesCheck.bind(url, ...arguments),
    getV1PartiesIdFetchSoldItems: _getV1PartiesIdFetchSoldItems.bind(url, ...arguments),
    getV1PartiesIdFetchPurchaseItems: _getV1PartiesIdFetchPurchaseItems.bind(url, ...arguments),
    postV1PaymentEntriesEntries: _postV1PaymentEntriesEntries.bind(url, ...arguments),
    getV1PaymentEntriesEntries: _getV1PaymentEntriesEntries.bind(url, ...arguments),
    postV1PaymentEntriesImport: _postV1PaymentEntriesImport.bind(url, ...arguments),
    getV1PaymentEntriesEntriesIdType: _getV1PaymentEntriesEntriesIdType.bind(url, ...arguments),
    putV1PaymentEntriesEntriesId: _putV1PaymentEntriesEntriesId.bind(url, ...arguments),
    deleteV1PaymentEntriesEntriesId: _deleteV1PaymentEntriesEntriesId.bind(url, ...arguments),
    postV1PaymentEntriesAddApprover: _postV1PaymentEntriesAddApprover.bind(url, ...arguments),
    putV1PaymentEntriesApprovalStatusId: _putV1PaymentEntriesApprovalStatusId.bind(url, ...arguments),
    getV1PaymentEntriesPurchaseInvoicesId: _getV1PaymentEntriesPurchaseInvoicesId.bind(url, ...arguments),
    getV1PaymentEntriesSalesInvoicesId: _getV1PaymentEntriesSalesInvoicesId.bind(url, ...arguments),
    getV1PaymentEntriesCreditNoteId: _getV1PaymentEntriesCreditNoteId.bind(url, ...arguments),
    getV1PaymentEntriesDebitNoteId: _getV1PaymentEntriesDebitNoteId.bind(url, ...arguments),
    getV1PaymentEntriesExpenseReimbursementsId: _getV1PaymentEntriesExpenseReimbursementsId.bind(url, ...arguments),
    putV1PaymentEntriesExpenseReimbursementsApprovalStatusId: _putV1PaymentEntriesExpenseReimbursementsApprovalStatusId.bind(url, ...arguments),
    getV1PaymentEntriesEntriesTypeIdDownload: _getV1PaymentEntriesEntriesTypeIdDownload.bind(url, ...arguments),
    getV1PaymentEntriesGenerateExcel: _getV1PaymentEntriesGenerateExcel.bind(url, ...arguments),
    getV1PaymentEntriesGeneratePdf: _getV1PaymentEntriesGeneratePdf.bind(url, ...arguments),
    getV1PurchaseInvoicesUom: _getV1PurchaseInvoicesUom.bind(url, ...arguments),
    getV1PurchaseInvoicesIncoterms: _getV1PurchaseInvoicesIncoterms.bind(url, ...arguments),
    getV1PurchaseInvoicesItems: _getV1PurchaseInvoicesItems.bind(url, ...arguments),
    getV1PurchaseInvoicesDiscountItemId: _getV1PurchaseInvoicesDiscountItemId.bind(url, ...arguments),
    getV1PurchaseInvoicesWarehouses: _getV1PurchaseInvoicesWarehouses.bind(url, ...arguments),
    getV1PurchaseInvoicesSuppliers: _getV1PurchaseInvoicesSuppliers.bind(url, ...arguments),
    getV1PurchaseInvoicesSuppliersId: _getV1PurchaseInvoicesSuppliersId.bind(url, ...arguments),
    postV1PurchaseInvoices: _postV1PurchaseInvoices.bind(url, ...arguments),
    getV1PurchaseInvoices: _getV1PurchaseInvoices.bind(url, ...arguments),
    postV1PurchaseInvoicesImport: _postV1PurchaseInvoicesImport.bind(url, ...arguments),
    getV1PurchaseInvoicesId: _getV1PurchaseInvoicesId.bind(url, ...arguments),
    putV1PurchaseInvoicesId: _putV1PurchaseInvoicesId.bind(url, ...arguments),
    deleteV1PurchaseInvoicesId: _deleteV1PurchaseInvoicesId.bind(url, ...arguments),
    postV1PurchaseInvoicesItemEntry: _postV1PurchaseInvoicesItemEntry.bind(url, ...arguments),
    getV1PurchaseInvoicesItemEntryId: _getV1PurchaseInvoicesItemEntryId.bind(url, ...arguments),
    putV1PurchaseInvoicesItemEntryId: _putV1PurchaseInvoicesItemEntryId.bind(url, ...arguments),
    deleteV1PurchaseInvoicesItemEntryId: _deleteV1PurchaseInvoicesItemEntryId.bind(url, ...arguments),
    postV1PurchaseInvoicesExpenseEntry: _postV1PurchaseInvoicesExpenseEntry.bind(url, ...arguments),
    getV1PurchaseInvoicesExpenseEntryId: _getV1PurchaseInvoicesExpenseEntryId.bind(url, ...arguments),
    putV1PurchaseInvoicesExpenseEntryId: _putV1PurchaseInvoicesExpenseEntryId.bind(url, ...arguments),
    deleteV1PurchaseInvoicesExpenseEntryId: _deleteV1PurchaseInvoicesExpenseEntryId.bind(url, ...arguments),
    postV1PurchaseInvoicesAddApprover: _postV1PurchaseInvoicesAddApprover.bind(url, ...arguments),
    putV1PurchaseInvoicesApprovalStatusId: _putV1PurchaseInvoicesApprovalStatusId.bind(url, ...arguments),
    postV1PurchaseInvoicesAddRecurringDetails: _postV1PurchaseInvoicesAddRecurringDetails.bind(url, ...arguments),
    getV1PurchaseInvoicesIdDownload: _getV1PurchaseInvoicesIdDownload.bind(url, ...arguments),
    getV1PurchaseInvoicesIdSendEmail: _getV1PurchaseInvoicesIdSendEmail.bind(url, ...arguments),
    getV1PurchaseInvoicesGeneratePdf: _getV1PurchaseInvoicesGeneratePdf.bind(url, ...arguments),
    getV1PurchaseInvoicesGenerateExcel: _getV1PurchaseInvoicesGenerateExcel.bind(url, ...arguments),
    getV1PurchaseInvoicesIdFetchAdvancePayment: _getV1PurchaseInvoicesIdFetchAdvancePayment.bind(url, ...arguments),
    postV1PurchaseInvoicesIdApplyAdvancePayment: _postV1PurchaseInvoicesIdApplyAdvancePayment.bind(url, ...arguments),
    postV1Assets: _postV1Assets.bind(url, ...arguments),
    getV1Assets: _getV1Assets.bind(url, ...arguments),
    postV1AssetsImport: _postV1AssetsImport.bind(url, ...arguments),
    getV1AssetsId: _getV1AssetsId.bind(url, ...arguments),
    putV1AssetsId: _putV1AssetsId.bind(url, ...arguments),
    deleteV1AssetsId: _deleteV1AssetsId.bind(url, ...arguments),
    deleteV1AssetsDepreciationBoardsId: _deleteV1AssetsDepreciationBoardsId.bind(url, ...arguments),
    getV1AssetsFixedAssetAccounts: _getV1AssetsFixedAssetAccounts.bind(url, ...arguments),
    getV1AssetsDepreciationAccounts: _getV1AssetsDepreciationAccounts.bind(url, ...arguments),
    getV1AssetsExpenseAccounts: _getV1AssetsExpenseAccounts.bind(url, ...arguments),
    getV1AssetsJournalTypes: _getV1AssetsJournalTypes.bind(url, ...arguments),
    getV1AssetsAssetTypes: _getV1AssetsAssetTypes.bind(url, ...arguments),
    getV1AssetsDepreciationBoards: _getV1AssetsDepreciationBoards.bind(url, ...arguments),
    postV1AssetsDisposalLogs: _postV1AssetsDisposalLogs.bind(url, ...arguments),
    postV1AssetsReevaluationLogs: _postV1AssetsReevaluationLogs.bind(url, ...arguments),
    postV1AssetsDevaluationLogs: _postV1AssetsDevaluationLogs.bind(url, ...arguments),
    deleteV1AssetsInsuranceEntryId: _deleteV1AssetsInsuranceEntryId.bind(url, ...arguments),
    getV1AssetsGenerateExcel: _getV1AssetsGenerateExcel.bind(url, ...arguments),
    getV1AssetsGeneratePdf: _getV1AssetsGeneratePdf.bind(url, ...arguments),
    postV1AssetsNextSequence: _postV1AssetsNextSequence.bind(url, ...arguments),
    postV1AssetsCheckUniqueness: _postV1AssetsCheckUniqueness.bind(url, ...arguments),
    postV1AssetsTransfer: _postV1AssetsTransfer.bind(url, ...arguments),
    getV1AssetsTransfer: _getV1AssetsTransfer.bind(url, ...arguments),
    getV1AssetsTransferId: _getV1AssetsTransferId.bind(url, ...arguments),
    putV1AssetsTransferId: _putV1AssetsTransferId.bind(url, ...arguments),
    deleteV1AssetsTransferId: _deleteV1AssetsTransferId.bind(url, ...arguments),
    postV1AssetsTransferAddApprover: _postV1AssetsTransferAddApprover.bind(url, ...arguments),
    putV1AssetsTransferApprovalStatusId: _putV1AssetsTransferApprovalStatusId.bind(url, ...arguments),
    getV1AssetsTransferGenerateExcel: _getV1AssetsTransferGenerateExcel.bind(url, ...arguments),
    getV1AssetsTransferGeneratePdf: _getV1AssetsTransferGeneratePdf.bind(url, ...arguments),
    postV1ExpenseReimbursement: _postV1ExpenseReimbursement.bind(url, ...arguments),
    getV1ExpenseReimbursement: _getV1ExpenseReimbursement.bind(url, ...arguments),
    getV1ExpenseReimbursementId: _getV1ExpenseReimbursementId.bind(url, ...arguments),
    deleteV1ExpenseReimbursementId: _deleteV1ExpenseReimbursementId.bind(url, ...arguments),
    putV1ExpenseReimbursementId: _putV1ExpenseReimbursementId.bind(url, ...arguments),
    getV1ExpenseReimbursementExpenseCategories: _getV1ExpenseReimbursementExpenseCategories.bind(url, ...arguments),
    getV1ExpenseReimbursementEmployees: _getV1ExpenseReimbursementEmployees.bind(url, ...arguments),
    postV1ExpenseReimbursementAddApprover: _postV1ExpenseReimbursementAddApprover.bind(url, ...arguments),
    putV1ExpenseReimbursementApprovalStatusId: _putV1ExpenseReimbursementApprovalStatusId.bind(url, ...arguments),
    getV1ExpenseReimbursementIdDownload: _getV1ExpenseReimbursementIdDownload.bind(url, ...arguments),
    getV1ExpenseReimbursementIdDisallowedExpenseDownload: _getV1ExpenseReimbursementIdDisallowedExpenseDownload.bind(url, ...arguments),
    getV1ExpenseReimbursementGenerateExcel: _getV1ExpenseReimbursementGenerateExcel.bind(url, ...arguments),
    getV1ExpenseReimbursementGeneratePdf: _getV1ExpenseReimbursementGeneratePdf.bind(url, ...arguments),
    postV1Budget: _postV1Budget.bind(url, ...arguments),
    getV1Budget: _getV1Budget.bind(url, ...arguments),
    getV1BudgetId: _getV1BudgetId.bind(url, ...arguments),
    putV1BudgetId: _putV1BudgetId.bind(url, ...arguments),
    deleteV1BudgetId: _deleteV1BudgetId.bind(url, ...arguments),
    getV1BudgetBudgetTypes: _getV1BudgetBudgetTypes.bind(url, ...arguments),
    getV1BudgetBudgetMonths: _getV1BudgetBudgetMonths.bind(url, ...arguments),
    postV1BudgetAddApprover: _postV1BudgetAddApprover.bind(url, ...arguments),
    putV1BudgetApprovalStatusId: _putV1BudgetApprovalStatusId.bind(url, ...arguments),
    getV1BudgetBudgetComparisonId: _getV1BudgetBudgetComparisonId.bind(url, ...arguments),
    getV1BudgetGenerateExcel: _getV1BudgetGenerateExcel.bind(url, ...arguments),
    getV1BudgetGeneratePdf: _getV1BudgetGeneratePdf.bind(url, ...arguments),
    getV1FileUpload: _getV1FileUpload.bind(url, ...arguments),
    postV1FileUploadMarkComplete: _postV1FileUploadMarkComplete.bind(url, ...arguments),
    postV1CreditNotes: _postV1CreditNotes.bind(url, ...arguments),
    getV1CreditNotes: _getV1CreditNotes.bind(url, ...arguments),
    postV1CreditNotesImport: _postV1CreditNotesImport.bind(url, ...arguments),
    getV1CreditNotesId: _getV1CreditNotesId.bind(url, ...arguments),
    putV1CreditNotesId: _putV1CreditNotesId.bind(url, ...arguments),
    deleteV1CreditNotesId: _deleteV1CreditNotesId.bind(url, ...arguments),
    postV1CreditNotesItemEntries: _postV1CreditNotesItemEntries.bind(url, ...arguments),
    getV1CreditNotesItemEntriesId: _getV1CreditNotesItemEntriesId.bind(url, ...arguments),
    putV1CreditNotesItemEntriesId: _putV1CreditNotesItemEntriesId.bind(url, ...arguments),
    deleteV1CreditNotesItemEntriesId: _deleteV1CreditNotesItemEntriesId.bind(url, ...arguments),
    postV1CreditNotesExpenseEntries: _postV1CreditNotesExpenseEntries.bind(url, ...arguments),
    getV1CreditNotesExpenseEntriesId: _getV1CreditNotesExpenseEntriesId.bind(url, ...arguments),
    putV1CreditNotesExpenseEntriesId: _putV1CreditNotesExpenseEntriesId.bind(url, ...arguments),
    deleteV1CreditNotesExpenseEntriesId: _deleteV1CreditNotesExpenseEntriesId.bind(url, ...arguments),
    postV1CreditNotesInvoiceDetails: _postV1CreditNotesInvoiceDetails.bind(url, ...arguments),
    postV1CreditNotesAddApprover: _postV1CreditNotesAddApprover.bind(url, ...arguments),
    putV1CreditNotesApprovalStatusId: _putV1CreditNotesApprovalStatusId.bind(url, ...arguments),
    getV1CreditNotesCustomerInvoiceId: _getV1CreditNotesCustomerInvoiceId.bind(url, ...arguments),
    getV1CreditNotesVoidId: _getV1CreditNotesVoidId.bind(url, ...arguments),
    getV1CreditNotesIdDownload: _getV1CreditNotesIdDownload.bind(url, ...arguments),
    getV1CreditNotesGenerateExcel: _getV1CreditNotesGenerateExcel.bind(url, ...arguments),
    getV1CreditNotesGeneratePdf: _getV1CreditNotesGeneratePdf.bind(url, ...arguments),
    postV1DebitNotes: _postV1DebitNotes.bind(url, ...arguments),
    getV1DebitNotes: _getV1DebitNotes.bind(url, ...arguments),
    postV1DebitNotesImport: _postV1DebitNotesImport.bind(url, ...arguments),
    getV1DebitNotesId: _getV1DebitNotesId.bind(url, ...arguments),
    putV1DebitNotesId: _putV1DebitNotesId.bind(url, ...arguments),
    deleteV1DebitNotesId: _deleteV1DebitNotesId.bind(url, ...arguments),
    postV1DebitNotesItemEntries: _postV1DebitNotesItemEntries.bind(url, ...arguments),
    getV1DebitNotesItemEntriesId: _getV1DebitNotesItemEntriesId.bind(url, ...arguments),
    putV1DebitNotesItemEntriesId: _putV1DebitNotesItemEntriesId.bind(url, ...arguments),
    deleteV1DebitNotesItemEntriesId: _deleteV1DebitNotesItemEntriesId.bind(url, ...arguments),
    postV1DebitNotesExpenseEntries: _postV1DebitNotesExpenseEntries.bind(url, ...arguments),
    getV1DebitNotesExpenseEntriesId: _getV1DebitNotesExpenseEntriesId.bind(url, ...arguments),
    putV1DebitNotesExpenseEntriesId: _putV1DebitNotesExpenseEntriesId.bind(url, ...arguments),
    deleteV1DebitNotesExpenseEntriesId: _deleteV1DebitNotesExpenseEntriesId.bind(url, ...arguments),
    postV1DebitNotesInvoiceDetails: _postV1DebitNotesInvoiceDetails.bind(url, ...arguments),
    postV1DebitNotesAddApprover: _postV1DebitNotesAddApprover.bind(url, ...arguments),
    putV1DebitNotesApprovalStatusId: _putV1DebitNotesApprovalStatusId.bind(url, ...arguments),
    getV1DebitNotesVendorInvoiceId: _getV1DebitNotesVendorInvoiceId.bind(url, ...arguments),
    getV1DebitNotesReasons: _getV1DebitNotesReasons.bind(url, ...arguments),
    postV1DebitNotesInvoiceNote: _postV1DebitNotesInvoiceNote.bind(url, ...arguments),
    getV1DebitNotesVoidId: _getV1DebitNotesVoidId.bind(url, ...arguments),
    getV1DebitNotesIdDownload: _getV1DebitNotesIdDownload.bind(url, ...arguments),
    getV1DebitNotesGenerateExcel: _getV1DebitNotesGenerateExcel.bind(url, ...arguments),
    getV1DebitNotesGeneratePdf: _getV1DebitNotesGeneratePdf.bind(url, ...arguments),
    postV1SalesInvoices: _postV1SalesInvoices.bind(url, ...arguments),
    getV1SalesInvoices: _getV1SalesInvoices.bind(url, ...arguments),
    postV1SalesInvoicesImport: _postV1SalesInvoicesImport.bind(url, ...arguments),
    getV1SalesInvoicesId: _getV1SalesInvoicesId.bind(url, ...arguments),
    putV1SalesInvoicesId: _putV1SalesInvoicesId.bind(url, ...arguments),
    deleteV1SalesInvoicesId: _deleteV1SalesInvoicesId.bind(url, ...arguments),
    getV1SalesInvoicesIdDownload: _getV1SalesInvoicesIdDownload.bind(url, ...arguments),
    postV1SalesInvoicesItemEntry: _postV1SalesInvoicesItemEntry.bind(url, ...arguments),
    getV1SalesInvoicesItemEntryId: _getV1SalesInvoicesItemEntryId.bind(url, ...arguments),
    putV1SalesInvoicesItemEntryId: _putV1SalesInvoicesItemEntryId.bind(url, ...arguments),
    deleteV1SalesInvoicesItemEntryId: _deleteV1SalesInvoicesItemEntryId.bind(url, ...arguments),
    postV1SalesInvoicesAddApprover: _postV1SalesInvoicesAddApprover.bind(url, ...arguments),
    putV1SalesInvoicesApprovalStatusId: _putV1SalesInvoicesApprovalStatusId.bind(url, ...arguments),
    getV1SalesInvoicesRequestPayment: _getV1SalesInvoicesRequestPayment.bind(url, ...arguments),
    getV1SalesInvoicesRequestPaymentId: _getV1SalesInvoicesRequestPaymentId.bind(url, ...arguments),
    postV1SalesInvoicesSendPaymentRequest: _postV1SalesInvoicesSendPaymentRequest.bind(url, ...arguments),
    getV1SalesInvoicesIdSendEmail: _getV1SalesInvoicesIdSendEmail.bind(url, ...arguments),
    postV1SalesInvoicesPromotionCheck: _postV1SalesInvoicesPromotionCheck.bind(url, ...arguments),
    postV1SalesInvoicesPromotionApply: _postV1SalesInvoicesPromotionApply.bind(url, ...arguments),
    postV1SalesInvoicesPromotionItemApply: _postV1SalesInvoicesPromotionItemApply.bind(url, ...arguments),
    deleteV1SalesInvoicesPromotionId: _deleteV1SalesInvoicesPromotionId.bind(url, ...arguments),
    getV1SalesInvoicesIdPromotions: _getV1SalesInvoicesIdPromotions.bind(url, ...arguments),
    postV1SalesInvoicesSaveDraft: _postV1SalesInvoicesSaveDraft.bind(url, ...arguments),
    getV1SalesInvoicesGenerateExcel: _getV1SalesInvoicesGenerateExcel.bind(url, ...arguments),
    getV1SalesInvoicesGeneratePdf: _getV1SalesInvoicesGeneratePdf.bind(url, ...arguments),
    getV1SalesInvoicesRequestPaymentGenerateExcel: _getV1SalesInvoicesRequestPaymentGenerateExcel.bind(url, ...arguments),
    getV1SalesInvoicesIdFetchAdvancePayment: _getV1SalesInvoicesIdFetchAdvancePayment.bind(url, ...arguments),
    postV1SalesInvoicesIdApplyAdvancePayment: _postV1SalesInvoicesIdApplyAdvancePayment.bind(url, ...arguments),
    postV1ReportsGeneralLedgerReport: _postV1ReportsGeneralLedgerReport.bind(url, ...arguments),
    postV1ReportsProfitLossStatement: _postV1ReportsProfitLossStatement.bind(url, ...arguments),
    postV1ReportsBalanceSheet: _postV1ReportsBalanceSheet.bind(url, ...arguments),
    postV1ReportsTrialBalance: _postV1ReportsTrialBalance.bind(url, ...arguments),
    postV1ReportsJournalReport: _postV1ReportsJournalReport.bind(url, ...arguments),
    postV1ReportsAgedPayable: _postV1ReportsAgedPayable.bind(url, ...arguments),
    postV1ReportsAgedReceivable: _postV1ReportsAgedReceivable.bind(url, ...arguments),
    postV1ReportsShareholderReport: _postV1ReportsShareholderReport.bind(url, ...arguments),
    postV1ReportsDepreciationScheduler: _postV1ReportsDepreciationScheduler.bind(url, ...arguments),
    postV1ReportsCashflowReport: _postV1ReportsCashflowReport.bind(url, ...arguments),
    postV1ReportsJournalDetails: _postV1ReportsJournalDetails.bind(url, ...arguments),
    getV1ReportsJournalItemsTypeId: _getV1ReportsJournalItemsTypeId.bind(url, ...arguments),
    postV1ReportsReportSummary: _postV1ReportsReportSummary.bind(url, ...arguments),
    postV1ReportsGeneralLedgerReportDownload: _postV1ReportsGeneralLedgerReportDownload.bind(url, ...arguments),
    postV1ReportsVatReport: _postV1ReportsVatReport.bind(url, ...arguments),
    postV1ReportsVatReportNarration: _postV1ReportsVatReportNarration.bind(url, ...arguments),
    postV1ReportsVatReportDetails: _postV1ReportsVatReportDetails.bind(url, ...arguments),
    postV1ReportsVatReportDownload: _postV1ReportsVatReportDownload.bind(url, ...arguments),
    postV1ReportsCustomerSoa: _postV1ReportsCustomerSoa.bind(url, ...arguments),
    postV1ReportsVendorSoa: _postV1ReportsVendorSoa.bind(url, ...arguments),
    postV1ReportsCollectionRegisterReport: _postV1ReportsCollectionRegisterReport.bind(url, ...arguments),
    postV1ReportsExpenseAnalysis: _postV1ReportsExpenseAnalysis.bind(url, ...arguments),
    postV1ReportsTaxSummary: _postV1ReportsTaxSummary.bind(url, ...arguments),
    postV1ReportsFixedAssetsRegister: _postV1ReportsFixedAssetsRegister.bind(url, ...arguments),
    postV1ReportsExport: _postV1ReportsExport.bind(url, ...arguments),
    getV1ReconciliatonList: _getV1ReconciliatonList.bind(url, ...arguments),
    postV1ReconciliatonBankIdTransactions: _postV1ReconciliatonBankIdTransactions.bind(url, ...arguments),
    getV1ReconciliatonBankIdTransactions: _getV1ReconciliatonBankIdTransactions.bind(url, ...arguments),
    getV1ReconciliatonBankIdTransactionsTranIdPayment: _getV1ReconciliatonBankIdTransactionsTranIdPayment.bind(url, ...arguments),
    patchV1ReconciliatonBankIdTransactionsTranIdReconcile: _patchV1ReconciliatonBankIdTransactionsTranIdReconcile.bind(url, ...arguments),
    getV1ReconciliatonGenerateExcel: _getV1ReconciliatonGenerateExcel.bind(url, ...arguments),
    getV1ReconciliatonGeneratePdf: _getV1ReconciliatonGeneratePdf.bind(url, ...arguments),
    getV1CommissionAuthorize: _getV1CommissionAuthorize.bind(url, ...arguments),
    postV1CommissionAuthorizeId: _postV1CommissionAuthorizeId.bind(url, ...arguments),
    postV1CommissionAuthorizeIdTransaction: _postV1CommissionAuthorizeIdTransaction.bind(url, ...arguments),
    getV1CommissionAuthorizeIdTransactionTranId: _getV1CommissionAuthorizeIdTransactionTranId.bind(url, ...arguments),
    getV1Commission: _getV1Commission.bind(url, ...arguments),
    getV1CommissionId: _getV1CommissionId.bind(url, ...arguments),
    postV1CommissionIdAuthorised: _postV1CommissionIdAuthorised.bind(url, ...arguments),
    getV1CommissionAuthorizeGenerateExcel: _getV1CommissionAuthorizeGenerateExcel.bind(url, ...arguments),
    getV1CommissionGenerateExcel: _getV1CommissionGenerateExcel.bind(url, ...arguments),
    getV1CommissionAuthorizeGeneratePdf: _getV1CommissionAuthorizeGeneratePdf.bind(url, ...arguments),
    getV1CommissionGeneratePdf: _getV1CommissionGeneratePdf.bind(url, ...arguments),
    postV1CommissionPlans: _postV1CommissionPlans.bind(url, ...arguments),
    getV1CommissionPlans: _getV1CommissionPlans.bind(url, ...arguments),
    postV1CommissionPlansSaveDraft: _postV1CommissionPlansSaveDraft.bind(url, ...arguments),
    getV1CommissionPlansId: _getV1CommissionPlansId.bind(url, ...arguments),
    putV1CommissionPlansId: _putV1CommissionPlansId.bind(url, ...arguments),
    deleteV1CommissionPlansId: _deleteV1CommissionPlansId.bind(url, ...arguments),
    postV1CommissionPlansIdTier: _postV1CommissionPlansIdTier.bind(url, ...arguments),
    putV1CommissionPlansIdTierTierId: _putV1CommissionPlansIdTierTierId.bind(url, ...arguments),
    getV1CommissionPlansIdTierTierId: _getV1CommissionPlansIdTierTierId.bind(url, ...arguments),
    deleteV1CommissionPlansIdTierTierId: _deleteV1CommissionPlansIdTierTierId.bind(url, ...arguments),
    getV1CommissionPlansGenerateExcel: _getV1CommissionPlansGenerateExcel.bind(url, ...arguments),
    getV1CommissionPlansGeneratePdf: _getV1CommissionPlansGeneratePdf.bind(url, ...arguments),
    postV1CommissionTargets: _postV1CommissionTargets.bind(url, ...arguments),
    getV1CommissionTargets: _getV1CommissionTargets.bind(url, ...arguments),
    postV1CommissionTargetsSaveDraft: _postV1CommissionTargetsSaveDraft.bind(url, ...arguments),
    getV1CommissionTargetsId: _getV1CommissionTargetsId.bind(url, ...arguments),
    putV1CommissionTargetsId: _putV1CommissionTargetsId.bind(url, ...arguments),
    deleteV1CommissionTargetsId: _deleteV1CommissionTargetsId.bind(url, ...arguments),
    getV1CommissionTargetsGenerateExcel: _getV1CommissionTargetsGenerateExcel.bind(url, ...arguments),
    getV1CommissionTargetsGeneratePdf: _getV1CommissionTargetsGeneratePdf.bind(url, ...arguments),
    postV1CommissionAssignment: _postV1CommissionAssignment.bind(url, ...arguments),
    getV1CommissionAssignment: _getV1CommissionAssignment.bind(url, ...arguments),
    postV1CommissionAssignmentSaveDraft: _postV1CommissionAssignmentSaveDraft.bind(url, ...arguments),
    getV1CommissionAssignmentId: _getV1CommissionAssignmentId.bind(url, ...arguments),
    putV1CommissionAssignmentId: _putV1CommissionAssignmentId.bind(url, ...arguments),
    deleteV1CommissionAssignmentId: _deleteV1CommissionAssignmentId.bind(url, ...arguments),
    postV1CommissionAssignmentIdSalesperson: _postV1CommissionAssignmentIdSalesperson.bind(url, ...arguments),
    putV1CommissionAssignmentIdSalespersonSalespersonId: _putV1CommissionAssignmentIdSalespersonSalespersonId.bind(url, ...arguments),
    getV1CommissionAssignmentIdSalespersonSalespersonId: _getV1CommissionAssignmentIdSalespersonSalespersonId.bind(url, ...arguments),
    deleteV1CommissionAssignmentIdSalespersonSalespersonId: _deleteV1CommissionAssignmentIdSalespersonSalespersonId.bind(url, ...arguments),
    getV1CommissionAssignmentGenerateExcel: _getV1CommissionAssignmentGenerateExcel.bind(url, ...arguments),
    getV1CommissionAssignmentGeneratePdf: _getV1CommissionAssignmentGeneratePdf.bind(url, ...arguments),
    getV1CashExpensesUom: _getV1CashExpensesUom.bind(url, ...arguments),
    getV1CashExpensesIncoterms: _getV1CashExpensesIncoterms.bind(url, ...arguments),
    getV1CashExpensesItems: _getV1CashExpensesItems.bind(url, ...arguments),
    getV1CashExpensesDiscountItemId: _getV1CashExpensesDiscountItemId.bind(url, ...arguments),
    getV1CashExpensesWarehouses: _getV1CashExpensesWarehouses.bind(url, ...arguments),
    getV1CashExpensesSuppliers: _getV1CashExpensesSuppliers.bind(url, ...arguments),
    getV1CashExpensesSuppliersId: _getV1CashExpensesSuppliersId.bind(url, ...arguments),
    postV1CashExpenses: _postV1CashExpenses.bind(url, ...arguments),
    getV1CashExpenses: _getV1CashExpenses.bind(url, ...arguments),
    postV1CashExpensesImport: _postV1CashExpensesImport.bind(url, ...arguments),
    getV1CashExpensesId: _getV1CashExpensesId.bind(url, ...arguments),
    putV1CashExpensesId: _putV1CashExpensesId.bind(url, ...arguments),
    deleteV1CashExpensesId: _deleteV1CashExpensesId.bind(url, ...arguments),
    postV1CashExpensesItemEntry: _postV1CashExpensesItemEntry.bind(url, ...arguments),
    getV1CashExpensesItemEntryId: _getV1CashExpensesItemEntryId.bind(url, ...arguments),
    putV1CashExpensesItemEntryId: _putV1CashExpensesItemEntryId.bind(url, ...arguments),
    deleteV1CashExpensesItemEntryId: _deleteV1CashExpensesItemEntryId.bind(url, ...arguments),
    postV1CashExpensesExpenseEntry: _postV1CashExpensesExpenseEntry.bind(url, ...arguments),
    getV1CashExpensesExpenseEntryId: _getV1CashExpensesExpenseEntryId.bind(url, ...arguments),
    putV1CashExpensesExpenseEntryId: _putV1CashExpensesExpenseEntryId.bind(url, ...arguments),
    deleteV1CashExpensesExpenseEntryId: _deleteV1CashExpensesExpenseEntryId.bind(url, ...arguments),
    postV1CashExpensesAddApprover: _postV1CashExpensesAddApprover.bind(url, ...arguments),
    putV1CashExpensesApprovalStatusId: _putV1CashExpensesApprovalStatusId.bind(url, ...arguments),
    postV1CashExpensesAddRecurringDetails: _postV1CashExpensesAddRecurringDetails.bind(url, ...arguments),
    getV1CashExpensesGenerateExcel: _getV1CashExpensesGenerateExcel.bind(url, ...arguments),
    getV1CashExpensesGeneratePdf: _getV1CashExpensesGeneratePdf.bind(url, ...arguments),
    getV1ExcelTemplateGenerateTemplate: _getV1ExcelTemplateGenerateTemplate.bind(url, ...arguments),
    postV1DashboardFinancialSummary: _postV1DashboardFinancialSummary.bind(url, ...arguments),
    postV1DashboardAgeingSummary: _postV1DashboardAgeingSummary.bind(url, ...arguments),
    postV1DashboardVendorSummary: _postV1DashboardVendorSummary.bind(url, ...arguments),
    postV1DashboardCustomerSummary: _postV1DashboardCustomerSummary.bind(url, ...arguments),
    getV1Dashboard: _getV1Dashboard.bind(url, ...arguments),
    postV1DashboardCashflowSummary: _postV1DashboardCashflowSummary.bind(url, ...arguments),
    getV1SettingsEntities: _getV1SettingsEntities.bind(url, ...arguments),
    postV1SettingsEntities: _postV1SettingsEntities.bind(url, ...arguments),
    getV1SettingsEntitiesId: _getV1SettingsEntitiesId.bind(url, ...arguments),
    putV1SettingsEntitiesId: _putV1SettingsEntitiesId.bind(url, ...arguments),
    deleteV1SettingsEntitiesId: _deleteV1SettingsEntitiesId.bind(url, ...arguments),
    getV1SettingsConfigurations: _getV1SettingsConfigurations.bind(url, ...arguments),
    getV1PdcType: _getV1PdcType.bind(url, ...arguments),
    postV1PdcSettleType: _postV1PdcSettleType.bind(url, ...arguments)
  }
}